import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Plus, Edit, Trash, Search, Filter, X, Package, Info, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, RefreshCw, Calendar, TrendingUp, TrendingDown, DollarSign, Weight, FileText, ChevronDown, Save, Minus, AlertCircle, Eye, Printer, Upload, Download, FileSpreadsheet, CheckCircle, XCircle, Users, Copy } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import authUtils from '../utils/authUtils';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const XuatNhapKhoManagement = () => {
  // State Management
  const [phieuList, setPhieuList] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [khoList, setKhoList] = useState([]);
  const [dmhh, setDmhh] = useState([]);
  const [tonKho, setTonKho] = useState([]);
  const [tieuChuanList, setTieuChuanList] = useState([]);
  const [doiHangKhoList, setDoiHangKhoList] = useState([]);
  const [giaBanList, setGiaBanList] = useState([]); // ✅ THÊM STATE CHO BẢNG GIÁ BÁN
  const [currentUser, setCurrentUser] = useState(null);


  const [currentPhieu, setCurrentPhieu] = useState({
    'SOPHIEU': '',
    'NGHIEP_VU': 'NHAP',
    'NGAYNHAP_XUAT': new Date().toISOString().split('T')[0],
    'NCC_KHACHHANG': '',
    'KHOXUAT': '',
    'KHONHAP': '',
    'NGUOIPHUTRACH': '',
    'TONGKHOILUONG': 0,
    'THANHTIEN': 0,
    'PT VAT': 0,
    'TIEN VAT': 0,
    'TONGTIEN': 0,
    'DIENGIAI': ''
  });

  const [chiTietList, setChiTietList] = useState([]);
  const [currentChiTiet, setCurrentChiTiet] = useState({
    'NHOM_HANG': '',
    'SO_KIEN': '',
    'DONGIA': 0,
    'TIEU_CHUAN': '',
    'DOI_HANG_KHO': ''
  });

  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showTieuChuanModal, setShowTieuChuanModal] = useState(false);
  const [showDoiHangKhoModal, setShowDoiHangKhoModal] = useState(false);
  const [newTieuChuan, setNewTieuChuan] = useState('');
  const [newDoiHangKho, setNewDoiHangKho] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [search, setSearch] = useState('');
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [phieuToDelete, setPhieuToDelete] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'NGAYNHAP_XUAT', direction: 'descending' });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [originalSoPhieu, setOriginalSoPhieu] = useState('');
  const [isSyncingTotals, setIsSyncingTotals] = useState(false);

  // Import/Export states
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importPreview, setImportPreview] = useState([]);
  const [importNghiepVu, setImportNghiepVu] = useState('NHAP');
  const [isImporting, setIsImporting] = useState(false);

  const [showPrintOptions, setShowPrintOptions] = useState(false);
  const [phieuToPrint, setPhieuToPrint] = useState(null);
  const [printWithPrice, setPrintWithPrice] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState('HOANG_NGUYEN_LONG'); // Mặc định là CÔNG TY CP TM SX XD HOÀNG NGUYÊN LONG
  const [headerInfo, setHeaderInfo] = useState('Điện thoại: 0919.509.009 - 0985.96.97.98 ( A. Lưỡng )'); // Thông tin header có thể chỉnh sửa

  const fileInputRef = useRef(null);

  // Autocomplete states
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showNhomHangDropdown, setShowNhomHangDropdown] = useState(false);
  const [nhomHangSearchTerm, setNhomHangSearchTerm] = useState('');
  const [selectedNhomHangInfo, setSelectedNhomHangInfo] = useState(null);
  const [availableKien, setAvailableKien] = useState([]);

  const [selectedDay, setSelectedDay] = useState('');
  const [availableDay, setAvailableDay] = useState([]);

  // ✅ THÊM STATE CHO TIÊU CHUẨN XUẤT KHO
  const [selectedTieuChuanXuat, setSelectedTieuChuanXuat] = useState('');

  const [kienSearchTerm, setKienSearchTerm] = useState('');

  const customerDropdownRef = useRef(null);
  const nhomHangDropdownRef = useRef(null);

  // Thêm state cho yêu cầu duyệt
  const [showApprovalConfirm, setShowApprovalConfirm] = useState(false);
  const [pendingChanges, setPendingChanges] = useState(null);
  const [lyDoYeuCau, setLyDoYeuCau] = useState('');
  const [originalChiTietList, setOriginalChiTietList] = useState([]); // Lưu chi tiết gốc khi edit

  const [showRequestHistoryModal, setShowRequestHistoryModal] = useState(false);
  const [requestHistory, setRequestHistory] = useState([]);
  const [filterRequestStatus, setFilterRequestStatus] = useState('ALL');
  const [filterRequestType, setFilterRequestType] = useState('ALL');
  const [searchRequest, setSearchRequest] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showRequestDetailModal, setShowRequestDetailModal] = useState(false);

  // Filter states
  const [filterNghiepVu, setFilterNghiepVu] = useState('ALL');
  const [filterCustomer, setFilterCustomer] = useState('ALL');
  // Bộ lọc mặc định: từ đầu tháng đến ngày hiện tại
  const [filterDateFrom, setFilterDateFrom] = useState(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}-01`;
  });
  const [filterDateTo, setFilterDateTo] = useState(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // ✅ STATE MỚI: Lưu lỗi mã kiện cho từng dòng
  const [maKienErrors, setMaKienErrors] = useState({});

  // ==================== FETCH FUNCTIONS ====================

  // ✅ THÊM HÀM FETCH BẢNG GIÁ BÁN
  const fetchGiaBan = async () => {
    try {
      const response = await authUtils.apiRequestKHO('CD_GIABAN', 'Find', {});
      setGiaBanList(response);
    } catch (error) {
      console.error('Error fetching gia ban:', error);
      toast.error('Lỗi khi tải bảng giá bán');
    }
  };

  // ✅ HÀM LẤY ĐỠN GIÁ THEO ĐỘ DÀY VÀ TIÊU CHUẨN
  const getDonGiaByDayAndTieuChuan = (day, tieuChuan) => {
    if (!day || !tieuChuan) return 0;

    const today = new Date();

    // Tìm giá bán hiệu lực
    const giaBan = giaBanList.find(item => {
      const hieuLucTu = item['HIEULUC_TU'] ? new Date(item['HIEULUC_TU']) : null;
      const hieuLucDen = item['HIEULUC_DEN'] ? new Date(item['HIEULUC_DEN']) : null;

      const matchDay = parseFloat(item['DAY']) === parseFloat(day);
      const matchTieuChuan = item['TIEU_CHUAN'] === tieuChuan;

      let isValid = true;
      if (hieuLucTu && today < hieuLucTu) isValid = false;
      if (hieuLucDen && today > hieuLucDen) isValid = false;

      return matchDay && matchTieuChuan && isValid;
    });

    return giaBan ? parseFloat(giaBan['GIABAN_DEXUAT'] || 0) : 0;
  };

  const fetchDoiHangKho = async () => {
    try {
      const response = await authUtils.apiRequestKHO('CD_DOIHANGKHO', 'Find', {});
      setDoiHangKhoList(response);
    } catch (error) {
      console.error('Error fetching doi hang kho:', error);
      toast.error('Lỗi khi tải danh sách đội hàng khô');
    }
  };

  const handleAddDoiHangKho = async () => {
    if (!newDoiHangKho.trim()) {
      toast.error('Vui lòng nhập tên đội hàng khô');
      return;
    }

    const exists = doiHangKhoList.find(dhk =>
      dhk['DOI_HANG_KHO'].toLowerCase() === newDoiHangKho.trim().toLowerCase()
    );

    if (exists) {
      toast.error('Đội hàng khô này đã tồn tại');
      return;
    }

    try {
      const newDHK = {
        'ID_DHK': Date.now(),
        'DOI_HANG_KHO': newDoiHangKho.trim().toUpperCase()
      };

      await authUtils.apiRequestKHO('CD_DOIHANGKHO', 'Add', {
        "Rows": [newDHK]
      });

      toast.success('Thêm đội hàng khô mới thành công!');
      await fetchDoiHangKho();
      setNewDoiHangKho('');
      setShowDoiHangKhoModal(false);
    } catch (error) {
      console.error('Error adding doi hang kho:', error);
      toast.error('Có lỗi xảy ra khi thêm đội hàng khô');
    }
  };

  const handleDeleteDoiHangKho = async (idDHK) => {
    if (!window.confirm('Bạn có chắc chắn muốn xóa đội hàng khô này?')) {
      return;
    }

    try {
      await authUtils.apiRequestKHO('CD_DOIHANGKHO', 'Delete', {
        "Rows": [{ "ID_DHK": idDHK }]
      });

      toast.success('Xóa đội hàng khô thành công!');
      await fetchDoiHangKho();
    } catch (error) {
      console.error('Error deleting doi hang kho:', error);
      toast.error('Có lỗi xảy ra khi xóa đội hàng khô');
    }
  };

  // ✅ HÀM KIỂM TRA MÃ KIỆN TRÙNG
  const checkMaKienDuplicate = (maKien, currentIndex = -1) => {
    if (!maKien || maKien.trim() === '') {
      return { isDuplicate: false, message: '' };
    }

    const trimmedMaKien = maKien.trim();

    // Kiểm tra trùng trong form (bỏ qua dòng hiện tại)
    const isDuplicateInForm = chiTietList.some((item, index) =>
      index !== currentIndex && item['MA_KIEN'] === trimmedMaKien
    );

    if (isDuplicateInForm) {
      return { isDuplicate: true, message: 'Mã kiện đã tồn tại trong danh sách!' };
    }

    // Kiểm tra trùng trong database
    const isDuplicateInDB = tonKho.some(item => item['MA_KIEN'] === trimmedMaKien);

    if (isDuplicateInDB) {
      return { isDuplicate: true, message: 'Mã kiện đã tồn tại trong kho!' };
    }

    return { isDuplicate: false, message: '' };
  };

  // ✅ HÀM CẬP NHẬT MÃ KIỆN TRONG BẢNG CHI TIẾT
  const handleUpdateMaKien = (index, newMaKien) => {
    const checkResult = checkMaKienDuplicate(newMaKien, index);

    // Cập nhật errors
    setMaKienErrors(prev => ({
      ...prev,
      [index]: checkResult.isDuplicate ? checkResult.message : ''
    }));

    // Cập nhật mã kiện
    const newChiTietList = [...chiTietList];
    newChiTietList[index]['MA_KIEN'] = newMaKien;
    setChiTietList(newChiTietList);
  };

  // ==================== EXCEL FUNCTIONS ====================

  const convertDateDDMMYYYYtoYYYYMMDD = (dateStr) => {
    if (!dateStr) return new Date().toISOString().split('T')[0];

    const dateString = dateStr.toString().trim();

    if (dateString.includes('-') && dateString.split('-')[0].length === 4) {
      return dateString;
    }

    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }

    return new Date().toISOString().split('T')[0];
  };

  const convertDateYYYYMMDDtoDDMMYYYY = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const calculateM3 = (day, rong, dai, soThanh) => {
    const dayNum = parseFloat(day) || 0;
    const rongNum = parseFloat(rong) || 0;
    const daiNum = parseFloat(dai) || 0;
    const soThanhNum = parseFloat(soThanh) || 0;

    return (dayNum * rongNum * daiNum * soThanhNum) / 1000000000;
  };

  const handleExportTemplate = () => {
    // ✅ Ngày mẫu: 30/01/2025
    const templateDate = new Date(2025, 0, 30); // Tháng 0 = tháng 1

    // ✅ NHẬP KHO: KHÔNG CÓ CỘT SỐ PHIẾU (tự động tạo)
    const templateNhapData = [
      {
        'Ngày': templateDate,
        'NCC/Khách hàng': 'XƯỞNG CƯA HOÀNG NGUYÊN LONG',
        'Kho': 'Kho Phú Giáo',
        'Người phụ trách': 'Nguyễn Văn A',
        'Mã kiện': 'K-250130-00001',
        'Dày (mm)': 25,
        'Rộng (mm)': 100,
        'Dài (mm)': 2400,
        'Số thanh': 50,
        'Tiêu chuẩn': 'AB',
        'Đội hàng khô': 'Đội 1',
        'Diễn giải': 'Ghi chú'
      },
      {
        'Ngày': templateDate,
        'NCC/Khách hàng': 'XƯỞNG CƯA HOÀNG NGUYÊN LONG',
        'Kho': 'Kho Phú Giáo',
        'Người phụ trách': 'Nguyễn Văn A',
        'Mã kiện': 'K-250130-00002',
        'Dày (mm)': 30,
        'Rộng (mm)': 120,
        'Dài (mm)': 3000,
        'Số thanh': 40,
        'Tiêu chuẩn': 'AB',
        'Đội hàng khô': 'Đội 2',
        'Diễn giải': ''
      }
    ];

    const templateXuatData = [
      {
        'Số phiếu': '',
        'Ngày': templateDate,
        'NCC/Khách hàng': 'Công ty XYZ',
        'Kho xuất': 'Kho Phú Giáo',
        'Người phụ trách': 'Nguyễn Văn B',
        'Mã kiện': 'K-250130-00001',
        'Đơn giá': 5000000,
        'Diễn giải': 'Xuất hàng cho khách'
      },
      {
        'Số phiếu': '',
        'Ngày': templateDate,
        'NCC/Khách hàng': 'Công ty XYZ',
        'Kho xuất': 'Kho Phú Giáo',
        'Người phụ trách': 'Nguyễn Văn B',
        'Mã kiện': 'K-250130-00002',
        'Đơn giá': 6000000,
        'Diễn giải': ''
      }
    ];

    const wb = XLSX.utils.book_new();

    // ✅ Tạo worksheet cho Nhập Kho
    const wsNhap = XLSX.utils.json_to_sheet(templateNhapData, { cellDates: true });

    // ✅ Định dạng cột ngày cho sheet Nhập Kho (KHÔNG CÓ CỘT SỐ PHIẾU)
    wsNhap['!cols'] = [
      { wch: 12 }, // Ngày
      { wch: 30 }, // NCC/Khách hàng
      { wch: 15 }, // Kho
      { wch: 20 }, // Người phụ trách
      { wch: 20 }, // Mã kiện
      { wch: 12 }, // Dày
      { wch: 12 }, // Rộng
      { wch: 12 }, // Dài
      { wch: 12 }, // Số thanh
      { wch: 15 }, // Tiêu chuẩn
      { wch: 15 }, // Đội hàng khô
      { wch: 30 }  // Diễn giải
    ];

    // ✅ Format các ô ngày trong sheet Nhập Kho
    const rangeNhap = XLSX.utils.decode_range(wsNhap['!ref']);
    for (let R = rangeNhap.s.r + 1; R <= rangeNhap.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: 0 }); // Cột A (Ngày)
      if (wsNhap[cellAddress]) {
        wsNhap[cellAddress].z = 'dd/mm/yyyy'; // ✅ Format dd/mm/yyyy
      }
    }

    XLSX.utils.book_append_sheet(wb, wsNhap, 'Mẫu Nhập Kho');

    // ✅ Tạo worksheet cho Xuất Kho
    const wsXuat = XLSX.utils.json_to_sheet(templateXuatData, { cellDates: true });

    wsXuat['!cols'] = [
      { wch: 20 }, // Số phiếu
      { wch: 12 }, // Ngày
      { wch: 25 }, // NCC/Khách hàng
      { wch: 15 }, // Kho xuất
      { wch: 20 }, // Người phụ trách
      { wch: 20 }, // Mã kiện
      { wch: 15 }, // Đơn giá
      { wch: 30 }  // Diễn giải
    ];

    // ✅ Format các ô ngày trong sheet Xuất Kho
    const rangeXuat = XLSX.utils.decode_range(wsXuat['!ref']);
    for (let R = rangeXuat.s.r + 1; R <= rangeXuat.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: 1 }); // Cột B (Ngày)
      if (wsXuat[cellAddress]) {
        wsXuat[cellAddress].z = 'dd/mm/yyyy'; // ✅ Format dd/mm/yyyy
      }
    }

    XLSX.utils.book_append_sheet(wb, wsXuat, 'Mẫu Xuất Kho');

    // ✅ Export file với cellDates: true
    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
      cellDates: true // ✅ Quan trọng!
    });

    // ✅ TẠO TÊN FILE THEO ĐỊNH DẠNG: "Mẫu nhập xuất kho ngày DD-MM-YYYY.xlsx"
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    const fileName = `Mẫu nhập xuất kho ngày ${day}-${month}-${year}.xlsx`;

    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, fileName);

    toast.success('Đã tải xuống file mẫu Excel với định dạng ngày chuẩn');
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
      toast.error('Vui lòng chọn file Excel (.xlsx hoặc .xls)');
      return;
    }

    setImportFile(file);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;

        // ✅ THÊM OPTION cellDates: true ĐỂ NHẬN DẠNG NGÀY
        const wb = XLSX.read(bstr, {
          type: 'binary',
          cellDates: true,      // ✅ Tự động chuyển serial number thành Date
          cellNF: false,        // ✅ Không giữ định dạng số
          cellText: false       // ✅ Không chuyển thành text
        });

        let sheetName;
        if (importNghiepVu === 'NHAP') {
          sheetName = 'Mẫu Nhập Kho';
        } else if (importNghiepVu === 'XUAT') {
          sheetName = 'Mẫu Xuất Kho';
        } else {
          sheetName = wb.SheetNames[0];
        }

        if (!wb.Sheets[sheetName]) {
          toast.error(`Không tìm thấy sheet "${sheetName}" trong file Excel!`);
          console.error('Các sheet có sẵn:', wb.SheetNames);
          return;
        }

        console.log(`✅ Đang đọc sheet: "${sheetName}"`);

        const ws = wb.Sheets[sheetName];

        // ✅ THÊM OPTION raw: false ĐỂ CHUYỂN ĐỔI NGÀY
        const data = XLSX.utils.sheet_to_json(ws, {
          raw: false,           // ✅ Chuyển đổi ngày thành chuỗi
          dateNF: 'dd/mm/yyyy'  // ✅ Định dạng ngày mong muốn
        });

        if (data.length === 0) {
          toast.error('File Excel không có dữ liệu');
          return;
        }

        console.log(`📊 Đọc được ${data.length} dòng từ sheet "${sheetName}"`);

        // ✅ LOG 5 DÒNG ĐẦU TIÊN
        console.log('🔍 5 dòng đầu tiên:');
        data.slice(0, 5).forEach((row, idx) => {
          console.log(`Dòng ${idx + 1}:`, {
            'Ngày RAW': row['Ngày'],
            'Ngày TYPE': typeof row['Ngày'],
            'NCC/KH': row['NCC/Khách hàng'],
            'Kho': row['Kho'] || row['Kho xuất'],
            'Mã kiện': row['Mã kiện']
          });
        });

        // ✅ HÀM CHUYỂN ĐỔI NGÀY AN TOÀN
        const parseExcelDate = (dateValue) => {
          if (!dateValue) return new Date().toISOString().split('T')[0];

          // Nếu đã là Date object
          if (dateValue instanceof Date) {
            return dateValue.toISOString().split('T')[0];
          }

          // Nếu là chuỗi dd/mm/yyyy
          if (typeof dateValue === 'string' && dateValue.includes('/')) {
            const parts = dateValue.split('/');
            if (parts.length === 3) {
              const day = parts[0].padStart(2, '0');
              const month = parts[1].padStart(2, '0');
              const year = parts[2];
              return `${year}-${month}-${day}`;
            }
          }

          // Nếu là serial number (45687)
          if (typeof dateValue === 'number') {
            const excelEpoch = new Date(1900, 0, 1);
            const days = dateValue - 2; // Excel bug: tính từ 1/1/1900 nhưng có lỗi 2 ngày
            const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000);
            return date.toISOString().split('T')[0];
          }

          // Nếu là chuỗi yyyy-mm-dd
          if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return dateValue;
          }

          return new Date().toISOString().split('T')[0];
        };

        const processedData = data.map((row, index) => {
          // ✅ CHUYỂN ĐỔI NGÀY AN TOÀN
          const ngayYYYYMMDD = parseExcelDate(row['Ngày']);
          const ngayDDMMYYYY = convertDateYYYYMMDDtoDDMMYYYY(ngayYYYYMMDD);

          console.log(`📅 Dòng ${index + 2}: "${row['Ngày']}" → ${ngayYYYYMMDD} (${ngayDDMMYYYY})`);

          // ✅ CHUẨN HÓA TÊN KHÁCH HÀNG
          let nccKhachHang = (row['NCC/Khách hàng'] || '').toString().trim();
          nccKhachHang = nccKhachHang.replace(/\s+/g, ' ');

          // ✅ ĐỌC SỐ PHIẾU TỪ EXCEL (CHỈ CHO XUẤT KHO)
          // NHẬP KHO luôn tự động tạo số phiếu, không cần đọc từ Excel
          let soPhieuFromExcel = '';
          if (importNghiepVu === 'XUAT') {
            soPhieuFromExcel = (row['Số phiếu'] || '').toString().trim();
          }

          // ✅ TỰ ĐỘNG TẠO NHÓM HÀNG TỪ KÍCH THƯỚC
          const day = parseFloat(row['Dày (mm)']) || 0;
          const rong = parseFloat(row['Rộng (mm)']) || 0;
          const dai = parseFloat(row['Dài (mm)']) || 0;
          const nhomHang = day && rong && dai ? `${day}*${rong}*${dai}` : '';

          let processedRow = {
            rowIndex: index + 2,
            soPhieu: soPhieuFromExcel, // ✅ Thêm số phiếu từ Excel
            ngay: ngayDDMMYYYY,
            ngayYYYYMMDD: ngayYYYYMMDD,
            nccKhachHang: nccKhachHang,
            kho: (row['Kho'] || row['Kho xuất'] || '').toString().trim(),
            nguoiPhuTrach: (row['Người phụ trách'] || '').toString().trim(),
            dienGiai: (row['Diễn giải'] || '').toString().trim(),
            maKien: (row['Mã kiện'] || '').toString().trim(),
            nhomHang: nhomHang,
            day: day,
            rong: rong,
            dai: dai,
            errors: []
          };

          // ✅ VALIDATE NCC/KHÁCH HÀNG (PHẢI CÓ TRONG DATA)
          if (!nccKhachHang) {
            processedRow.errors.push('Thiếu NCC/Khách hàng');
          } else {
            const customerMatch = customers.find(c =>
              c['TEN_KHACHHANG']?.trim().toLowerCase() === nccKhachHang.toLowerCase()
            );

            if (!customerMatch) {
              processedRow.errors.push(`NCC/Khách hàng "${nccKhachHang}" không tồn tại trong hệ thống`);
            } else {
              // Chuẩn hóa tên theo database
              processedRow.nccKhachHang = customerMatch['TEN_KHACHHANG'];

              // Nếu là Xuất Kho thì phải là KH (theo yêu cầu lọc)
              /* 
                 Tạm thời chỉ bắt buộc tồn tại trong hệ thống. 
                 Nếu cần bắt buộc loại KH cho phiếu xuất thì uncomment dòng dưới:
                 if (importNghiepVu === 'XUAT' && customerMatch['PHAN_LOAI'] !== 'KH') {
                   processedRow.errors.push(`"${nccKhachHang}" không phải là Khách hàng (loại KH)`);
                 }
              */
            }
          }

          if (importNghiepVu === 'XUAT') {
            const maKien = row['Mã kiện'];

            if (!maKien || String(maKien).trim() === '') {
              processedRow.errors.push('Thiếu mã kiện');
              return processedRow;
            }

            const maKienClean = String(maKien).trim();

            const isDuplicateInImport = data.slice(0, index).some(prevRow =>
              String(prevRow['Mã kiện'] || '').trim() === maKienClean
            );

            if (isDuplicateInImport) {
              processedRow.errors.push(`Mã kiện ${maKienClean} bị trùng trong file Excel`);
            }

            const kienInfo = tonKho.find(k =>
              k['MA_KIEN'] === maKienClean &&
              k['NGHIEP_VU'] === 'NHAP'
            );

            if (!kienInfo) {
              processedRow.errors.push(`Không tìm thấy kiện ${maKienClean} trong kho`);
              return processedRow;
            }

            const daXuat = tonKho.find(k =>
              k['MA_KIEN'] === maKienClean &&
              k['NGHIEP_VU'] === 'XUAT'
            );

            if (daXuat) {
              processedRow.errors.push(`Kiện ${maKienClean} đã được xuất`);
              return processedRow;
            }

            const donGia = parseFloat(row['Đơn giá']) || 0;
            const soKhoi = parseFloat(kienInfo['SO_KHOI']) || 0;
            const thanhTien = soKhoi * donGia;

            processedRow = {
              ...processedRow,
              maKien: maKienClean,
              nhomHang: kienInfo['NHOM_HANG'],
              day: kienInfo['DAY'],
              rong: kienInfo['RONG'],
              dai: kienInfo['DAI'],
              soThanh: kienInfo['THANH'],
              soKhoi: soKhoi,
              tieuChuan: kienInfo['TIEU_CHUAN'],
              doiHangKho: kienInfo['DOI_HANG_KHO'],
              donGia: donGia,
              thanhTien: thanhTien
            };

          } else {
            // ✅ NHẬP KHO
            const maKien = row['Mã kiện'];
            if (!maKien || String(maKien).trim() === '') {
              processedRow.errors.push('Thiếu mã kiện');
            } else {
              const maKienClean = String(maKien).trim();

              const isDuplicateInImport = data.slice(0, index).some(prevRow =>
                String(prevRow['Mã kiện'] || '').trim() === maKienClean
              );

              if (isDuplicateInImport) {
                processedRow.errors.push(`Mã kiện ${maKienClean} bị trùng trong file Excel`);
              }

              const isDuplicateInDB = tonKho.some(k => k['MA_KIEN'] === maKienClean);
              if (isDuplicateInDB) {
                processedRow.errors.push(`Mã kiện ${maKienClean} đã tồn tại trong kho`);
              }
            }

            const soThanh = parseFloat(row['Số thanh']) || 0;
            const soKhoi = calculateM3(day, rong, dai, soThanh);

            processedRow = {
              ...processedRow,
              soThanh: soThanh,
              soKhoi: soKhoi,
              donGia: 0,
              thanhTien: 0,
              tieuChuan: row['Tiêu chuẩn'] || '',
              doiHangKho: row['Đội hàng khô'] || ''
            };

            if (!nhomHang) {
              processedRow.errors.push('Thiếu kích thước (Dày/Rộng/Dài)');
            }
            if (day <= 0 || rong <= 0 || dai <= 0) {
              processedRow.errors.push('Kích thước không hợp lệ');
            }
            if (soThanh <= 0) {
              processedRow.errors.push('Số thanh phải lớn hơn 0');
            }
            if (!processedRow.tieuChuan) {
              processedRow.errors.push('Thiếu tiêu chuẩn');
            }
          }

          if (!processedRow.ngayYYYYMMDD) {
            processedRow.errors.push('Thiếu ngày');
          }
          if (!processedRow.kho) {
            processedRow.errors.push('Thiếu kho');
          }

          // ✅ VALIDATE SỐ PHIẾU (CHỈ CHO XUẤT KHO)
          if (importNghiepVu === 'XUAT' && processedRow.soPhieu && processedRow.soPhieu !== '') {
            // ✅ CHỈ KIỂM TRA TRÙNG TRONG DATABASE
            // ✅ KHÔNG KIỂM TRA TRÙNG TRONG FILE EXCEL (vì nhiều dòng có thể cùng 1 số phiếu)
            const isDuplicateInDB = phieuList.some(p => p['SOPHIEU'] === processedRow.soPhieu);
            if (isDuplicateInDB) {
              processedRow.errors.push(`Số phiếu ${processedRow.soPhieu} đã tồn tại trong hệ thống`);
            }
          }

          return processedRow;
        });

        setImportPreview(processedData);

        const validCount = processedData.filter(r => r.errors.length === 0).length;
        const errorCount = processedData.filter(r => r.errors.length > 0).length;

        if (validCount > 0) {
          toast.success(`Đã đọc ${processedData.length} dòng từ sheet "${sheetName}": ${validCount} hợp lệ, ${errorCount} lỗi`);
        } else {
          toast.error('Không có dòng dữ liệu hợp lệ');
        }
      } catch (error) {
        console.error('❌ Error reading Excel file:', error);
        toast.error('Có lỗi khi đọc file Excel: ' + error.message);
      }
    };
    reader.readAsBinaryString(file);
  };


  const handleImportData = async () => {
    if (importPreview.length === 0) {
      toast.error('Không có dữ liệu để import');
      return;
    }

    const validRows = importPreview.filter(row => row.errors.length === 0);
    if (validRows.length === 0) {
      toast.error('Không có dòng dữ liệu hợp lệ để import');
      return;
    }

    // ✅ Không cho phép import nếu có bất kỳ dòng lỗi nào (đã disable nút ở UI)
    const hasErrors = importPreview.some(row => row.errors.length > 0);
    if (hasErrors) {
      toast.error('Vui lòng sửa tất cả các lỗi trước khi import');
      return;
    }

    try {
      setIsImporting(true);

      const groupedData = {};

      validRows.forEach(row => {
        // ✅ LOGIC GROUPING:
        // - NHẬP KHO: Luôn group theo (ngày + NCC + kho + người phụ trách)
        // - XUẤT KHO: Nếu có số phiếu thì group theo số phiếu, nếu không thì group theo (ngày + NCC + kho + người phụ trách)
        let key;
        if (importNghiepVu === 'XUAT' && row.soPhieu && row.soPhieu !== '') {
          // XUẤT KHO với số phiếu custom
          key = `PHIEU_${row.soPhieu}`;
        } else {
          // NHẬP KHO hoặc XUẤT KHO không có số phiếu → tự động group
          key = `AUTO_${row.ngayYYYYMMDD}_${row.nccKhachHang}_${row.kho}_${row.nguoiPhuTrach}`;
        }

        if (!groupedData[key]) {
          groupedData[key] = {
            soPhieuFromExcel: (importNghiepVu === 'XUAT' && row.soPhieu && row.soPhieu !== '') ? row.soPhieu : null, // ✅ Lưu số phiếu từ Excel (chỉ cho xuất kho)
            ngay: row.ngayYYYYMMDD,  // ✅ Đã đúng định dạng YYYY-MM-DD
            kho: row.kho,
            nccKhachHang: row.nccKhachHang,
            nguoiPhuTrach: row.nguoiPhuTrach,
            dienGiai: row.dienGiai,
            chiTiet: []
          };
        }

        groupedData[key].chiTiet.push(row);
      });

      let successCount = 0;
      let errorCount = 0;

      console.log(`📊 Tổng số phiếu sẽ tạo: ${Object.keys(groupedData).length}`);

      // ✅ TẠO DANH SÁCH SỐ PHIẾU TRƯỚC KHI BẮT ĐẦU IMPORT
      const phieuListWithNumbers = [];
      let currentMaxNumber = 0;

      // Tìm số phiếu lớn nhất hiện có
      const prefix = importNghiepVu === 'NHAP' ? 'NK' : 'XK';
      const existingPhieu = phieuList.filter(p => p['SOPHIEU'] && p['SOPHIEU'].startsWith(`${prefix}-`));

      existingPhieu.forEach(p => {
        const match = p['SOPHIEU'].match(/-(\d+)$/);
        if (match) {
          const num = parseInt(match[1]);
          if (num > currentMaxNumber) currentMaxNumber = num;
        }
      });

      // Tạo số phiếu cho từng nhóm
      Object.keys(groupedData).forEach((key, index) => {
        const group = groupedData[key];
        let soPhieu;

        // ✅ NẾU CÓ SỐ PHIẾU TỪ EXCEL, DÙNG SỐ PHIẾU ĐÓ
        if (group.soPhieuFromExcel) {
          soPhieu = group.soPhieuFromExcel;
          console.log(`📝 Phiếu ${index + 1}: ${soPhieu} (từ Excel) - ${group.nccKhachHang} - ${group.chiTiet.length} kiện`);
        } else {
          // ✅ NẾU KHÔNG CÓ, TỰ ĐỘNG TẠO SỐ PHIẾU
          const date = new Date(group.ngay);
          const yy = date.getFullYear().toString().slice(-2);
          const mm = (date.getMonth() + 1).toString().padStart(2, '0');
          const dd = date.getDate().toString().padStart(2, '0');
          const yearMonthDay = `${yy}${mm}${dd}`;

          // ✅ TĂNG SỐ THỨ TỰ CHO MỖI PHIẾU
          currentMaxNumber++;
          const nextNumber = currentMaxNumber.toString().padStart(4, '0');
          soPhieu = `${prefix}-${yearMonthDay}-${nextNumber}`;

          console.log(`📝 Phiếu ${index + 1}: ${soPhieu} (tự động) - ${group.nccKhachHang} - ${group.chiTiet.length} kiện`);
        }

        phieuListWithNumbers.push({
          key: key,
          soPhieu: soPhieu,
          group: group
        });
      });

      // ✅ IMPORT TỪNG PHIẾU VỚI SỐ PHIẾU ĐÃ TẠO
      for (const phieuData of phieuListWithNumbers) {
        const { soPhieu, group } = phieuData;

        try {
          const tongKhoiLuong = group.chiTiet.reduce((sum, item) => sum + item.soKhoi, 0);
          const tongTien = group.chiTiet.reduce((sum, item) => sum + item.thanhTien, 0);

          const phieu = {
            'SOPHIEU': soPhieu,
            'NGHIEP_VU': importNghiepVu,
            'NGAYNHAP_XUAT': group.ngay,
            'NCC_KHACHHANG': group.nccKhachHang,
            'KHOXUAT': importNghiepVu === 'XUAT' ? group.kho : '',
            'KHONHAP': importNghiepVu === 'NHAP' ? group.kho : '',
            'NGUOIPHUTRACH': group.nguoiPhuTrach,
            'TONGKHOILUONG': tongKhoiLuong,
            'THANHTIEN': tongTien,
            'PT VAT': 0,
            'TIEN VAT': 0,
            'TONGTIEN': tongTien,
            'DIENGIAI': group.dienGiai
          };

          await authUtils.apiRequestKHO('XUATNHAPKHO', 'Add', {
            "Rows": [phieu]
          });

          const chiTietToSave = [];

          for (let i = 0; i < group.chiTiet.length; i++) {
            const item = group.chiTiet[i];

            const chiTiet = {
              'ID_CT': Date.now() + i,
              'SOPHIEU': soPhieu,
              'NGHIEP_VU': importNghiepVu,
              'KHO_XUAT': importNghiepVu === 'XUAT' ? group.kho : '',
              'KHO_NHAP': importNghiepVu === 'NHAP' ? group.kho : '',
              'NGAY_NHAP_XUAT': group.ngay,
              'NHOM_HANG': item.nhomHang,
              'MA_KIEN': item.maKien,
              'DAY': item.day,
              'RONG': item.rong,
              'DAI': item.dai,
              'THANH': item.soThanh,
              'SO_KHOI': item.soKhoi,
              'TIEU_CHUAN': item.tieuChuan,
              'DOI_HANG_KHO': item.doiHangKho,
              'DONGIA': item.donGia,
              'THANHTIEN': item.thanhTien,
              'GHICHU': ''
            };

            chiTietToSave.push(chiTiet);

            await new Promise(resolve => setTimeout(resolve, 10));
          }

          await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Add', {
            "Rows": chiTietToSave
          });

          console.log(`✅ Đã tạo phiếu ${soPhieu}: ${group.nccKhachHang} - ${group.chiTiet.length} kiện`);
          successCount++;
        } catch (error) {
          console.error(`❌ Error importing phieu ${soPhieu}:`, error);
          errorCount++;
        }
      }

      if (successCount > 0) {
        toast.success(`Import thành công ${successCount} phiếu với ${validRows.length} kiện`);
        await fetchPhieuList();
        await fetchTonKho();
        handleCloseImportModal();
      }

      if (errorCount > 0) {
        toast.warning(`Có ${errorCount} phiếu import thất bại`);
      }

    } catch (error) {
      console.error('Error importing data:', error);
      toast.error('Có lỗi xảy ra khi import dữ liệu: ' + error.message);
    } finally {
      setIsImporting(false);
    }
  };

  const handleOpenImportModal = () => {
    setShowImportModal(true);
    setImportFile(null);
    setImportPreview([]);
    setImportNghiepVu('NHAP');
  };

  const handleCloseImportModal = () => {
    setShowImportModal(false);
    setImportFile(null);
    setImportPreview([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // ==================== PRINT FUNCTIONS ====================

  const handleOpenPrintOptions = (phieu) => {
    if (phieu['NGHIEP_VU'] === 'XUAT') {
      setPhieuToPrint(phieu);
      setShowPrintOptions(true);
      setPrintWithPrice(false);
    } else {
      handlePrintPhieu(phieu, false);
    }
  };

  const handlePrintPhieu = async (phieu, showPrice = false, companyCode = 'HOANG_NGUYEN_LONG', customHeaderInfo = '') => {
    try {
      toast.info('Đang tải dữ liệu để in...');

      const response = await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {});
      const chiTiet = response.filter(item => item['SOPHIEU'] === phieu['SOPHIEU']);

      if (chiTiet.length === 0) {
        toast.error('Không tìm thấy chi tiết phiếu để in');
        return;
      }

      const date = new Date(phieu['NGAYNHAP_XUAT']);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();

      const isNhapKho = phieu['NGHIEP_VU'] === 'NHAP';
      const isXuatKho = phieu['NGHIEP_VU'] === 'XUAT';

      // Thông tin công ty
      const companyInfo = companyCode === 'HOANG_KHOI'
        ? {
          name: 'CÔNG TY TNHH GỖ HOÀNG KHÔI',
          mst: customHeaderInfo || 'MST: 3702896657',
          phone: ''
        }
        : {
          name: 'CÔNG TY CP TM SX XD HOÀNG NGUYÊN LONG',
          mst: '',
          phone: customHeaderInfo || 'Điện thoại: 0919.509.009 - 0985.96.97.98 ( A. Lưỡng )'
        };
      const showPriceColumns = isXuatKho && showPrice;

      // ✅ HÀM FORMAT SỐ CHO PRINT (dùng dấu phẩy)
      const formatNumberForPrint = (number, decimals = 4) => {
        if (!number || isNaN(number)) return '0' + ',0000'.slice(0, decimals + 1);
        return parseFloat(number).toFixed(decimals).replace('.', ',');
      };

      // ✅ NHẬP KHO: Nhóm theo ĐỘI + ĐỘ DÀY
      let groupedDataNhap = {};
      let groupedDominoNhap = {}; // Nhóm Domino (Dài 200-350) theo ĐỘI + ĐỘ DÀY
      if (isNhapKho) {
        chiTiet.forEach(item => {
          const doiHangKho = item['DOI_HANG_KHO'] || 'Chưa phân đội';
          const day = item['DAY'] || 0;
          const dai = parseFloat(item['DAI'] || 0);
          const key = `${doiHangKho}_${day}`;

          if (!groupedDataNhap[key]) {
            groupedDataNhap[key] = {
              doiHangKho: doiHangKho,
              day: day,
              soKien: 0,
              tongKhoi: 0
            };
          }
          groupedDataNhap[key].soKien += 1;
          groupedDataNhap[key].tongKhoi += parseFloat(item['SO_KHOI'] || 0);

          // Nhóm Domino riêng nếu Dài từ 200 đến 350
          if (dai >= 200 && dai <= 350) {
            if (!groupedDominoNhap[key]) {
              groupedDominoNhap[key] = {
                doiHangKho: doiHangKho,
                day: day,
                soKien: 0,
                tongKhoi: 0
              };
            }
            groupedDominoNhap[key].soKien += 1;
            groupedDominoNhap[key].tongKhoi += parseFloat(item['SO_KHOI'] || 0);
          }
        });
      }

      // Sắp xếp
      const sortedGroupsNhap = Object.values(groupedDataNhap).sort((a, b) => {
        if (a.doiHangKho !== b.doiHangKho) {
          return a.doiHangKho.localeCompare(b.doiHangKho);
        }
        return a.day - b.day;
      });

      // ============================================
      // PHIẾU NHẬP KHO (MẪU BAN ĐẦU - GIỐNG CODE CŨ)
      // ============================================
      if (isNhapKho) {
        const printContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Phiếu Nhập Kho - ${phieu['SOPHIEU']}</title>
  <style>
    @page { size: A4; margin: 10mm; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Times New Roman', Times, serif; font-size: 12pt; line-height: 1.3; color: #000; }
    .container { width: 100%; max-width: 210mm; margin: 0 auto; padding: 5mm; }
    .header { text-align: center; }
    .header h1 { font-size: 18pt; font-weight: bold; margin-bottom: 3px; text-transform: uppercase; }
    .header .date { font-weight: bold; font-size: 13pt; font-style: italic; margin-bottom: 5px; }
    .info-section { display: grid; grid-template-columns: 1fr 1fr; gap: 5px; margin-bottom: 5px; }
    .info-item { font-size: 11pt;}
    .info-item strong { font-weight: bold; min-width: 120px; display: inline-block; }
    table { width: 100%; border-collapse: collapse; margin: 5px 0; font-size: 10pt; }
    table th { background-color: #f0f0f0; border: 1px solid #000; padding: 6px 4px; text-align: center; font-weight: bold; font-size: 9pt; }
    table td { border: 1px solid #000; padding: 5px 4px; text-align: center; }
    table td.left { text-align: left; padding-left: 10px; }
    table td.right { text-align: right; padding-right: 10px; }
    .summary-row { background-color: #ffff26; color: red; }
    .total-row { background-color: #ffff26; font-weight: bold; color: red; }
    .signatures { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; text-align: center; }
    .signature-box { padding: 10px; }
    .signature-box .title { font-weight: bold; font-size: 11pt; }
    .signature-box .name { font-style: italic; margin-top: 5px; }
    .footer { margin-top: 20px; text-align: center; font-size: 9pt; font-style: italic; color: #666; }
    @media print {
      body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      .no-print { display: none; }
      .page-break { page-break-after: always; }
    }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <div class="company-name" style="font-size: 13pt; font-weight: bold;">${companyInfo.name}</div>
      ${companyInfo.mst ? `<div style="font-size: 9pt; margin-bottom: 5px;">${companyInfo.mst}</div>` : ''}
      ${companyInfo.phone ? `<div style="font-size: 9pt; margin-bottom: 10px;">${companyInfo.phone}</div>` : ''}
      <h1>SỔ NHẬT KÝ - NHẬP KHO THÀNH PHẨM</h1>
      <div class="date">Ngày ${day} Tháng ${month} Năm ${year}</div>
    </div>
    
    <div class="info-section">
      <div class="info-item"><strong>Số phiếu:</strong> ${phieu['SOPHIEU']}</div>
      <div class="info-item"><strong>Kho nhập:</strong> ${phieu['KHONHAP']}</div>
          </div>
    <div class="info-item"><strong>Nhà cung cấp:</strong> ${phieu['NCC_KHACHHANG'] || ''}</div>
    
    <table>
      <thead>
        <tr>
          <th style="width: 30px;">STT</th>
          <th style="width: 80px;">Mã Kiện</th>
          <th style="width: 40px;">Dày</th>
          <th style="width: 50px;">Rộng</th>
          <th style="width: 50px;">Dài</th>
          <th style="width: 80px;">Số thanh</th>
          <th style="width: 70px;">Số m³</th>
          <th style="width: 80px;">Tiêu chuẩn</th>
          <th style="width: 60px;">Thủ kho</th>
          <th style="width: 90px;">Đội hàng Khô</th>
          <th style="width: 80px;">Ghi chú</th>
        </tr>
      </thead>
      <tbody>
        ${chiTiet.map((item, index) => `
          <tr>
            <td>${index + 1}</td>
            <td>${item['MA_KIEN']}</td>
            <td>${item['DAY']}</td>
            <td>${item['RONG']}</td>
            <td>${item['DAI']}</td>
            <td>${item['THANH'] || ''}</td>
            <td class="right">${formatNumberForPrint(item['SO_KHOI'], 4)}</td>
            <td>${item['TIEU_CHUAN'] || ''}</td>
            <td></td>
            <td>${item['DOI_HANG_KHO'] || ''}</td>
            <td>${item['GHICHU'] || ''}</td>
          </tr>
        `).join('')}
        
        <!-- TỔNG CỘNG THEO ĐỘI + ĐỘ DÀY -->
        ${sortedGroupsNhap.map(group => {
          const dominoKey = `${group.doiHangKho}_${group.day}`;
          const dominoGroup = groupedDominoNhap[dominoKey];
          const nonDominoKien = group.soKien - (dominoGroup ? dominoGroup.soKien : 0);
          return `
          ${nonDominoKien > 0 ? `
          <tr class="summary-row">
            <td colspan="5" class="left">
              <span>TỔNG CỘNG ĐỘI ${group.doiHangKho.toUpperCase()}</span>
            </td>
            <td class="left"><span>Hàng ${group.day}</span></td>
            <td class="right"><span>${formatNumberForPrint(group.tongKhoi - (dominoGroup ? dominoGroup.tongKhoi : 0), 4)}</span></td>
            <td></td>
            <td></td>
            <td><span>${nonDominoKien} kiện</span></td>
            <td></td>
          </tr>
          ` : ''}
          ${dominoGroup ? `
          <tr class="summary-row">
            <td colspan="5" class="left">
              <span>TỔNG CỘNG ĐỘI ${group.doiHangKho.toUpperCase()}</span>
            </td>
            <td class="left"><span>Đôminô ${group.day}</span></td>
            <td class="right"><span>${formatNumberForPrint(dominoGroup.tongKhoi, 4)}</span></td>
            <td></td>
            <td></td>
            <td><span>${dominoGroup.soKien} kiện</span></td>
            <td></td>
          </tr>
          ` : ''}
        `}).join('')}
        
        <!-- TỔNG NGÀY -->
        <tr class="total-row">
          <td colspan="6" class="left">
            <strong>TỔNG NGÀY ${day}/${month}/${year}</strong>
          </td>
          <td class="right"><strong>${formatNumberForPrint(phieu['TONGKHOILUONG'], 4)}</strong></td>
          <td></td>
          <td></td>
          <td colspan="2" class="left"><strong>Tổng cộng ${chiTiet.length} kiện</strong></td>
        </tr>
      </tbody>
    </table>
    
    <div class="signatures">
      <div class="signature-box">
        <div class="title">Người lập phiếu</div>
        <div class="name">${phieu['NGUOIPHUTRACH'] || '(Ký và ghi rõ họ tên)'}</div>
      </div>
      <div class="signature-box">
        <div class="title">Thủ kho</div>
        <div class="name">(Ký và ghi rõ họ tên)</div>
      </div>
      <div class="signature-box">
        <div class="title">Kế toán trưởng</div>
        <div class="name">(Ký và ghi rõ họ tên)</div>
      </div>
    </div>
  </div>
  
  <script>
    window.onload = function() {
      window.print();
    }
  </script>
</body>
</html>
`;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(printContent);
        printWindow.document.close();
      }

      // ============================================
      // PHIẾU XUẤT KHO (MẪU MỚI - CÓ TÙY CHỌN GIÁ)
      // ============================================
      if (isXuatKho) {
        // ✅ XUẤT KHO: Nhóm theo ĐỘ DÀY + TIÊU CHUẨN
        let groupedDataXuat = {};
        chiTiet.forEach(item => {
          const day = item['DAY'] || 0;
          const tieuChuan = item['TIEU_CHUAN'] || '';
          const key = `${day}_${tieuChuan}`;

          if (!groupedDataXuat[key]) {
            groupedDataXuat[key] = {
              day: day,
              tieuChuan: tieuChuan,
              soKien: 0,
              tongKhoi: 0,
              tongTien: 0,
              tongThanh: 0,
            };
          }
          groupedDataXuat[key].soKien += 1;
          groupedDataXuat[key].tongKhoi += parseFloat(item['SO_KHOI'] || 0);
          groupedDataXuat[key].tongTien += parseFloat(item['THANHTIEN'] || 0);
          groupedDataXuat[key].tongThanh += parseInt(item['THANH'] || 0);
        });

        // Tính tổng số thanh toàn phiếu
        const tongThanhAll = chiTiet.reduce((sum, item) => sum + (parseInt(item['THANH']) || 0), 0);

        // Sắp xếp theo độ dày, sau đó theo tiêu chuẩn
        const sortedGroupsXuat = Object.values(groupedDataXuat).sort((a, b) => {
          if (a.day !== b.day) {
            return a.day - b.day;
          }
          return a.tieuChuan.localeCompare(b.tieuChuan);
        });


        const ptVat = phieu['PT VAT'] || 0;
        const tienVat = parseFloat(phieu['TIEN VAT'] || 0);
        const tongThanhToan = parseFloat(phieu['TONGTIEN'] || 0);
        // TONGTIEN là Tổng thanh toán, THANHTIEN là Tiền hàng (Subtotal)
        // Nếu không có THANHTIEN thì tính ngược lại
        const tienHang = phieu['THANHTIEN'] ? parseFloat(phieu['THANHTIEN']) : (tongThanhToan - tienVat);

        const printContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Phiếu Xuất Kho - ${phieu['SOPHIEU']}</title>
  <style>
    @page { size: A4; margin: 10mm; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Times New Roman', Times, serif; font-size: 11pt; line-height: 1.3; color: #000; }
    .container { width: 100%; max-width: 210mm; margin: 0 auto; padding: 8mm; }
    
    /* Header */
    .header { text-align: center;}
    .header .company-name { font-size: 13pt; font-weight: bold; }
    .header .contact { font-size: 9pt; margin-bottom: 10px; }
    .header .title { font-size: 15pt; font-weight: bold; margin-bottom: 8px; text-transform: uppercase; }
    
    /* Date and Number Info */
    .date-number-section { 
      display: flex; 
      justify-content: flex-end; 
      gap: 30px;
      margin-bottom: 5px; 
      font-size: 11pt;
    }
    .date-number-section .item {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .date-number-section .label { font-weight: normal; }
    .date-number-section .value { 
      border: 1px solid #000; 
      padding: 3px 15px;
      min-width: 100px;
      text-align: center;
    }
    
    /* Info Section */
    .info-section { margin-bottom: 5px; font-size: 11pt; }
    .info-row { display: flex; }
    .info-label { font-weight: bold; min-width: 100px; }
    
    /* Table */
    table { width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10pt; }
    table th { 
      background-color: #f0f0f0; 
      border: 1px solid #000; 
      padding: 6px 4px; 
      text-align: center; 
      font-weight: bold; 
      font-size: 9pt;
      vertical-align: middle;
    }
    table td { 
      border: 1px solid #000; 
      padding: 5px 4px; 
      text-align: center;
      vertical-align: middle;
    }
    table td.left { text-align: left; padding-left: 8px; }
    table td.right { text-align: right; padding-right: 8px; }
    
    /* Summary rows */
    .summary-row { font-weight: bold; color: #000; }
    .total-row { background-color: #ffeb3b; font-weight: bold; color: red; }
    
    /* Footer */
    .footer { 
      display: flex; 
      justify-content: space-between;
      font-size: 11pt;
    }
    .footer-box { 
      text-align: center;
      padding: 10px;
    }
    .footer-box .title { 
      font-weight: bold; 
      margin-bottom: 60px;
    }
    
    @media print {
      body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      .no-print { display: none; }
    }
  </style>
</head>
<body>
  <div class="container">
    <!-- Header -->
    <div class="header">
      <div class="company-name">${companyInfo.name}</div>
      ${companyInfo.mst ? `<div class="company-name">${companyInfo.mst}</div>` : ''}
      ${companyInfo.phone ? `<div class="company-name">${companyInfo.phone}</div>` : ''}
      <div class="title">PHIẾU XUẤT KHO ( GIAO HÀNG)</div>
    </div>
    
    <!-- Date and Number -->
    <div class="date-number-section">
      <div class="item">
        <span class="label">Ngày</span>
        <span class="value">${day}/${month}/${year}</span>
      </div>
      <div class="item">
        <span class="label">Số phiếu:</span>
        <span class="value">${phieu['SOPHIEU']}</span>
      </div>
    </div>
    
    <!-- Info Section -->
    <div class="info-section">
      <div class="info-row">
        <span class="info-label">Khách hàng:</span>
        <span><strong>${phieu['NCC_KHACHHANG'] || ''}</strong></span>
      </div>
      <div class="info-row">
        <span class="info-label">Số xe:</span>
        <span><strong>${phieu['DIENGIAI'] || ''}</strong></span>
      </div>
    </div>
    
    <!-- Table -->
    <table>
      <thead>
        <tr>
          <th style="width: 30px;">STT</th>
          <th style="width: 80px;">Mã Kiện</th>
          <th style="width: 40px;">Dày</th>
          <th style="width: 45px;">Rộng</th>
          <th style="width: 45px;">Dài</th>
          <th style="width: 55px;">Số thanh</th>
          <th style="width: 55px;">Số m3</th>
          <th style="width: 70px;">Tiêu chuẩn</th>
          ${showPriceColumns ? '<th style="width: 90px;">Đơn giá</th>' : ''}
          ${showPriceColumns ? '<th style="width: 100px;">Thành tiền</th>' : '<th style="width: 70px;">Ghi chú</th>'}
        </tr>
      </thead>
      <tbody>
        ${chiTiet.map((item, index) => `
          <tr>
            <td>${index + 1}</td>
            <td class="left">${item['MA_KIEN']}</td>
            <td>${item['DAY']}</td>
            <td>${item['RONG']}</td>
            <td>${item['DAI']}</td>
            <td>${item['THANH'] || ''}</td>
            <td class="right">${formatNumberForPrint(item['SO_KHOI'], 4)}</td>
            <td>${item['TIEU_CHUAN'] || ''}</td>
            ${showPriceColumns ? `<td class="right">${new Intl.NumberFormat('vi-VN').format(item['DONGIA'] || 0)}</td>` : ''}
            ${showPriceColumns ? `<td class="right">${new Intl.NumberFormat('vi-VN').format(item['THANHTIEN'] || 0)}</td>` : `<td>${item['GHICHU'] || ''}</td>`}
          </tr>
        `).join('')}

        <!-- TỔNG CỘNG THEO ĐỘ DÀY + TIÊU CHUẨN -->
        ${sortedGroupsXuat.map(group => `
          <tr class="summary-row">
            <td colspan="3" class="center">
              <strong>Hàng ${group.day}${group.tieuChuan ? ' - ' + group.tieuChuan : ''}</strong>
            </td>
            <td colspan="2" class="right">
              <strong>${group.soKien} kiện</strong>
            </td>
            <td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(group.tongThanh)}</strong></td>
            <td class="right"><strong>${formatNumberForPrint(group.tongKhoi, 4)}</strong></td>
            <td></td>
            ${showPriceColumns ? '<td></td>' : ''}
            ${showPriceColumns ? `<td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(group.tongTien)}</strong></td>` : '<td></td>'}
          </tr>
        `).join('')}

        <!-- TỔNG CỘNG CHUNG -->
        <tr class="total-row">
          <td colspan="3" class="center">
            <strong>TỔNG CỘNG</strong>
          </td>
          <td colspan="2" class="right">
            <strong>${chiTiet.length} kiện</strong>
          </td>
          <td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(tongThanhAll)}</strong></td>
          <td class="right"><strong>${formatNumberForPrint(phieu['TONGKHOILUONG'], 4)}</strong></td>
          <td ${showPriceColumns ? '' : 'colspan="2"'}></td>
          ${showPriceColumns ? '<td></td>' : ''}
          ${showPriceColumns ? `<td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(tienHang)}</strong></td>` : ''}
        </tr>

        ${showPriceColumns ? `
          <tr class="total-row">
            <td colspan="9" class="right" style="text-align: center;"><strong>THUẾ VAT ${ptVat}%</strong></td>
            <td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(tienVat)}</strong></td>
          </tr>
          <tr class="total-row">
            <td colspan="9" class="right" style="text-align: center;"><strong>TỔNG THANH TOÁN</strong></td>
            <td class="right"><strong>${new Intl.NumberFormat('vi-VN').format(tongThanhToan)}</strong></td>
          </tr>
        ` : ''}
      </tbody>
    </table>
    
    <!-- Footer -->
    <div class="footer">
      <div class="footer-box">
        <div class="title">Bên nhận hàng</div>
      </div>
      <div class="footer-box">
        <div class="title">${companyInfo.name}</div>
      </div>
    </div>
  </div>
  
  <script>
    window.onload = function() {
      window.print();
    }
  </script>
</body>
</html>
`;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(printContent);
        printWindow.document.close();
      }


      toast.dismiss();
      setShowPrintOptions(false);

    } catch (error) {
      console.error('Error printing phieu:', error);
      toast.error('Có lỗi xảy ra khi in phiếu: ' + error.message);
    }
  };

  // ==================== GENERATE FUNCTIONS ====================

  const generateSoPhieu = (nghiepVu, ngayNhapXuat) => {
    const date = new Date(ngayNhapXuat);
    const yy = date.getFullYear().toString().slice(-2);
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    const prefix = nghiepVu === 'NHAP' ? 'NK' : 'XK';
    const yearMonthDay = `${yy}${mm}${dd}`;

    const phieuCungLoai = phieuList.filter(p => {
      return p['SOPHIEU'] && p['SOPHIEU'].startsWith(`${prefix}-`);
    });

    let maxNumber = 0;
    phieuCungLoai.forEach(p => {
      const match = p['SOPHIEU'].match(/-(\d+)$/);
      if (match) {
        const num = parseInt(match[1]);
        if (num > maxNumber) maxNumber = num;
      }
    });

    const nextNumber = (maxNumber + 1).toString().padStart(4, '0');
    return `${prefix}-${yearMonthDay}-${nextNumber}`;
  };

  const generateMaKien = (ngayNhapXuat) => {
    const date = new Date(ngayNhapXuat);
    const yy = date.getFullYear().toString().slice(-2);
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    const yearMonthDay = `${yy}${mm}${dd}`;

    const allKien = [
      ...tonKho,
      ...chiTietList
    ];

    let maxNumber = 0;
    allKien.forEach(k => {
      if (k['MA_KIEN']) {
        const match = k['MA_KIEN'].match(/-(\d+)$/);
        if (match) {
          const num = parseInt(match[1]);
          if (num > maxNumber) maxNumber = num;
        }
      }
    });

    const nextNumber = (maxNumber + 1).toString().padStart(5, '0');
    return `K-${yearMonthDay}-${nextNumber}`;
  };

  // ==================== FORMAT FUNCTIONS ====================

  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return '0 ₫';
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('vi-VN');
    } catch (error) {
      return dateString;
    }
  };

  // Thêm hàm này vào đầu component, sau các hàm format hiện có
  const formatNumber = (number, decimals = 4) => {
    if (!number || isNaN(number)) return '0' + ',0000'.slice(0, decimals + 1);
    return parseFloat(number).toFixed(decimals).replace('.', ',');
  };

  // ==================== FETCH DATA ====================

  const fetchPhieuList = async () => {
    try {
      setIsLoading(true);
      const response = await authUtils.apiRequestKHO('XUATNHAPKHO', 'Find', {});
      setPhieuList(response);
    } catch (error) {
      console.error('Error fetching phieu list:', error);
      toast.error('Lỗi khi tải danh sách phiếu');
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Đồng bộ TONGKHOILUONG/THANHTIEN/TIEN VAT/TONGTIEN của phiếu cha theo tổng SO_KHOI chi tiết.
  //    Quét toàn bộ phiếu, chỉ ghi đè những phiếu đang lệch (data cũ không khớp chi tiết).
  const handleSyncTotals = async () => {
    if (isSyncingTotals) return;
    if (!window.confirm('Quét toàn bộ phiếu và cập nhật lại Tổng khối lượng / Thành tiền theo chi tiết thực tế?\nChỉ những phiếu đang lệch mới bị ghi đè.')) {
      return;
    }

    try {
      setIsSyncingTotals(true);
      toast.info('Đang tải dữ liệu để đối chiếu...');

      const [allPhieu, allChiTiet] = await Promise.all([
        authUtils.apiRequestKHO('XUATNHAPKHO', 'Find', {}),
        authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {})
      ]);

      // Gom chi tiết theo số phiếu
      const chiTietByPhieu = {};
      allChiTiet.forEach(ct => {
        const sp = ct['SOPHIEU'];
        if (!sp) return;
        if (!chiTietByPhieu[sp]) chiTietByPhieu[sp] = [];
        chiTietByPhieu[sp].push(ct);
      });

      const EPSILON = 0.00005; // ngưỡng sai lệch khối lượng coi là "khác" (nhỏ hơn = do làm tròn)
      const rowsToUpdate = [];
      const lechList = [];

      allPhieu.forEach(phieu => {
        const sp = phieu['SOPHIEU'];
        const chiTiet = chiTietByPhieu[sp] || [];

        const tongKhoiLuong = chiTiet.reduce((sum, ct) => sum + (parseFloat(ct['SO_KHOI']) || 0), 0);
        const thanhTien = chiTiet.reduce((sum, ct) => sum + (parseFloat(ct['THANHTIEN']) || 0), 0);
        const ptVat = parseFloat(phieu['PT VAT']) || 0;
        const tienVat = Math.round(thanhTien * (ptVat / 100));
        const tongTien = thanhTien + tienVat;

        const oldKhoiLuong = parseFloat(phieu['TONGKHOILUONG']) || 0;
        const oldThanhTien = parseFloat(phieu['THANHTIEN']) || 0;
        const oldTongTien = parseFloat(phieu['TONGTIEN']) || 0;

        const lechKhoiLuong = Math.abs(oldKhoiLuong - tongKhoiLuong) > EPSILON;
        const lechThanhTien = Math.abs(oldThanhTien - thanhTien) >= 1; // tiền lệch từ 1đ
        const lechTongTien = Math.abs(oldTongTien - tongTien) >= 1;

        if (lechKhoiLuong || lechThanhTien || lechTongTien) {
          rowsToUpdate.push({
            'SOPHIEU': sp,
            'TONGKHOILUONG': tongKhoiLuong,
            'THANHTIEN': thanhTien,
            'TIEN VAT': tienVat,
            'TONGTIEN': tongTien
          });
          lechList.push({
            sp,
            oldKL: oldKhoiLuong.toFixed(4),
            newKL: tongKhoiLuong.toFixed(4)
          });
        }
      });

      if (rowsToUpdate.length === 0) {
        toast.success('Tất cả phiếu đã khớp. Không có gì cần cập nhật.');
        return;
      }

      console.log(`[SyncTotals] ${rowsToUpdate.length} phiếu lệch:`, lechList);
      toast.info(`Phát hiện ${rowsToUpdate.length} phiếu lệch. Đang cập nhật...`);

      // Ghi theo lô để tránh payload quá lớn
      const BATCH_SIZE = 100;
      for (let i = 0; i < rowsToUpdate.length; i += BATCH_SIZE) {
        const batch = rowsToUpdate.slice(i, i + BATCH_SIZE);
        await authUtils.apiRequestKHO('XUATNHAPKHO', 'Edit', { "Rows": batch });
      }

      await fetchPhieuList();
      toast.success(`Đã đồng bộ ${rowsToUpdate.length} phiếu bị lệch thành công!`);
    } catch (error) {
      console.error('Error syncing totals:', error);
      toast.error('Lỗi khi đồng bộ tổng phiếu: ' + error.message);
    } finally {
      setIsSyncingTotals(false);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await authUtils.apiRequestKHO('DSKH', 'Find', {});
      setCustomers(response);
    } catch (error) {
      console.error('Error fetching customers:', error);
      toast.error('Lỗi khi tải danh sách khách hàng');
    }
  };

  const fetchKhoList = async () => {
    try {
      const response = await authUtils.apiRequestKHO('CD_KHO', 'Find', {});
      setKhoList(response);
    } catch (error) {
      console.error('Error fetching kho list:', error);
      toast.error('Lỗi khi tải danh sách kho');
    }
  };

  const fetchDMHH = async () => {
    try {
      const response = await authUtils.apiRequestKHO('DMHH', 'Find', {});
      setDmhh(response);
    } catch (error) {
      console.error('Error fetching DMHH:', error);
      toast.error('Lỗi khi tải danh mục hàng hóa');
    }
  };

  const fetchTonKho = async () => {
    try {
      const response = await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {});
      setTonKho(response);
    } catch (error) {
      console.error('Error fetching ton kho:', error);
    }
  };

  const fetchTieuChuan = async () => {
    try {
      const response = await authUtils.apiRequestKHO('CD_TIEUCHUAN', 'Find', {});
      setTieuChuanList(response);
    } catch (error) {
      console.error('Error fetching tieu chuan:', error);
      toast.error('Lỗi khi tải danh sách tiêu chuẩn');
    }
  };

  const fetchCurrentUser = async () => {
    try {
      const localUser = authUtils.getUserData();
      if (localUser) {
        setCurrentUser(localUser);
      }
    } catch (error) {
      console.error('Error fetching current user:', error);
    }
  };

  const fetchRequestHistory = async () => {
    try {
      const response = await authUtils.apiRequestKHO('XUATNHAPKHO_REQUEST', 'Find', {});

      // Lọc theo người yêu cầu hiện tại
      const currentUserName = currentUser ? (currentUser['Họ và Tên'] || currentUser.username) : '';
      const userRequests = response.filter(req => req['NGUOI_YEU_CAU'] === currentUserName);

      // Sắp xếp theo thời gian mới nhất
      userRequests.sort((a, b) => new Date(b['THOI_GIAN_YEU_CAU']) - new Date(a['THOI_GIAN_YEU_CAU']));

      setRequestHistory(userRequests);
    } catch (error) {
      console.error('Error fetching request history:', error);
      toast.error('Lỗi khi tải lịch sử yêu cầu');
    }
  };


  const handleAddTieuChuan = async () => {
    if (!newTieuChuan.trim()) {
      toast.error('Vui lòng nhập tên tiêu chuẩn');
      return;
    }

    const exists = tieuChuanList.find(tc =>
      tc['TIEU_CHUAN'].toLowerCase() === newTieuChuan.trim().toLowerCase()
    );

    if (exists) {
      toast.error('Tiêu chuẩn này đã tồn tại');
      return;
    }

    try {
      const newTC = {
        'ID_TC': Date.now(),
        'TIEU_CHUAN': newTieuChuan.trim().toUpperCase()
      };

      await authUtils.apiRequestKHO('CD_TIEUCHUAN', 'Add', {
        "Rows": [newTC]
      });

      toast.success('Thêm tiêu chuẩn mới thành công!');
      await fetchTieuChuan();
      setNewTieuChuan('');
      setShowTieuChuanModal(false);
    } catch (error) {
      console.error('Error adding tieu chuan:', error);
      toast.error('Có lỗi xảy ra khi thêm tiêu chuẩn');
    }
  };

  const handleDeleteTieuChuan = async (idTC) => {
    if (!window.confirm('Bạn có chắc chắn muốn xóa tiêu chuẩn này?')) {
      return;
    }

    try {
      await authUtils.apiRequestKHO('CD_TIEUCHUAN', 'Delete', {
        "Rows": [{ "ID_TC": idTC }]
      });

      toast.success('Xóa tiêu chuẩn thành công!');
      await fetchTieuChuan();
    } catch (error) {
      console.error('Error deleting tieu chuan:', error);
      toast.error('Có lỗi xảy ra khi xóa tiêu chuẩn');
    }
  };

  useEffect(() => {
    if (khoList.length > 0 && !currentPhieu['KHONHAP'] && !currentPhieu['KHOXUAT']) {
      const defaultKho = khoList[0]['KHO'];
      setCurrentPhieu(prev => ({
        ...prev,
        'KHONHAP': prev['NGHIEP_VU'] === 'NHAP' ? defaultKho : '',
        'KHOXUAT': prev['NGHIEP_VU'] === 'XUAT' ? defaultKho : ''
      }));
    }
  }, [khoList]);

  // ✅ CẬP NHẬT: Khi chọn độ dày và tiêu chuẩn xuất kho, tự động load kiện và đơn giá
  useEffect(() => {
    if (currentPhieu['NGHIEP_VU'] === 'XUAT' && currentPhieu['KHOXUAT']) {
      loadAvailableDay(currentPhieu['KHOXUAT']);
    }
  }, [currentPhieu['KHOXUAT'], currentPhieu['NGHIEP_VU']]);

  // ✅ CẬP NHẬT: Khi chọn độ dày và tiêu chuẩn, load kiện và đơn giá
  useEffect(() => {
    if (currentPhieu['NGHIEP_VU'] === 'XUAT' && selectedDay && selectedTieuChuanXuat) {
      loadAvailableKienByDayAndTieuChuan(selectedDay, selectedTieuChuanXuat);

      // Tự động lấy đơn giá
      const donGia = getDonGiaByDayAndTieuChuan(selectedDay, selectedTieuChuanXuat);
      setCurrentChiTiet(prev => ({
        ...prev,
        'DONGIA': donGia
      }));

      if (donGia > 0) {
        toast.success(`Đơn giá: ${formatCurrency(donGia)}`);
      } else {
        toast.warning('Không tìm thấy đơn giá cho độ dày và tiêu chuẩn này');
      }
    }
  }, [selectedDay, selectedTieuChuanXuat, currentPhieu['NGHIEP_VU']]);

  useEffect(() => {
    if (tieuChuanList.length > 0 && !currentChiTiet['TIEU_CHUAN']) {
      setCurrentChiTiet(prev => ({
        ...prev,
        'TIEU_CHUAN': tieuChuanList[0]['TIEU_CHUAN']
      }));
    }
  }, [tieuChuanList]);

  useEffect(() => {
    if (doiHangKhoList.length > 0 && !currentChiTiet['DOI_HANG_KHO']) {
      setCurrentChiTiet(prev => ({
        ...prev,
        'DOI_HANG_KHO': doiHangKhoList[0]['DOI_HANG_KHO']
      }));
    }
  }, [doiHangKhoList]);

  useEffect(() => {
    fetchPhieuList();
    fetchCustomers();
    fetchKhoList();
    fetchDMHH();
    fetchTonKho();
    fetchTieuChuan();
    fetchDoiHangKho();
    fetchCurrentUser();
    fetchGiaBan(); // ✅ THÊM FETCH BẢNG GIÁ BÁN
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (customerDropdownRef.current && !customerDropdownRef.current.contains(event.target)) {
        setShowCustomerDropdown(false);
      }
      if (nhomHangDropdownRef.current && !nhomHangDropdownRef.current.contains(event.target)) {
        setShowNhomHangDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredCustomers = customers.filter(customer => {
    const matchesSearch = customer['TEN_KHACHHANG']?.toLowerCase().includes(customerSearchTerm.toLowerCase()) ||
      customer['MA_KH']?.toLowerCase().includes(customerSearchTerm.toLowerCase());

    if (currentPhieu['NGHIEP_VU'] === 'XUAT') {
      return matchesSearch && customer['PHAN_LOAI'] === 'KH';
    }

    return matchesSearch;
  });

  const filteredNhomHang = dmhh.filter(item =>
    item['NHOM_HANG']?.toLowerCase().includes(nhomHangSearchTerm.toLowerCase())
  );

  const handleSelectCustomer = async (customer) => {
    setCurrentPhieu(prev => ({
      ...prev,
      'NCC_KHACHHANG': customer['TEN_KHACHHANG']
    }));
    setCustomerSearchTerm(customer['TEN_KHACHHANG']);
    setShowCustomerDropdown(false);
  };

  const handleSelectNhomHang = (nhomHang) => {
    const nhomHangInfo = dmhh.find(item => item['NHOM_HANG'] === nhomHang);
    setSelectedNhomHangInfo(nhomHangInfo);
    setNhomHangSearchTerm(nhomHang);
    setCurrentChiTiet(prev => ({
      ...prev,
      'NHOM_HANG': nhomHang,
      'DONGIA': nhomHangInfo?.['DONGIA_HIEULUC'] || 0
    }));
    setShowNhomHangDropdown(false);
  };

  const loadAvailableDay = (khoXuat) => {
    if (!khoXuat) return;

    const kienTon = tonKho.filter(item =>
      item['NGHIEP_VU'] === 'NHAP' &&
      item['KHO_NHAP'] === khoXuat
    );

    const dayList = [...new Set(kienTon.map(item => item['DAY']))].filter(Boolean).sort((a, b) => a - b);
    setAvailableDay(dayList);
  };

  // ✅ HÀM MỚI: Load kiện theo độ dày và tiêu chuẩn
  const loadAvailableKienByDayAndTieuChuan = (day, tieuChuan) => {
    if (!day || !tieuChuan || !currentPhieu['KHOXUAT']) {
      setAvailableKien([]);
      return;
    }

    let kienTon = tonKho.filter(item =>
      item['NGHIEP_VU'] === 'NHAP' &&
      item['KHO_NHAP'] === currentPhieu['KHOXUAT'] &&
      parseFloat(item['DAY']) === parseFloat(day) &&
      item['TIEU_CHUAN'] === tieuChuan
    );

    const kienDaXuat = tonKho.filter(item => item['NGHIEP_VU'] === 'XUAT').map(item => item['MA_KIEN']);
    kienTon = kienTon.filter(item => !kienDaXuat.includes(item['MA_KIEN']));

    setAvailableKien(kienTon);
  };

  const handleSelectDay = (day) => {
    setSelectedDay(day);

    // Reset tiêu chuẩn và kiện khi đổi độ dày
    setSelectedTieuChuanXuat('');
    setAvailableKien([]);

    if (tieuChuanList.length > 0) {
      setSelectedTieuChuanXuat(tieuChuanList[0]['TIEU_CHUAN']);
    }
  };

  // ✅ HÀM MỚI: Xử lý chọn tiêu chuẩn xuất kho
  const handleSelectTieuChuanXuat = (tieuChuan) => {
    setSelectedTieuChuanXuat(tieuChuan);

    if (selectedDay && tieuChuan) {
      loadAvailableKienByDayAndTieuChuan(selectedDay, tieuChuan);

      // Tự động lấy đơn giá
      const donGia = getDonGiaByDayAndTieuChuan(selectedDay, tieuChuan);
      setCurrentChiTiet(prev => ({
        ...prev,
        'DONGIA': donGia,
        'TIEU_CHUAN': tieuChuan
      }));
    }
  };

  const filteredAvailableKien = availableKien.filter(kien =>
    kien['MA_KIEN']?.toLowerCase().includes(kienSearchTerm.toLowerCase())
  );

  const isKienSelected = (maKien) => {
    return chiTietList.some(item => item['MA_KIEN'] === maKien);
  };

  const handleSelectKien = (kien) => {
    const exists = chiTietList.find(item => item['MA_KIEN'] === kien['MA_KIEN']);
    if (exists) {
      toast.warning('Kiện này đã được chọn');
      return;
    }

    const donGia = parseFloat(currentChiTiet['DONGIA']) || 0;
    const soKhoi = parseFloat(kien['SO_KHOI']) || 0;

    const newChiTiet = {
      'ID_CT': Date.now(),
      'SOPHIEU': currentPhieu['SOPHIEU'],
      'NGHIEP_VU': 'XUAT',
      'KHO_XUAT': currentPhieu['KHOXUAT'],
      'KHO_NHAP': '',
      'NGAY_NHAP_XUAT': currentPhieu['NGAYNHAP_XUAT'],
      'NHOM_HANG': kien['NHOM_HANG'],
      'MA_KIEN': kien['MA_KIEN'],
      'DAY': kien['DAY'],
      'RONG': kien['RONG'],
      'DAI': kien['DAI'],
      'THANH': kien['THANH'],
      'SO_KHOI': soKhoi,
      'TIEU_CHUAN': kien['TIEU_CHUAN'],
      'DOI_HANG_KHO': kien['DOI_HANG_KHO'],
      'DONGIA': donGia,
      'THANHTIEN': soKhoi * donGia,
      'GHICHU': ''
    };

    const newList = [...chiTietList, newChiTiet];
    setChiTietList(newList);
    updateTongTien(newList);
    toast.success('Đã thêm kiện vào danh sách');
  };

  // ✅ THAY ĐỔI: Chỉ cần số kiện, không bắt buộc nhóm hàng, tiêu chuẩn
  const handleAddChiTietNhap = () => {
    // ✅ CHỈ KIỂM TRA SỐ KIỆN
    if (!currentChiTiet['SO_KIEN'] || parseInt(currentChiTiet['SO_KIEN']) <= 0) {
      toast.error('Vui lòng nhập số lượng kiện hợp lệ');
      return;
    }

    const soKien = parseInt(currentChiTiet['SO_KIEN']) || 0;
    const newChiTietList = [];

    const allKien = [...tonKho, ...chiTietList];
    let maxNumber = 0;

    allKien.forEach(k => {
      if (k['MA_KIEN']) {
        const match = k['MA_KIEN'].match(/-(\d+)$/);
        if (match) {
          const num = parseInt(match[1]);
          if (num > maxNumber) maxNumber = num;
        }
      }
    });

    const date = new Date(currentPhieu['NGAYNHAP_XUAT']);
    const yy = date.getFullYear().toString().slice(-2);
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    const yearMonthDay = `${yy}${mm}${dd}`;

    // ✅ LOGIC PARSE KÍCH THƯỚC TỪ NHÓM HÀNG
    let day = '', rong = '', dai = '';
    const nhomHang = currentChiTiet['NHOM_HANG'];

    if (nhomHang) {
      // Ưu tiên tìm trong DMHH
      const nhomHangInfo = dmhh.find(item => item['NHOM_HANG'] === nhomHang);
      if (nhomHangInfo) {
        day = nhomHangInfo['DAY'];
        rong = nhomHangInfo['RONG'];
        dai = nhomHangInfo['DAI'];
      } else {
        // Parse từ string nếu đúng format A*B*C
        const parts = nhomHang.split('*');
        if (parts.length === 3) {
          day = parseFloat(parts[0]) || '';
          rong = parseFloat(parts[1]) || '';
          dai = parseFloat(parts[2]) || '';
        }
      }
    }

    for (let i = 0; i < soKien; i++) {
      const nextNumber = (maxNumber + i + 1).toString().padStart(5, '0');
      const maKien = `K-${yearMonthDay}-${nextNumber}`;

      // ✅ THAY ĐỔI: Cho phép để trống nhóm hàng, tiêu chuẩn, đội hàng khô
      const chiTiet = {
        'ID_CT': Date.now() + i,
        'SOPHIEU': currentPhieu['SOPHIEU'],
        'NGHIEP_VU': 'NHAP',
        'KHO_XUAT': '',
        'KHO_NHAP': currentPhieu['KHONHAP'],
        'NGAY_NHAP_XUAT': currentPhieu['NGAYNHAP_XUAT'],
        'NHOM_HANG': currentChiTiet['NHOM_HANG'] || '', // ✅ Có thể trống
        'MA_KIEN': maKien,
        'DAY': day, // ✅ Đã tự động điền
        'RONG': rong,
        'DAI': dai,
        'THANH': '',
        'SO_KHOI': 0,
        'TIEU_CHUAN': currentChiTiet['TIEU_CHUAN'] || '', // ✅ Có thể trống
        'DOI_HANG_KHO': currentChiTiet['DOI_HANG_KHO'] || '', // ✅ Có thể trống
        'DONGIA': 0,
        'THANHTIEN': 0,
        'GHICHU': ''
      };

      newChiTietList.push(chiTiet);
    }

    setChiTietList(prev => [...prev, ...newChiTietList]);

    toast.success(`Đã thêm ${soKien} kiện vào danh sách`);

    // ✅ RESET FORM
    setCurrentChiTiet({
      'NHOM_HANG': '',
      'SO_KIEN': '',
      'DONGIA': 0,
      'TIEU_CHUAN': '',
      'DOI_HANG_KHO': ''
    });
    setNhomHangSearchTerm('');
    setSelectedNhomHangInfo(null);
  };

  // ✅ HÀM MỚI: Cập nhật nhóm hàng từ kích thước
  const updateNhomHangFromSize = (index, day, rong, dai) => {
    const newChiTietList = [...chiTietList];

    if (day && rong && dai) {
      const nhomHang = `${day}*${rong}*${dai}`;
      newChiTietList[index]['NHOM_HANG'] = nhomHang;
    }

    setChiTietList(newChiTietList);
  };

  // ✅ THAY ĐỔI: Hỗ trợ cập nhật nhóm hàng từ kích thước VÀ TỰ ĐỘNG ĐIỀN KÍCH THƯỚC KHI CHỌN NHÓM HÀNG
  const handleUpdateChiTietField = (index, field, value) => {
    const newChiTietList = [...chiTietList];
    newChiTietList[index][field] = value;

    // ✅ TỰ ĐỘNG ĐIỀN KÍCH THƯỚC KHI CHỌN NHÓM HÀNG
    if (field === 'NHOM_HANG' && value) {
      // Tìm thông tin nhóm hàng trong DMHH
      const nhomHangInfo = dmhh.find(item => item['NHOM_HANG'] === value);

      if (nhomHangInfo) {
        // Tự động điền kích thước
        newChiTietList[index]['DAY'] = nhomHangInfo['DAY'] || '';
        newChiTietList[index]['RONG'] = nhomHangInfo['RONG'] || '';
        newChiTietList[index]['DAI'] = nhomHangInfo['DAI'] || '';
      } else {
        // Nếu không tìm thấy trong DMHH, thử parse từ tên nhóm hàng (format: DÀY*RỘNG*DÀI)
        const parts = value.split('*');
        if (parts.length === 3) {
          const day = parseFloat(parts[0]);
          const rong = parseFloat(parts[1]);
          const dai = parseFloat(parts[2]);

          if (!isNaN(day) && !isNaN(rong) && !isNaN(dai)) {
            newChiTietList[index]['DAY'] = day;
            newChiTietList[index]['RONG'] = rong;
            newChiTietList[index]['DAI'] = dai;
          }
        }
      }
    }

    // ✅ Tự động cập nhật nhóm hàng khi thay đổi kích thước
    if (['DAY', 'RONG', 'DAI'].includes(field)) {
      const day = field === 'DAY' ? value : newChiTietList[index]['DAY'];
      const rong = field === 'RONG' ? value : newChiTietList[index]['RONG'];
      const dai = field === 'DAI' ? value : newChiTietList[index]['DAI'];

      if (day && rong && dai) {
        newChiTietList[index]['NHOM_HANG'] = `${day}*${rong}*${dai}`;
      }
    }

    // Tính toán số khối khi thay đổi số thanh
    if (field === 'THANH') {
      const day = parseFloat(newChiTietList[index]['DAY']) || 0;
      const rong = parseFloat(newChiTietList[index]['RONG']) || 0;
      const dai = parseFloat(newChiTietList[index]['DAI']) || 0;
      const soThanh = parseFloat(value) || 0;
      newChiTietList[index]['SO_KHOI'] = (day * rong * dai * soThanh) / 1000000000;
    }

    setChiTietList(newChiTietList);
    updateTongKhoiLuong(newChiTietList);
  };

  const updateTongKhoiLuong = (chiTietArray) => {
    const tongKhoiLuong = chiTietArray.reduce((sum, item) => sum + (parseFloat(item['SO_KHOI']) || 0), 0);
    setCurrentPhieu(prev => ({
      ...prev,
      'TONGKHOILUONG': tongKhoiLuong
    }));
  };

  const updateTongTien = (chiTietArray) => {
    // Tổng tiền hàng (Chưa VAT)
    const thanhTien = chiTietArray.reduce((sum, item) => sum + (parseFloat(item['THANHTIEN']) || 0), 0);
    const tongKhoiLuong = chiTietArray.reduce((sum, item) => sum + (parseFloat(item['SO_KHOI']) || 0), 0);

    // Tính VAT và Tổng tiền thanh toán
    const ptVat = parseFloat(currentPhieu['PT VAT']) || 0;
    const tienVat = Math.round(thanhTien * (ptVat / 100)); // Làm tròn tiền VNĐ
    const tongTien = thanhTien + tienVat;

    setCurrentPhieu(prev => ({
      ...prev,
      'THANHTIEN': thanhTien,
      'TIEN VAT': tienVat,
      'TONGTIEN': tongTien,
      'TONGKHOILUONG': tongKhoiLuong
    }));
  };

  const handleRemoveChiTiet = (index) => {
    const newChiTietList = chiTietList.filter((_, i) => i !== index);
    setChiTietList(newChiTietList);

    // ✅ Xóa error của dòng đó
    const newErrors = { ...maKienErrors };
    delete newErrors[index];

    // Cập nhật lại index cho các error còn lại
    const updatedErrors = {};
    Object.keys(newErrors).forEach(key => {
      const oldIndex = parseInt(key);
      if (oldIndex > index) {
        updatedErrors[oldIndex - 1] = newErrors[key];
      } else {
        updatedErrors[oldIndex] = newErrors[key];
      }
    });
    setMaKienErrors(updatedErrors);

    if (currentPhieu['NGHIEP_VU'] === 'NHAP') {
      updateTongKhoiLuong(newChiTietList);
    } else {
      updateTongTien(newChiTietList);
    }
    toast.info('Đã xóa chi tiết');
  };

  const handleUpdateDonGia = (index, newDonGia) => {
    const newChiTietList = [...chiTietList];
    newChiTietList[index]['DONGIA'] = parseFloat(newDonGia) || 0;
    newChiTietList[index]['THANHTIEN'] = newChiTietList[index]['SO_KHOI'] * newChiTietList[index]['DONGIA'];
    setChiTietList(newChiTietList);
    updateTongTien(newChiTietList);
  };

  const handleOpenModal = (phieu = null) => {
    if (phieu) {
      setIsEditMode(true);
      setOriginalSoPhieu(phieu['SOPHIEU']);
      // Sử dụng trực tiếp chuỗi ngày từ database (đã ở định dạng YYYY-MM-DD)
      // Convert sag Local Time để đảm bảo đúng ngày (tránh lỗi UTC lùi 1 ngày)
      const phieuDate = (() => {
        if (!phieu['NGAYNHAP_XUAT']) {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }

        try {
          const dateObj = new Date(phieu['NGAYNHAP_XUAT']);
          if (isNaN(dateObj.getTime())) return '';

          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        } catch {
          return '';
        }
      })();

      setCurrentPhieu({
        'SOPHIEU': phieu['SOPHIEU'] || '',
        'NGHIEP_VU': phieu['NGHIEP_VU'] || 'NHAP',
        'NGAYNHAP_XUAT': phieuDate,
        'NCC_KHACHHANG': phieu['NCC_KHACHHANG'] || '',
        'KHOXUAT': phieu['KHOXUAT'] || '',
        'KHONHAP': phieu['KHONHAP'] || '',
        'NGUOIPHUTRACH': phieu['NGUOIPHUTRACH'] || '',
        'TONGKHOILUONG': phieu['TONGKHOILUONG'] || 0,
        'THANHTIEN': phieu['THANHTIEN'] || 0,
        'PT VAT': phieu['PT VAT'] || 0,
        'TIEN VAT': phieu['TIEN VAT'] || 0,
        'TONGTIEN': phieu['TONGTIEN'] || 0,
        'DIENGIAI': phieu['DIENGIAI'] || ''
      });
      setCustomerSearchTerm(phieu['NCC_KHACHHANG'] || '');

      loadChiTiet(phieu['SOPHIEU']);
    } else {
      setIsEditMode(false);
      setOriginalSoPhieu('');
      // Lấy ngày hiện tại đúng theo local timezone
      const now = new Date();
      const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      const newSoPhieu = generateSoPhieu('NHAP', todayStr);
      const nguoiPhuTrach = currentUser ? (currentUser['Họ và Tên'] || currentUser.username) : '';

      const defaultKho = khoList.length > 0 ? khoList[0]['KHO'] : '';

      const defaultCustomer = customers.find(c =>
        c['TEN_KHACHHANG'] === 'XƯỞNG CƯA HOÀNG NGUYÊN LONG' ||
        c['MA_KH'] === 'NCC-HNL-0001' ||
        (c['TEN_KHACHHANG'] && c['TEN_KHACHHANG'].includes('XƯỞNG CƯA HOÀNG NGUYÊN LONG'))
      );
      const defaultCustomerName = defaultCustomer ? defaultCustomer['TEN_KHACHHANG'] : '';

      setCurrentPhieu({
        'SOPHIEU': newSoPhieu,
        'NGHIEP_VU': 'NHAP',
        'NGAYNHAP_XUAT': todayStr,
        'NCC_KHACHHANG': defaultCustomerName,
        'KHOXUAT': '',
        'KHONHAP': defaultKho,
        'NGUOIPHUTRACH': nguoiPhuTrach,
        'TONGKHOILUONG': 0,
        'THANHTIEN': 0,
        'PT VAT': 0,
        'TIEN VAT': 0,
        'TONGTIEN': 0,
        'DIENGIAI': ''
      });
      setCustomerSearchTerm(defaultCustomerName);
      setChiTietList([]);

      const defaultTieuChuan = tieuChuanList.length > 0 ? tieuChuanList[0]['TIEU_CHUAN'] : '';
      const defaultDoiHangKho = doiHangKhoList.length > 0 ? doiHangKhoList[0]['DOI_HANG_KHO'] : '';
      setCurrentChiTiet({
        'NHOM_HANG': '',
        'SO_KIEN': '',
        'DONGIA': 0,
        'TIEU_CHUAN': defaultTieuChuan,
        'DOI_HANG_KHO': defaultDoiHangKho
      });
    }
    setMaKienErrors({});
    setShowModal(true);
  };

  const handleOpenDetailModal = (phieu) => {
    setCurrentPhieu(phieu);
    setCustomerSearchTerm(phieu['NCC_KHACHHANG'] || '');
    loadChiTiet(phieu['SOPHIEU']);
    setShowDetailModal(true);
  };

  const loadChiTiet = async (soPhieu) => {
    try {
      const response = await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {});
      const filtered = response.filter(item => item['SOPHIEU'] === soPhieu);
      setChiTietList(filtered);
    } catch (error) {
      console.error('Error loading chi tiet:', error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowDetailModal(false);
    setIsEditMode(false);
    setOriginalSoPhieu('');
    setCurrentPhieu({
      'SOPHIEU': '',
      'NGHIEP_VU': 'NHAP',
      'NGAYNHAP_XUAT': new Date().toISOString().split('T')[0],
      'NCC_KHACHHANG': '',
      'KHOXUAT': '',
      'KHONHAP': '',
      'NGUOIPHUTRACH': '',
      'TONGKHOILUONG': 0,
      'THANHTIEN': 0,
      'PT VAT': 0,
      'TIEN VAT': 0,
      'TONGTIEN': 0,
      'DIENGIAI': ''
    });
    setCustomerSearchTerm('');
    setChiTietList([]);
    setCurrentChiTiet({
      'NHOM_HANG': '',
      'SO_KIEN': '',
      'DONGIA': 0,
      'TIEU_CHUAN': '',
      'DOI_HANG_KHO': ''
    });
    setNhomHangSearchTerm('');
    setSelectedNhomHangInfo(null);
    setShowCustomerDropdown(false);
    setShowNhomHangDropdown(false);
    setAvailableKien([]);
    setKienSearchTerm('');
    setSelectedDay('');
    setSelectedTieuChuanXuat(''); // ✅ RESET TIÊU CHUẨN XUẤT KHO
    setMaKienErrors({});
  };

  const handleInputChange = (field, value) => {
    setCurrentPhieu(prev => {
      const newState = {
        ...prev,
        [field]: value
      };

      // Xử lý tính toán lại khi thay đổi PT VAT
      if (field === 'PT VAT') {
        const thanhTien = parseFloat(prev['THANHTIEN']) || 0;
        const ptVat = parseFloat(value) || 0;
        const tienVat = Math.round(thanhTien * (ptVat / 100));
        const tongTien = thanhTien + tienVat;

        newState['TIEN VAT'] = tienVat;
        newState['TONGTIEN'] = tongTien;
      }

      return newState;
    });

    if (field === 'KHOXUAT') {
      setSelectedDay('');
      setSelectedTieuChuanXuat(''); // ✅ RESET TIÊU CHUẨN
      setAvailableKien([]);
      setKienSearchTerm('');
    }

    if (field === 'NGHIEP_VU') {
      const defaultKho = khoList.length > 0 ? khoList[0]['KHO'] : '';

      let customerValue = currentPhieu['NCC_KHACHHANG'];

      if (value === 'NHAP') {
        if (!customerValue || customerValue.trim() === '') {
          const defaultCustomer = customers.find(c =>
            c['TEN_KHACHHANG'] === 'XƯỞNG CƯA HOÀNG NGUYÊN LONG' ||
            c['MA_KH'] === 'NCC-HNL-0001' ||
            (c['TEN_KHACHHANG'] && c['TEN_KHACHHANG'].includes('XƯỞNG CƯA HOÀNG NGUYÊN LONG'))
          );
          customerValue = defaultCustomer ? defaultCustomer['TEN_KHACHHANG'] : '';
          setCustomerSearchTerm(customerValue);
        }
      } else if (value === 'XUAT') {
        customerValue = '';
        setCustomerSearchTerm('');
      }

      setCurrentPhieu(prev => ({
        ...prev,
        'NCC_KHACHHANG': customerValue,
        'KHONHAP': value === 'NHAP' ? defaultKho : '',
        'KHOXUAT': value === 'XUAT' ? defaultKho : ''
      }));
    }

    if ((field === 'NGHIEP_VU' || field === 'NGAYNHAP_XUAT') && !isEditMode) {
      const nghiepVu = field === 'NGHIEP_VU' ? value : currentPhieu['NGHIEP_VU'];
      const ngayNhapXuat = field === 'NGAYNHAP_XUAT' ? value : currentPhieu['NGAYNHAP_XUAT'];
      const newSoPhieu = generateSoPhieu(nghiepVu, ngayNhapXuat);
      setCurrentPhieu(prev => ({
        ...prev,
        'SOPHIEU': newSoPhieu
      }));
    }
  };

  const handleCustomerInputChange = (value) => {
    setCustomerSearchTerm(value);
    setCurrentPhieu(prev => ({
      ...prev,
      'NCC_KHACHHANG': value
    }));
    setShowCustomerDropdown(true);
  };

  const handleNhomHangInputChange = (value) => {
    setNhomHangSearchTerm(value);
    setShowNhomHangDropdown(true);
  };

  const validatePhieu = (phieu) => {
    const errors = [];

    if (!phieu['SOPHIEU']) {
      errors.push('Số phiếu không được để trống');
    }

    if (!phieu['NGAYNHAP_XUAT']) {
      errors.push('Ngày nhập/xuất không được để trống');
    }

    if (!phieu['NCC_KHACHHANG'] || phieu['NCC_KHACHHANG'].trim() === '') {
      errors.push(phieu['NGHIEP_VU'] === 'NHAP' ? 'Nhà cung cấp không được để trống' : 'Khách hàng không được để trống');
    }

    if (phieu['NGHIEP_VU'] === 'NHAP' && !phieu['KHONHAP']) {
      errors.push('Kho nhập không được để trống');
    }

    if (phieu['NGHIEP_VU'] === 'XUAT' && !phieu['KHOXUAT']) {
      errors.push('Kho xuất không được để trống');
    }

    if (chiTietList.length === 0) {
      errors.push('Vui lòng thêm ít nhất một chi tiết');
    }

    const hasErrorMaKien = Object.values(maKienErrors).some(error => error !== '');
    if (hasErrorMaKien) {
      errors.push('Có mã kiện bị trùng, vui lòng kiểm tra lại');
    }

    const hasEmptyMaKien = chiTietList.some(item => !item['MA_KIEN'] || item['MA_KIEN'].trim() === '');
    if (hasEmptyMaKien) {
      errors.push('Có kiện chưa có mã kiện, vui lòng kiểm tra lại');
    }

    // ✅ BỎ KIỂM TRA BẮT BUỘC NHÓM HÀNG, TIÊU CHUẨN
    // Chỉ cảnh báo nếu thiếu thông tin quan trọng
    if (phieu['NGHIEP_VU'] === 'NHAP') {
      const invalidItems = chiTietList.filter(item =>
        (!item['DAY'] || !item['RONG'] || !item['DAI']) && !item['NHOM_HANG']
      );
      if (invalidItems.length > 0) {
        errors.push('Có kiện chưa có thông tin kích thước hoặc nhóm hàng');
      }
    }

    return errors;
  };

  // ==================== APPROVAL REQUEST FUNCTIONS ====================

  // Hàm tạo REQUEST_ID
  const generateRequestId = () => {
    const timestamp = Date.now();
    // Tăng độ dài random string để tránh trùng lặp (từ 3 số lên ~9 ký tự alphanumeric)
    const random = Math.random().toString(36).substring(2, 11).toUpperCase();
    return `REQ-${timestamp}-${random}`;
  };

  // ✅ Hàm chuẩn hóa giá trị để so sánh (tránh false positive do kiểu dữ liệu)
  const normalizeValue = (val) => {
    if (val === null || val === undefined || val === '') return '';
    const num = Number(val);
    if (!isNaN(num) && val !== '') return String(num);
    return String(val).trim();
  };

  // Hàm kiểm tra 2 giá trị có thực sự khác nhau không
  const isValueChanged = (oldVal, newVal) => {
    return normalizeValue(oldVal) !== normalizeValue(newVal);
  };

  // ✅ Chuẩn hóa ngày về yyyy-mm-dd (local) để so sánh
  //    DB trả về ISO ("2026-08-05T00:00:00.000Z") còn form trả về "2026-08-05",
  //    nếu so sánh chuỗi thô sẽ luôn báo "đã thay đổi" dù ngày y hệt nhau.
  const toLocalDateStr = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value).trim();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Hàm tạo lịch sử thay đổi
  const createChangeHistory = (oldData, newData) => {
    const changes = [];
    const fields = {
      'KHO_XUAT': 'Kho xuất',
      'KHO_NHAP': 'Kho nhập',
      'MA_KIEN': 'Mã kiện',
      'NHOM_HANG': 'Nhóm hàng',
      'DAY': 'Dày',
      'RONG': 'Rộng',
      'DAI': 'Dài',
      'THANH': 'Số thanh',
      'SO_KHOI': 'Số khối',
      'TIEU_CHUAN': 'Tiêu chuẩn',
      'DOI_HANG_KHO': 'Đội hàng khô',
      'GHICHU': 'Ghi chú',
      'DONGIA': 'Đơn giá',
      'THANHTIEN': 'Thành tiền'
    };

    // ✅ Ngày nhập xuất so sánh theo ngày, hiển thị dạng dd/mm/yyyy
    const ngayCu = toLocalDateStr(oldData['NGAY_NHAP_XUAT']);
    const ngayMoi = toLocalDateStr(newData['NGAY_NHAP_XUAT']);
    if (ngayCu !== ngayMoi) {
      changes.push({
        field: 'Ngày nhập xuất',
        oldValue: formatDate(oldData['NGAY_NHAP_XUAT']),
        newValue: formatDate(newData['NGAY_NHAP_XUAT'])
      });
    }

    for (const [key, label] of Object.entries(fields)) {
      // ✅ Dùng isValueChanged thay vì !== để tránh lỗi kiểu dữ liệu
      if (isValueChanged(oldData[key], newData[key])) {
        changes.push({
          field: label,
          oldValue: String(oldData[key] ?? ''),
          newValue: String(newData[key] ?? '')
        });
      }
    }

    return JSON.stringify(changes);
  };

  // ✅ Hàm ghi AUDIT cho EDIT (đã cập nhật ngay)
  const sendEditAuditRequest = async (editChanges) => {
    try {
      const requestRows = [];
      const currentTime = new Date().toISOString();
      const nguoiYeuCau = currentUser ? (currentUser['Họ và Tên'] || currentUser.username) : '';

      for (const change of editChanges) {
        const { oldData, newData } = change;

        const baseRequest = {
          'REQUEST_ID': generateRequestId(),
          'LOAI_YEU_CAU': 'EDIT',
          'TRANG_THAI_DUYET': 'APPROVED', // ✅ EDIT đã được áp dụng ngay, nên status = APPROVED
          'SOPHIEU': oldData['SOPHIEU'],
          'NGHIEP_VU': oldData['NGHIEP_VU'],
          'NGUOI_YEU_CAU': nguoiYeuCau,
          'THOI_GIAN_YEU_CAU': currentTime,
          'LY_DO_YEU_CAU': 'Sửa đổi chi tiết (đã áp dụng)',
          'NGUOI_DUYET': nguoiYeuCau, // ✅ Tự động "duyệt" vì đã update ngay
          'THOI_GIAN_DUYET': currentTime,
          'LY_DO_TU_CHOI': '',
          'GHI_CHU_DUYET': 'Tự động cập nhật'
        };

        const oldFields = {
          'ID_CT_OLD': oldData['ID_CT'],
          'KHO_XUAT_OLD': oldData['KHO_XUAT'] || '',
          'KHO_NHAP_OLD': oldData['KHO_NHAP'] || '',
          'NGAY_NHAP_XUAT_OLD': oldData['NGAY_NHAP_XUAT'],
          'NHOM_HANG_OLD': oldData['NHOM_HANG'],
          'MA_KIEN_OLD': oldData['MA_KIEN'],
          'DAY_OLD': oldData['DAY'],
          'RONG_OLD': oldData['RONG'],
          'DAI_OLD': oldData['DAI'],
          'THANH_OLD': oldData['THANH'],
          'SO_KHOI_OLD': oldData['SO_KHOI'],
          'TIEU_CHUAN_OLD': oldData['TIEU_CHUAN'],
          'DOI_HANG_KHO_OLD': oldData['DOI_HANG_KHO'],
          'DONGIA_OLD': oldData['DONGIA'],
          'THANHTIEN_OLD': oldData['THANHTIEN'],
          'GHICHU_OLD': oldData['GHICHU'] || ''
        };

        const newFields = {
          'ID_CT_NEW': newData['ID_CT'],
          'KHO_XUAT_NEW': newData['KHO_XUAT'] || '',
          'KHO_NHAP_NEW': newData['KHO_NHAP'] || '',
          'NGAY_NHAP_XUAT_NEW': newData['NGAY_NHAP_XUAT'],
          'NHOM_HANG_NEW': newData['NHOM_HANG'],
          'MA_KIEN_NEW': newData['MA_KIEN'],
          'DAY_NEW': newData['DAY'],
          'RONG_NEW': newData['RONG'],
          'DAI_NEW': newData['DAI'],
          'THANH_NEW': newData['THANH'],
          'SO_KHOI_NEW': newData['SO_KHOI'],
          'TIEU_CHUAN_NEW': newData['TIEU_CHUAN'],
          'DOI_HANG_KHO_NEW': newData['DOI_HANG_KHO'],
          'DONGIA_NEW': newData['DONGIA'],
          'THANHTIEN_NEW': newData['THANHTIEN'],
          'GHICHU_NEW': newData['GHICHU'] || ''
        };

        const lichSu = createChangeHistory(oldData, newData);

        requestRows.push({
          ...baseRequest,
          ...oldFields,
          ...newFields,
          'LICH_SU': lichSu
        });
      }

      // Gửi audit log vào REQUEST
      await authUtils.apiRequestKHO('XUATNHAPKHO_REQUEST', 'Add', {
        "Rows": requestRows
      });

      return true;
    } catch (error) {
      console.error('Error sending edit audit request:', error);
      throw error;
    }
  };

  // Hàm gửi yêu cầu duyệt (chỉ cho ADD/DELETE)
  const sendApprovalRequest = async (changes, lyDoYeuCau = '') => {
    try {
      const requestRows = [];
      const currentTime = new Date().toISOString();
      const nguoiYeuCau = currentUser ? (currentUser['Họ và Tên'] || currentUser.username) : '';

      for (const change of changes) {
        const { type, oldData, newData } = change;

        const baseRequest = {
          'REQUEST_ID': generateRequestId(),
          'LOAI_YEU_CAU': type.toUpperCase(),
          'TRANG_THAI_DUYET': 'PENDING',
          'SOPHIEU': (oldData || newData)['SOPHIEU'],
          'NGHIEP_VU': (oldData || newData)['NGHIEP_VU'],
          'NGUOI_YEU_CAU': nguoiYeuCau,
          'THOI_GIAN_YEU_CAU': currentTime,
          'LY_DO_YEU_CAU': lyDoYeuCau,
          'NGUOI_DUYET': '',
          'THOI_GIAN_DUYET': '',
          'LY_DO_TU_CHOI': '',
          'GHI_CHU_DUYET': ''
        };

        if (type === 'edit') {
          // Dữ liệu CŨ
          const oldFields = {
            'ID_CT_OLD': oldData['ID_CT'],
            'KHO_XUAT_OLD': oldData['KHO_XUAT'] || '',
            'KHO_NHAP_OLD': oldData['KHO_NHAP'] || '',
            'NGAY_NHAP_XUAT_OLD': oldData['NGAY_NHAP_XUAT'],
            'NHOM_HANG_OLD': oldData['NHOM_HANG'],
            'MA_KIEN_OLD': oldData['MA_KIEN'],
            'DAY_OLD': oldData['DAY'],
            'RONG_OLD': oldData['RONG'],
            'DAI_OLD': oldData['DAI'],
            'THANH_OLD': oldData['THANH'],
            'SO_KHOI_OLD': oldData['SO_KHOI'],
            'TIEU_CHUAN_OLD': oldData['TIEU_CHUAN'],
            'DOI_HANG_KHO_OLD': oldData['DOI_HANG_KHO'],
            'DONGIA_OLD': oldData['DONGIA'],
            'THANHTIEN_OLD': oldData['THANHTIEN'],
            'GHICHU_OLD': oldData['GHICHU'] || ''
          };

          // Dữ liệu MỚI
          const newFields = {
            'ID_CT_NEW': newData['ID_CT'],
            'KHO_XUAT_NEW': newData['KHO_XUAT'] || '',
            'KHO_NHAP_NEW': newData['KHO_NHAP'] || '',
            'NGAY_NHAP_XUAT_NEW': newData['NGAY_NHAP_XUAT'],
            'NHOM_HANG_NEW': newData['NHOM_HANG'],
            'MA_KIEN_NEW': newData['MA_KIEN'],
            'DAY_NEW': newData['DAY'],
            'RONG_NEW': newData['RONG'],
            'DAI_NEW': newData['DAI'],
            'THANH_NEW': newData['THANH'],
            'SO_KHOI_NEW': newData['SO_KHOI'],
            'TIEU_CHUAN_NEW': newData['TIEU_CHUAN'],
            'DOI_HANG_KHO_NEW': newData['DOI_HANG_KHO'],
            'DONGIA_NEW': newData['DONGIA'],
            'THANHTIEN_NEW': newData['THANHTIEN'],
            'GHICHU_NEW': newData['GHICHU'] || ''
          };

          const lichSu = createChangeHistory(oldData, newData);

          requestRows.push({
            ...baseRequest,
            ...oldFields,
            ...newFields,
            'LICH_SU': lichSu
          });

        } else if (type === 'delete') {
          // Chỉ có dữ liệu CŨ
          const oldFields = {
            'ID_CT_OLD': oldData['ID_CT'],
            'KHO_XUAT_OLD': oldData['KHO_XUAT'] || '',
            'KHO_NHAP_OLD': oldData['KHO_NHAP'] || '',
            'NGAY_NHAP_XUAT_OLD': oldData['NGAY_NHAP_XUAT'],
            'NHOM_HANG_OLD': oldData['NHOM_HANG'],
            'MA_KIEN_OLD': oldData['MA_KIEN'],
            'DAY_OLD': oldData['DAY'],
            'RONG_OLD': oldData['RONG'],
            'DAI_OLD': oldData['DAI'],
            'THANH_OLD': oldData['THANH'],
            'SO_KHOI_OLD': oldData['SO_KHOI'],
            'TIEU_CHUAN_OLD': oldData['TIEU_CHUAN'],
            'DOI_HANG_KHO_OLD': oldData['DOI_HANG_KHO'],
            'DONGIA_OLD': oldData['DONGIA'],
            'THANHTIEN_OLD': oldData['THANHTIEN'],
            'GHICHU_OLD': oldData['GHICHU'] || ''
          };

          // Dữ liệu MỚI = NULL (nhưng vẫn cần lưu ID_CT_OLD để xóa)
          const newFields = {
            'ID_CT_NEW': null,
            'KHO_XUAT_NEW': '',
            'KHO_NHAP_NEW': '',
            'NGAY_NHAP_XUAT_NEW': '',
            'NHOM_HANG_NEW': '',
            'MA_KIEN_NEW': '',
            'DAY_NEW': null,
            'RONG_NEW': null,
            'DAI_NEW': null,
            'THANH_NEW': null,
            'SO_KHOI_NEW': null,
            'TIEU_CHUAN_NEW': '',
            'DOI_HANG_KHO_NEW': '',
            'DONGIA_NEW': null,
            'THANHTIEN_NEW': null,
            'GHICHU_NEW': ''
          };

          requestRows.push({
            ...baseRequest,
            ...oldFields,
            ...newFields,
            'LICH_SU': JSON.stringify([{
              action: 'Yêu cầu xóa chi tiết',
              timestamp: currentTime
            }])
          });

        } else if (type === 'add') {
          // Chỉ có dữ liệu MỚI (tất cả OLD = null/rỗng)
          const oldFields = {
            'ID_CT_OLD': null,
            'KHO_XUAT_OLD': '',
            'KHO_NHAP_OLD': '',
            'NGAY_NHAP_XUAT_OLD': '', // ← Giữ rỗng vì không có dữ liệu cũ
            'NHOM_HANG_OLD': '',
            'MA_KIEN_OLD': '',
            'DAY_OLD': null,
            'RONG_OLD': null,
            'DAI_OLD': null,
            'THANH_OLD': null,
            'SO_KHOI_OLD': null,
            'TIEU_CHUAN_OLD': '',
            'DOI_HANG_KHO_OLD': '',
            'DONGIA_OLD': null,
            'THANHTIEN_OLD': null,
            'GHICHU_OLD': ''
          };

          const newFields = {
            'ID_CT_NEW': newData['ID_CT'],
            'KHO_XUAT_NEW': newData['KHO_XUAT'] || '',
            'KHO_NHAP_NEW': newData['KHO_NHAP'] || '',
            'NGAY_NHAP_XUAT_NEW': newData['NGAY_NHAP_XUAT'],
            'NHOM_HANG_NEW': newData['NHOM_HANG'],
            'MA_KIEN_NEW': newData['MA_KIEN'],
            'DAY_NEW': newData['DAY'],
            'RONG_NEW': newData['RONG'],
            'DAI_NEW': newData['DAI'],
            'THANH_NEW': newData['THANH'],
            'SO_KHOI_NEW': newData['SO_KHOI'],
            'TIEU_CHUAN_NEW': newData['TIEU_CHUAN'],
            'DOI_HANG_KHO_NEW': newData['DOI_HANG_KHO'],
            'DONGIA_NEW': newData['DONGIA'],
            'THANHTIEN_NEW': newData['THANHTIEN'],
            'GHICHU_NEW': newData['GHICHU'] || ''
          };

          requestRows.push({
            ...baseRequest,
            ...oldFields,
            ...newFields,
            'LICH_SU': JSON.stringify([{
              action: 'Yêu cầu thêm mới chi tiết',
              timestamp: currentTime
            }])
          });
        }
      }

      // Gửi tất cả yêu cầu
      await authUtils.apiRequestKHO('XUATNHAPKHO_REQUEST', 'Add', {
        "Rows": requestRows
      });

      return true;
    } catch (error) {
      console.error('Error sending approval request:', error);
      throw error;
    }
  };

  // Hàm xử lý xác nhận gửi yêu cầu duyệt
  const handleConfirmApprovalRequest = async () => {
    if (!pendingChanges) return;

    if (!lyDoYeuCau.trim()) {
      toast.error('Vui lòng nhập lý do yêu cầu thay đổi');
      return;
    }

    try {
      setIsSubmitting(true);

      // Gửi yêu cầu duyệt
      await sendApprovalRequest(pendingChanges.changes, lyDoYeuCau);

      toast.success(`Đã gửi ${pendingChanges.changes.length} yêu cầu duyệt thành công! Vui lòng chờ admin phê duyệt.`);

      setShowApprovalConfirm(false);
      setPendingChanges(null);
      setLyDoYeuCau('');
      handleCloseModal();

    } catch (error) {
      console.error('Error sending approval request:', error);
      toast.error('Có lỗi khi gửi yêu cầu duyệt: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ HÀM MỚI: Copy dòng chi tiết
  const handleCopyChiTiet = (index) => {
    const itemToCopy = chiTietList[index];

    // Tạo mã kiện mới
    const date = new Date(currentPhieu['NGAYNHAP_XUAT']);
    const yy = date.getFullYear().toString().slice(-2);
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    const yearMonthDay = `${yy}${mm}${dd}`;

    const allKien = [...tonKho, ...chiTietList];
    let maxNumber = 0;

    allKien.forEach(k => {
      if (k['MA_KIEN']) {
        const match = k['MA_KIEN'].match(/-(\d+)$/);
        if (match) {
          const num = parseInt(match[1]);
          if (num > maxNumber) maxNumber = num;
        }
      }
    });

    const nextNumber = (maxNumber + 1).toString().padStart(5, '0');
    const newMaKien = `K-${yearMonthDay}-${nextNumber}`;

    // Copy dòng với mã kiện mới
    const copiedItem = {
      ...itemToCopy,
      'ID_CT': Date.now(),
      'MA_KIEN': newMaKien
    };

    // Chèn dòng copy ngay dưới dòng gốc
    const newChiTietList = [...chiTietList];
    newChiTietList.splice(index + 1, 0, copiedItem);

    setChiTietList(newChiTietList);

    if (currentPhieu['NGHIEP_VU'] === 'NHAP') {
      updateTongKhoiLuong(newChiTietList);
    } else {
      updateTongTien(newChiTietList);
    }

    toast.success('Đã copy dòng thành công');
  };

  // ✅ HÀM MỚI: Kiểm tra và thêm nhóm hàng vào DMHH nếu chưa tồn tại
  const checkAndAddNhomHangToDMHH = async (nhomHang, day, rong, dai) => {
    if (!nhomHang || !day || !rong || !dai) return;

    // Kiểm tra xem nhóm hàng đã tồn tại chưa
    const exists = dmhh.find(item => item['NHOM_HANG'] === nhomHang);

    if (!exists) {
      try {
        const newDMHH = {
          'NHOM_HANG': nhomHang,
          'DAY': parseFloat(day),
          'RONG': parseFloat(rong),
          'DAI': parseFloat(dai),
          'DONGIA_HIEULUC': 0
        };

        await authUtils.apiRequestKHO('DMHH', 'Add', {
          "Rows": [newDMHH]
        });

        // Cập nhật lại danh sách DMHH
        await fetchDMHH();

        console.log(`✅ Đã thêm nhóm hàng mới vào DMHH: ${nhomHang}`);
      } catch (error) {
        console.error('Error adding nhom hang to DMHH:', error);
        toast.warning(`Không thể thêm nhóm hàng ${nhomHang} vào DMHH`);
      }
    }
  };


  const handleSavePhieu = async () => {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      const errors = validatePhieu(currentPhieu);
      if (errors.length > 0) {
        toast.error(errors.join('\n'));
        setIsSubmitting(false);
        return;
      }

      // ✅ THÊM: Kiểm tra và thêm nhóm hàng mới vào DMHH
      if (currentPhieu['NGHIEP_VU'] === 'NHAP') {
        for (const item of chiTietList) {
          if (item['NHOM_HANG'] && item['DAY'] && item['RONG'] && item['DAI']) {
            await checkAndAddNhomHangToDMHH(
              item['NHOM_HANG'],
              item['DAY'],
              item['RONG'],
              item['DAI']
            );
          }
        }
      }

      const phieuToSave = { ...currentPhieu };

      // ✅ ĐỒNG BỘ THÔNG TIN HEADER VÀO CHI TIẾT
      // Đảm bảo số phiếu, ngày, kho,... của chi tiết luôn khớp với phiếu ngay cả khi user thay đổi thông tin phiếu trong quá trình nhập
      const updatedChiTietList = chiTietList.map(item => ({
        ...item,
        'SOPHIEU': phieuToSave['SOPHIEU'],
        'NGAY_NHAP_XUAT': phieuToSave['NGAYNHAP_XUAT'],
        'KHO_XUAT': phieuToSave['KHOXUAT'],
        'KHO_NHAP': phieuToSave['KHONHAP'],
        'NGHIEP_VU': phieuToSave['NGHIEP_VU']
      }));

      if (isEditMode) {
        // ✅ PHÁT HIỆN THAY ĐỔI
        const chiTietResponse = await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {});
        const oldChiTiet = chiTietResponse.filter(item => item['SOPHIEU'] === originalSoPhieu);

        const changes = [];

        // ✅ Các trường THỰC SỰ cần so sánh (bỏ qua các trường header tự động đồng bộ)
        const COMPARE_FIELDS = [
          'KHO_XUAT', 'KHO_NHAP',
          'MA_KIEN', 'NHOM_HANG',
          'DAY', 'RONG', 'DAI', 'THANH', 'SO_KHOI',
          'TIEU_CHUAN', 'DOI_HANG_KHO',
          'DONGIA', 'THANHTIEN', 'GHICHU'
        ];

        // ✅ TÁCH LOGIC: EDIT vs ADD/DELETE
        // - EDIT: cập nhật ngay + ghi REQUEST (để admin có thể reject revert)
        // - ADD/DELETE: chờ admin duyệt

        const editChanges = []; // Cập nhật ngay
        const pendingChanges = []; // Chờ duyệt

        // So sánh chi tiết cũ và mới
        updatedChiTietList.forEach(newItem => {
          const oldItem = oldChiTiet.find(old => old['ID_CT'] === newItem['ID_CT']);

          if (oldItem) {
            // ✅ Chỉ so sánh các trường nghiệp vụ thực sự, dùng isValueChanged để chuẩn hóa kiểu
            // ✅ NGAY_NHAP_XUAT so sánh riêng theo ngày (yyyy-mm-dd): nếu bỏ qua, khi user chỉ đổi
            //    ngày phiếu thì header đổi mà chi tiết giữ ngày cũ → Báo cáo tồn kho (lọc theo ngày
            //    chi tiết) lệch với trang Nhập Xuất Kho (lọc theo ngày phiếu).
            const hasChanges =
              COMPARE_FIELDS.some(key => isValueChanged(oldItem[key], newItem[key])) ||
              toLocalDateStr(oldItem['NGAY_NHAP_XUAT']) !== toLocalDateStr(newItem['NGAY_NHAP_XUAT']);

            if (hasChanges) {
              editChanges.push({
                type: 'edit',
                oldData: oldItem,
                newData: newItem
              });
            }
            // else: không thay đổi gì → bỏ qua, KHÔNG gửi request
          } else {
            // Chi tiết mới (ID_CT chưa tồn tại trong DB)
            // ADD: chờ duyệt
            pendingChanges.push({
              type: 'add',
              oldData: null,
              newData: newItem
            });
          }
        });

        // Tìm chi tiết bị xóa
        // DELETE: chờ duyệt
        oldChiTiet.forEach(oldItem => {
          const exists = updatedChiTietList.find(newItem => newItem['ID_CT'] === oldItem['ID_CT']);
          if (!exists) {
            pendingChanges.push({
              type: 'delete',
              oldData: oldItem,
              newData: null
            });
          }
        });

        // ✅ STEP 1: Áp dụng EDIT ngay vào DB
        if (editChanges.length > 0) {
          const editRows = editChanges.map(change => ({
            'ID_CT': change.oldData['ID_CT'],
            'SOPHIEU': change.oldData['SOPHIEU'],
            'NGHIEP_VU': change.oldData['NGHIEP_VU'],
            'KHO_XUAT': change.newData['KHO_XUAT'],
            'KHO_NHAP': change.newData['KHO_NHAP'],
            'NGAY_NHAP_XUAT': change.newData['NGAY_NHAP_XUAT'],
            'NHOM_HANG': change.newData['NHOM_HANG'],
            'MA_KIEN': change.newData['MA_KIEN'],
            'DAY': change.newData['DAY'],
            'RONG': change.newData['RONG'],
            'DAI': change.newData['DAI'],
            'THANH': change.newData['THANH'],
            'SO_KHOI': change.newData['SO_KHOI'],
            'TIEU_CHUAN': change.newData['TIEU_CHUAN'],
            'DOI_HANG_KHO': change.newData['DOI_HANG_KHO'],
            'DONGIA': change.newData['DONGIA'],
            'THANHTIEN': change.newData['THANHTIEN'],
            'GHICHU': change.newData['GHICHU']
          }));

          await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Edit', {
            "Rows": editRows
          });
        }

        // ✅ STEP 2: Ghi EDIT vào REQUEST (để audit + cho phép admin reject/revert)
        if (editChanges.length > 0) {
          await sendEditAuditRequest(editChanges);
        }

        let phieuHeaderToUpdate = { ...phieuToSave };

        // ✅ LOGIC CẬP NHẬT HEADER:
        // - Nếu có EDIT: tính từ dữ liệu mới (đã update)
        // - Nếu có ADD/DELETE chờ duyệt: giữ nguyên tạm thời
        if (editChanges.length > 0) {
          // EDIT đã được apply → tính toán lại header từ dữ liệu mới
          const updatedChiTiet = updatedChiTietList.filter(item => item['SOPHIEU'] === originalSoPhieu);
          const tongKhoiLuong = updatedChiTiet.reduce((sum, item) => sum + (parseFloat(item['SO_KHOI']) || 0), 0);
          const thanhTien = updatedChiTiet.reduce((sum, item) => sum + (parseFloat(item['THANHTIEN']) || 0), 0);

          const ptVat = parseFloat(phieuToSave['PT VAT']) || 0;
          const tienVat = Math.round(thanhTien * (ptVat / 100));
          const tongTien = thanhTien + tienVat;

          phieuHeaderToUpdate['TONGKHOILUONG'] = tongKhoiLuong;
          phieuHeaderToUpdate['THANHTIEN'] = thanhTien;
          phieuHeaderToUpdate['PT VAT'] = ptVat;
          phieuHeaderToUpdate['TIEN VAT'] = tienVat;
          phieuHeaderToUpdate['TONGTIEN'] = tongTien;
        } else if (pendingChanges.length > 0) {
          // ADD/DELETE chờ duyệt: giữ nguyên tạm thời
          const originalPhieu = phieuList.find(p => p['SOPHIEU'] === originalSoPhieu);
          if (originalPhieu) {
            phieuHeaderToUpdate['TONGKHOILUONG'] = originalPhieu['TONGKHOILUONG'];
            const oldThanhTien = parseFloat(originalPhieu['THANHTIEN']) || 0;
            phieuHeaderToUpdate['THANHTIEN'] = oldThanhTien;

            const newPtVat = parseFloat(phieuToSave['PT VAT']) || 0;
            const newTienVat = Math.round(oldThanhTien * (newPtVat / 100));
            const newTongTien = oldThanhTien + newTienVat;

            phieuHeaderToUpdate['PT VAT'] = newPtVat;
            phieuHeaderToUpdate['TIEN VAT'] = newTienVat;
            phieuHeaderToUpdate['TONGTIEN'] = newTongTien;
          }
        }

        // ✅ CẬP NHẬT THÔNG TIN PHIẾU (HEADER) TRƯỚC
        await authUtils.apiRequestKHO('XUATNHAPKHO', 'Edit', {
          "Rows": [phieuHeaderToUpdate]
        });
        await fetchPhieuList(); // Refresh lại danh sách phiếu

        if (pendingChanges.length > 0) {
          // ✅ CÓ THAY ĐỔI ADD/DELETE -> GỬI YÊU CẦU DUYỆT
          setPendingChanges({ phieu: phieuToSave, changes: pendingChanges });
          setShowApprovalConfirm(true);
          setIsSubmitting(false);
          toast.success('Đã cập nhật thông tin phiếu. Có thay đổi ở chi tiết cần xác nhận gửi yêu cầu duyệt.');
          return;
        } else {
          toast.success('Cập nhật thông tin phiếu thành công!');
        }
      } else {
        // ✅ TẠO MỚI - KHÔNG CẦN DUYỆT
        const existingPhieu = phieuList.find(
          p => p['SOPHIEU'] === phieuToSave['SOPHIEU']
        );

        if (existingPhieu) {
          toast.error('Số phiếu này đã tồn tại!');
          setIsSubmitting(false);
          return;
        }

        await authUtils.apiRequestKHO('XUATNHAPKHO', 'Add', {
          "Rows": [phieuToSave]
        });

        await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Add', {
          "Rows": updatedChiTietList
        });

        toast.success('Thêm phiếu mới thành công!');
      }

      await fetchPhieuList();
      await fetchTonKho();
      handleCloseModal();
    } catch (error) {
      console.error('Error saving phieu:', error);
      toast.error('Có lỗi xảy ra: ' + (error.message || 'Không thể lưu phiếu'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenRequestHistory = async () => {
    setShowRequestHistoryModal(true);
    await fetchRequestHistory();
  };

  const handleViewRequestDetail = (request) => {
    setSelectedRequest(request);
    setShowRequestDetailModal(true);
  };

  const getStatusBadge = (status) => {
    const badges = {
      'PENDING': { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Chờ duyệt', icon: '⏳' },
      'APPROVED': { bg: 'bg-green-100', text: 'text-green-800', label: 'Đã duyệt', icon: '✓' },
      'REJECTED': { bg: 'bg-red-100', text: 'text-red-800', label: 'Từ chối', icon: '✗' }
    };
    const badge = badges[status] || badges['PENDING'];
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
        <span className="mr-1">{badge.icon}</span>
        {badge.label}
      </span>
    );
  };

  const getTypeBadge = (type) => {
    const badges = {
      'ADD': { bg: 'bg-green-100', text: 'text-green-800', label: 'Thêm mới', icon: <Plus className="w-3 h-3" /> },
      'EDIT': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Sửa đổi', icon: <Edit className="w-3 h-3" /> },
      'DELETE': { bg: 'bg-red-100', text: 'text-red-800', label: 'Xóa', icon: <Trash className="w-3 h-3" /> }
    };
    const badge = badges[type] || badges['EDIT'];
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
        {badge.icon}
        <span className="ml-1">{badge.label}</span>
      </span>
    );
  };


  const handleOpenDeleteConfirmation = (phieu) => {
    setPhieuToDelete(phieu);
    setShowDeleteConfirmation(true);
  };

  const handleCloseDeleteConfirmation = () => {
    setShowDeleteConfirmation(false);
    setPhieuToDelete(null);
  };

  const handleDeletePhieu = async () => {
    if (!phieuToDelete) return;

    try {
      setIsSubmitting(true); // ✅ BẬT LOADING

      // ✅ BƯỚC 1: Lấy danh sách chi tiết
      toast.info('Đang kiểm tra chi tiết phiếu...');
      const chiTietResponse = await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Find', {});
      const chiTietOfPhieu = chiTietResponse.filter(item => item['SOPHIEU'] === phieuToDelete['SOPHIEU']);

      // ✅ BƯỚC 2: Xóa chi tiết (nếu có)
      if (chiTietOfPhieu.length > 0) {
        toast.info(`Đang xóa ${chiTietOfPhieu.length} chi tiết...`);
        const rowsToDelete = chiTietOfPhieu.map(item => ({ "ID_CT": item['ID_CT'] }));

        await authUtils.apiRequestKHO('XUATNHAPKHO_CHITIET', 'Delete', {
          "Rows": rowsToDelete
        });

        console.log(`✅ Đã xóa ${chiTietOfPhieu.length} chi tiết`);
      }

      // ✅ BƯỚC 3: Xóa phiếu
      toast.info('Đang xóa phiếu...');
      await authUtils.apiRequestKHO('XUATNHAPKHO', 'Delete', {
        "Rows": [{ "SOPHIEU": phieuToDelete['SOPHIEU'] }]
      });

      console.log(`✅ Đã xóa phiếu ${phieuToDelete['SOPHIEU']}`);

      // ✅ BƯỚC 4: Thông báo thành công
      toast.success(
        `Đã xóa phiếu ${phieuToDelete['SOPHIEU']} và ${chiTietOfPhieu.length} chi tiết thành công!`,
        { autoClose: 5000 }
      );

      // ✅ BƯỚC 5: Refresh dữ liệu
      await fetchPhieuList();
      await fetchTonKho();

      handleCloseDeleteConfirmation();
    } catch (error) {
      console.error('❌ Error deleting phieu:', error);
      toast.error('Có lỗi xảy ra khi xóa phiếu: ' + (error.message || ''));
    } finally {
      setIsSubmitting(false); // ✅ TẮT LOADING
    }
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getKienCountForPhieu = (soPhieu) => {
    return tonKho.filter(ct => ct['SOPHIEU'] === soPhieu).length;
  };

  // Tồn kho thực tế: duyệt theo map MA_KIEN, nhập thì thêm kiện, xuất thì lấy kiện ra.
  // Dòng XUAT không tìm thấy mã kiện trong map (xuất trùng, hoặc xuất mã kiện chưa từng nhập)
  // vẫn được trừ vào tồn vì hàng đã thực sự ra khỏi kho. Trang Báo cáo tồn kho tính y hệt cách này.
  const getTonKhoHienTai = () => {
    const tonKhoMap = {};
    const xuatKhongKhop = [];

    tonKho.forEach(item => {
      const maKien = item['MA_KIEN'];
      if (item['NGHIEP_VU'] === 'NHAP') {
        tonKhoMap[maKien] = item;
      } else if (item['NGHIEP_VU'] === 'XUAT') {
        if (tonKhoMap[maKien]) {
          delete tonKhoMap[maKien];
        } else {
          xuatKhongKhop.push(item);
        }
      }
    });

    const tongM3 = (list) => list.reduce((sum, item) => sum + (parseFloat(item['SO_KHOI']) || 0), 0);
    const tonList = Object.values(tonKhoMap);

    return {
      kien: tonList.length - xuatKhongKhop.length,
      m3: tongM3(tonList) - tongM3(xuatKhongKhop)
    };
  };

  const getSortedPhieuList = useCallback(() => {
    const sortableList = [...phieuList];
    if (sortConfig.key) {
      sortableList.sort((a, b) => {
        const keyA = a[sortConfig.key] || '';
        const keyB = b[sortConfig.key] || '';

        if (sortConfig.key === 'NGAYNHAP_XUAT') {
          const dateA = new Date(keyA);
          const dateB = new Date(keyB);
          return sortConfig.direction === 'ascending' ? dateA - dateB : dateB - dateA;
        }

        if (['TONGKHOILUONG', 'TONGTIEN'].includes(sortConfig.key)) {
          const numA = parseFloat(keyA) || 0;
          const numB = parseFloat(keyB) || 0;
          return sortConfig.direction === 'ascending' ? numA - numB : numB - numA;
        }

        if (keyA < keyB) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (keyA > keyB) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableList;
  }, [phieuList, sortConfig]);

  const filteredPhieuList = getSortedPhieuList().filter(phieu => {
    const searchLower = search.toLowerCase();
    const matchesSearch = (
      phieu['SOPHIEU']?.toLowerCase().includes(searchLower) ||
      phieu['NCC_KHACHHANG']?.toLowerCase().includes(searchLower) ||
      phieu['NGUOIPHUTRACH']?.toLowerCase().includes(searchLower)
    );

    const matchesNghiepVu = filterNghiepVu === 'ALL' || phieu['NGHIEP_VU'] === filterNghiepVu;
    const matchesCustomer = filterCustomer === 'ALL' || phieu['NCC_KHACHHANG'] === filterCustomer;

    let matchesDateRange = true;
    if (filterDateFrom || filterDateTo) {
      // Convert sang Local Time để đảm bảo đúng ngày (tránh lỗi UTC lùi 1 ngày)
      let phieuDateStr = '';
      if (phieu['NGAYNHAP_XUAT']) {
        try {
          const dateObj = new Date(phieu['NGAYNHAP_XUAT']);
          if (!isNaN(dateObj.getTime())) {
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            phieuDateStr = `${year}-${month}-${day}`;
          }
        } catch (e) {
          console.error('Error parsing date:', e);
        }
      }
      if (filterDateFrom && phieuDateStr) {
        matchesDateRange = matchesDateRange && phieuDateStr >= filterDateFrom;
      }
      if (filterDateTo && phieuDateStr) {
        matchesDateRange = matchesDateRange && phieuDateStr <= filterDateTo;
      }
    }

    return matchesSearch && matchesNghiepVu && matchesCustomer && matchesDateRange;
  });

  const totalPages = Math.ceil(filteredPhieuList.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPhieuList.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, filterNghiepVu, filterCustomer, filterDateFrom, filterDateTo, itemsPerPage]);

  const goToFirstPage = () => setCurrentPage(1);
  const goToLastPage = () => setCurrentPage(totalPages);
  const goToNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
  const goToPrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
  const goToPage = (page) => setCurrentPage(page);

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <span className="text-gray-400 ml-1">⇅</span>;
    }
    return sortConfig.direction === 'ascending' ?
      <span className="text-blue-600 ml-1">↑</span> :
      <span className="text-blue-600 ml-1">↓</span>;
  };

  const handleRefresh = async () => {
    toast.info('Đang tải lại dữ liệu...');
    await fetchPhieuList();
    await fetchCustomers();
    await fetchKhoList();
    await fetchDMHH();
    await fetchTonKho();
    await fetchTieuChuan();
    await fetchDoiHangKho();
    await fetchGiaBan(); // ✅ THÊM REFRESH BẢNG GIÁ BÁN
    toast.success('Đã tải lại dữ liệu thành công!');
  };

  const tongNhap = phieuList.filter(p => p['NGHIEP_VU'] === 'NHAP').length;
  const tongXuat = phieuList.filter(p => p['NGHIEP_VU'] === 'XUAT').length;
  const tongKhoiLuongNhap = phieuList
    .filter(p => p['NGHIEP_VU'] === 'NHAP')
    .reduce((sum, p) => sum + (parseFloat(p['TONGKHOILUONG']) || 0), 0);
  const tongTienXuat = phieuList
    .filter(p => p['NGHIEP_VU'] === 'XUAT')
    .reduce((sum, p) => sum + (parseFloat(p['TONGTIEN']) || 0), 0);

  const uniqueCustomers = [...new Set(phieuList.map(p => p['NCC_KHACHHANG']).filter(Boolean))];

  return (
    <div className="p-3 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
      <div className="mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-3 md:p-4 mb-4 border border-gray-100">
          {/* Header Section - GIỐNG CŨ, KHÔNG THAY ĐỔI */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-3 gap-3">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg shadow-md">
                <Package className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-gray-800">Quản Lý Nhập Xuất Kho</h1>
                <p className="text-xs md:text-sm text-gray-500 mt-0.5">Quản lý phiếu nhập xuất kho và chi tiết</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {/* <button
                onClick={handleRefresh}
                className="px-3 py-1.5 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm"
                title="Tải lại dữ liệu"
              >
                <RefreshCw className="w-4 h-4" />
                <span className="hidden sm:inline">Làm mới</span>
              </button> */}
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm ${showFilters
                  ? 'bg-purple-50 text-purple-700 border border-purple-200'
                  : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                  }`}
              >
                <Filter className="w-4 h-4" />
                <span className="hidden sm:inline">Bộ lọc</span>
              </button>
              <button
                onClick={() => setShowTieuChuanModal(true)}
                className="px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-lg hover:bg-blue-100 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm"
              >
                <Info className="w-4 h-4" />
                <span className="hidden sm:inline">Tiêu chuẩn</span>
              </button>
              <button
                onClick={() => setShowDoiHangKhoModal(true)}
                className="px-3 py-1.5 bg-indigo-50 text-indigo-700 border border-indigo-200 rounded-lg hover:bg-indigo-100 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm"
              >
                <Users className="w-4 h-4" />
                <span className="hidden sm:inline">Đội hàng khô</span>
              </button>
              <button
                onClick={handleOpenImportModal}
                className="px-3 py-1.5 bg-orange-50 text-orange-700 border border-orange-200 rounded-lg hover:bg-orange-100 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm"
                title="Import từ Excel"
              >
                <Upload className="w-4 h-4" />
                <span className="hidden sm:inline">Import Excel</span>
              </button>

              <button
                onClick={handleOpenRequestHistory}
                className="px-3 py-1.5 bg-yellow-50 text-yellow-700 border border-yellow-200 rounded-lg hover:bg-yellow-100 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm"
                title="Xem lịch sử yêu cầu duyệt"
              >
                <FileText className="w-4 h-4" />
                <span className="hidden sm:inline">Lịch sử yêu cầu</span>
              </button>

              <button
                onClick={handleSyncTotals}
                disabled={isSyncingTotals}
                className="px-3 py-1.5 bg-teal-50 text-teal-700 border border-teal-200 rounded-lg hover:bg-teal-100 flex items-center gap-1.5 transition-all shadow-sm hover:shadow text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                title="Quét & cập nhật lại Tổng khối lượng/Thành tiền theo chi tiết thực tế"
              >
                <RefreshCw className={`w-4 h-4 ${isSyncingTotals ? 'animate-spin' : ''}`} />
                <span className="hidden sm:inline">{isSyncingTotals ? 'Đang đồng bộ...' : 'Đồng bộ tổng'}</span>
              </button>

              <button
                onClick={() => handleOpenModal()}
                className="px-3 py-1.5 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 flex items-center gap-1.5 transition-all shadow-md hover:shadow-lg text-sm font-medium"
              >
                <Plus className="w-4 h-4" />
                <span>Tạo phiếu</span>
              </button>
            </div>
          </div>

          {/* Statistics Cards - GIỐNG CŨ */}
          <div className="grid grid-cols-2 lg:grid-cols-6 gap-2 md:gap-3 mb-3">
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-3 rounded-lg border-l-4 border-green-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <TrendingUp className="w-4 h-4 text-green-600" />
                <p className="text-xs font-medium text-green-700">Phiếu nhập</p>
              </div>
              <p className="text-2xl font-bold text-green-900">
                {filteredPhieuList.filter(p => p['NGHIEP_VU'] === 'NHAP').length}
              </p>
              {(filterNghiepVu !== 'ALL' || filterCustomer !== 'ALL' || filterDateFrom || filterDateTo) && (
                <p className="text-xs text-green-600 mt-0.5">
                  Tổng: {phieuList.filter(p => p['NGHIEP_VU'] === 'NHAP').length}
                </p>
              )}
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 rounded-lg border-l-4 border-red-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <TrendingDown className="w-4 h-4 text-red-600" />
                <p className="text-xs font-medium text-red-700">Phiếu xuất</p>
              </div>
              <p className="text-2xl font-bold text-red-900">
                {filteredPhieuList.filter(p => p['NGHIEP_VU'] === 'XUAT').length}
              </p>
              {(filterNghiepVu !== 'ALL' || filterCustomer !== 'ALL' || filterDateFrom || filterDateTo) && (
                <p className="text-xs text-red-600 mt-0.5">
                  Tổng: {phieuList.filter(p => p['NGHIEP_VU'] === 'XUAT').length}
                </p>
              )}
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-3 rounded-lg border-l-4 border-blue-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <Package className="w-4 h-4 text-blue-600" />
                <p className="text-xs font-medium text-blue-700">KL Nhập</p>
              </div>
              <p className="text-xl font-bold text-blue-900">
                {filteredPhieuList
                  .filter(p => p['NGHIEP_VU'] === 'NHAP')
                  .reduce((sum, p) => {
                    const chiTietNhap = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU']);
                    return sum + chiTietNhap.reduce((s, ct) => s + (parseFloat(ct['SO_KHOI']) || 0), 0);
                  }, 0)
                  .toFixed(4)} <span className="text-sm font-normal text-blue-700">m³</span>
              </p>
              <p className="text-xs text-blue-600 mt-0.5">
                {filteredPhieuList.filter(p => p['NGHIEP_VU'] === 'NHAP').reduce((sum, p) => {
                  const chiTietNhap = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU']);
                  return sum + chiTietNhap.length;
                }, 0)} kiện
                {(filterNghiepVu !== 'ALL' || filterCustomer !== 'ALL' || filterDateFrom || filterDateTo) && (
                  <span className="ml-1">
                    / {phieuList.filter(p => p['NGHIEP_VU'] === 'NHAP').reduce((sum, p) => {
                      const chiTietNhap = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU']);
                      return sum + chiTietNhap.length;
                    }, 0)}
                  </span>
                )}
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-3 rounded-lg border-l-4 border-orange-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <Package className="w-4 h-4 text-orange-600" />
                <p className="text-xs font-medium text-orange-700">KL Xuất</p>
              </div>
              <p className="text-xl font-bold text-orange-900">
                {filteredPhieuList
                  .filter(p => p['NGHIEP_VU'] === 'XUAT')
                  .reduce((sum, p) => {
                    const chiTietXuat = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU'] && ct['NGHIEP_VU'] === 'XUAT');
                    return sum + chiTietXuat.reduce((s, ct) => s + (parseFloat(ct['SO_KHOI']) || 0), 0);
                  }, 0)
                  .toFixed(4)} <span className="text-sm font-normal text-orange-700">m³</span>
              </p>
              <p className="text-xs text-orange-600 mt-0.5">
                {filteredPhieuList.filter(p => p['NGHIEP_VU'] === 'XUAT').reduce((sum, p) => {
                  const chiTietXuat = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU'] && ct['NGHIEP_VU'] === 'XUAT');
                  return sum + chiTietXuat.length;
                }, 0)} kiện
                {(filterNghiepVu !== 'ALL' || filterCustomer !== 'ALL' || filterDateFrom || filterDateTo) && (
                  <span className="ml-1">
                    / {phieuList.filter(p => p['NGHIEP_VU'] === 'XUAT').reduce((sum, p) => {
                      const chiTietXuat = tonKho.filter(ct => ct['SOPHIEU'] === p['SOPHIEU'] && ct['NGHIEP_VU'] === 'XUAT');
                      return sum + chiTietXuat.length;
                    }, 0)}
                  </span>
                )}
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-3 rounded-lg border-l-4 border-purple-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <Weight className="w-4 h-4 text-purple-600" />
                <p className="text-xs font-medium text-purple-700">KL Tồn</p>
              </div>
              <p className="text-xl font-bold text-purple-900">
                {getTonKhoHienTai().m3.toFixed(4)} <span className="text-sm font-normal text-purple-700">m³</span>
              </p>
              <p className="text-xs text-purple-600 mt-0.5">
                {getTonKhoHienTai().kien} kiện
              </p>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-3 rounded-lg border-l-4 border-yellow-500 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-2 mb-1">
                <DollarSign className="w-4 h-4 text-yellow-600" />
                <p className="text-xs font-medium text-yellow-700">Doanh thu</p>
              </div>
              <p className="text-xl font-bold text-yellow-900">
                {new Intl.NumberFormat('vi-VN', {
                  notation: 'compact',
                  compactDisplay: 'short',
                  maximumFractionDigits: 1
                }).format(
                  filteredPhieuList
                    .filter(p => p['NGHIEP_VU'] === 'XUAT')
                    .reduce((sum, p) => sum + (parseFloat(p['TONGTIEN']) || 0), 0)
                )}
              </p>
              <p className="text-xs text-yellow-600 mt-0.5 truncate" title={formatCurrency(
                filteredPhieuList
                  .filter(p => p['NGHIEP_VU'] === 'XUAT')
                  .reduce((sum, p) => sum + (parseFloat(p['TONGTIEN']) || 0), 0)
              )}>
                {formatCurrency(
                  filteredPhieuList
                    .filter(p => p['NGHIEP_VU'] === 'XUAT')
                    .reduce((sum, p) => sum + (parseFloat(p['TONGTIEN']) || 0), 0)
                )}
              </p>
            </div>
          </div>

          {/* Filters Section - GIỐNG CŨ */}
          {showFilters && (
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 mb-3 animate-fadeIn">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Nghiệp vụ</label>
                  <select
                    value={filterNghiepVu}
                    onChange={(e) => setFilterNghiepVu(e.target.value)}
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option value="ALL">Tất cả</option>
                    <option value="NHAP">Nhập kho</option>
                    <option value="XUAT">Xuất kho</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Khách hàng</label>
                  <select
                    value={filterCustomer}
                    onChange={(e) => setFilterCustomer(e.target.value)}
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option value="ALL">Tất cả</option>
                    {uniqueCustomers.map((customer, index) => (
                      <option key={index} value={customer}>{customer}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Từ ngày</label>
                  <input
                    type="date"
                    value={filterDateFrom}
                    onChange={(e) => setFilterDateFrom(e.target.value)}
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Đến ngày</label>
                  <input
                    type="date"
                    value={filterDateTo}
                    onChange={(e) => setFilterDateTo(e.target.value)}
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div className="flex justify-end mt-2">
                <button
                  onClick={() => {
                    setFilterNghiepVu('ALL');
                    setFilterCustomer('ALL');
                    setFilterDateFrom('');
                    setFilterDateTo('');
                  }}
                  className="px-3 py-1.5 text-xs text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  Xóa bộ lọc
                </button>
              </div>
            </div>
          )}

          {/* Search Bar - GIỐNG CŨ */}
          <div className="relative mb-3">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Tìm kiếm theo số phiếu, khách hàng, người phụ trách..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
          </div>

          {/* Table Section - GIỐNG CŨ, KHÔNG THAY ĐỔI */}
          <div className="overflow-x-auto rounded-lg border border-gray-200">
            {isLoading ? (
              <div className="flex justify-center items-center py-12">
                <div className="relative">
                  <div className="w-12 h-12 border-4 border-purple-200 border-t-purple-500 rounded-full animate-spin"></div>
                  <div className="absolute top-0 left-0 w-12 h-12 border-4 border-transparent border-t-purple-300 rounded-full animate-pulse"></div>
                </div>
              </div>
            ) : currentItems.length === 0 ? (
              <div className="text-center py-12">
                <Package className="w-16 h-16 text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500 text-sm">Không tìm thấy phiếu nào</p>
              </div>
            ) : (
              <table className="w-full text-sm">
                <thead className="bg-gradient-to-r from-purple-50 to-purple-100 border-b border-purple-200">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('SOPHIEU')}>
                      Số phiếu {getSortIcon('SOPHIEU')}
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('NGHIEP_VU')}>
                      Nghiệp vụ {getSortIcon('NGHIEP_VU')}
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('NGAYNHAP_XUAT')}>
                      Ngày {getSortIcon('NGAYNHAP_XUAT')}
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900">
                      Khách hàng/NCC
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900">
                      Kho
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-semibold text-purple-900">
                      Người phụ trách
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-semibold text-purple-900">
                      Số lượng kiện
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('TONGKHOILUONG')}>
                      KL (m³) {getSortIcon('TONGKHOILUONG')}
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('THANHTIEN')}>
                      Thành tiền {getSortIcon('THANHTIEN')}
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-semibold text-purple-900">
                      % VAT
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-semibold text-purple-900">
                      Tiền VAT
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-semibold text-purple-900 cursor-pointer hover:bg-purple-200 transition-colors"
                      onClick={() => requestSort('TONGTIEN')}>
                      Tổng tiền {getSortIcon('TONGTIEN')}
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-semibold text-purple-900">
                      Thao tác
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {currentItems.map((phieu, index) => (
                    <tr key={index} className="hover:bg-purple-50 transition-colors">
                      <td className="px-3 py-2 text-xs font-medium text-gray-900">
                        {phieu['SOPHIEU']}
                      </td>
                      <td className="px-3 py-2">
                        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${phieu['NGHIEP_VU'] === 'NHAP'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                          }`}>
                          {phieu['NGHIEP_VU'] === 'NHAP' ? 'Nhập' : 'Xuất'}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-xs text-gray-700">
                        {formatDate(phieu['NGAYNHAP_XUAT'])}
                      </td>
                      <td className="px-3 py-2 text-xs text-gray-700">
                        {phieu['NCC_KHACHHANG'] || '-'}
                      </td>
                      <td className="px-3 py-2 text-xs text-gray-700">
                        {phieu['NGHIEP_VU'] === 'NHAP' ? phieu['KHONHAP'] : phieu['KHOXUAT']}
                      </td>
                      <td className="px-3 py-2 text-xs text-gray-700">
                        {phieu['NGUOIPHUTRACH'] || '-'}
                      </td>
                      <td className="px-3 py-2 text-center">
                        <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold bg-blue-100 text-blue-800">
                          {getKienCountForPhieu(phieu['SOPHIEU'])}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-xs text-right font-medium text-gray-900">
                        {formatNumber(phieu['TONGKHOILUONG'], 4)}
                      </td>
                      <td className="px-3 py-2 text-xs text-right font-medium text-gray-900">
                        {formatCurrency(phieu['THANHTIEN'])}
                      </td>
                      <td className="px-3 py-2 text-xs text-center text-gray-700">
                        {phieu['PT VAT'] ? `${phieu['PT VAT']}%` : '-'}
                      </td>
                      <td className="px-3 py-2 text-xs text-right text-gray-700">
                        {phieu['TIEN VAT'] ? formatCurrency(phieu['TIEN VAT']) : '-'}
                      </td>
                      <td className="px-3 py-2 text-xs text-right font-medium text-gray-900">
                        {formatCurrency(phieu['TONGTIEN'])}
                      </td>
                      <td className="px-3 py-2">
                        <div className="flex items-center justify-center gap-1">
                          <button
                            onClick={() => handleOpenDetailModal(phieu)}
                            className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                            title="Xem chi tiết">
                            <Eye className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleOpenPrintOptions(phieu)}
                            className="p-1.5 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                            title="In phiếu"
                          >
                            <Printer className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleOpenModal(phieu)}
                            className="p-1.5 text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors"
                            title="Sửa"
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleOpenDeleteConfirmation(phieu)}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            title="Xóa"
                          >
                            <Trash className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination - GIỐNG CŨ */}
          {filteredPhieuList.length > 0 && (
            <div className="flex flex-col sm:flex-row items-center justify-between mt-3 gap-2">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-600">Hiển thị</span>
                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="px-2 py-1 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-xs text-gray-600">
                  / {filteredPhieuList.length} phiếu
                </span>
              </div>

              <div className="flex items-center gap-1">
                <button
                  onClick={goToFirstPage}
                  disabled={currentPage === 1}
                  className="p-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Trang đầu"
                >
                  <ChevronsLeft className="w-4 h-4" />
                </button>
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  className="p-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Trang trước"
                >
                  <ChevronLeft className="w-4 h-4" />
                </button>

                <div className="flex gap-1">
                  {getPageNumbers().map((page, index) => (
                    page === '...' ? (
                      <span key={index} className="px-2 py-1 text-xs text-gray-500">...</span>
                    ) : (
                      <button
                        key={index}
                        onClick={() => goToPage(page)}
                        className={`px-2.5 py-1 text-xs rounded-lg transition-colors ${currentPage === page
                          ? 'bg-purple-500 text-white font-medium'
                          : 'border border-gray-300 hover:bg-gray-50'
                          }`}
                      >
                        {page}
                      </button>
                    )
                  ))}
                </div>

                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="p-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Trang sau"
                >
                  <ChevronRight className="w-4 h-4" />
                </button>
                <button
                  onClick={goToLastPage}
                  disabled={currentPage === totalPages}
                  className="p-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Trang cuối"
                >
                  <ChevronsRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ✅ MODAL TẠO/SỬA PHIẾU - PHẦN XUẤT KHO ĐÃ THAY ĐỔI */}
      {
        showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4 overflow-y-auto">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-8xl max-h-[95vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-purple-50 to-purple-100">
                <h2 className="text-lg md:text-xl font-bold text-purple-900 flex items-center gap-2">
                  <FileText className="w-5 h-5" />
                  {isEditMode ? 'Sửa Phiếu' : 'Tạo Phiếu Mới'}
                </h2>
                <button
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                  className="p-1.5 hover:bg-purple-200 rounded-lg transition-colors disabled:opacity-50"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
                  {/* Left Column - 30% (3/10) - GIỐNG CŨ */}
                  <div className="lg:col-span-3 space-y-3">
                    <div className="bg-purple-50 p-3 rounded-lg border border-purple-200">
                      <h3 className="font-semibold text-purple-900 mb-3 text-sm flex items-center gap-2">
                        <Info className="w-4 h-4" />
                        Thông tin phiếu
                      </h3>

                      <div className="space-y-2.5">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Số phiếu <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            value={currentPhieu['SOPHIEU']}
                            onChange={(e) => handleInputChange('SOPHIEU', e.target.value)}
                            disabled={isSubmitting}
                            className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100 font-medium"
                            placeholder="Tự động tạo"
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Nghiệp vụ <span className="text-red-500">*</span>
                          </label>
                          <select
                            value={currentPhieu['NGHIEP_VU']}
                            onChange={(e) => handleInputChange('NGHIEP_VU', e.target.value)}
                            disabled={isSubmitting || isEditMode}
                            className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                          >
                            <option value="NHAP">Nhập kho</option>
                            <option value="XUAT">Xuất kho</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Ngày nhập/xuất <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            value={currentPhieu['NGAYNHAP_XUAT']}
                            onChange={(e) => handleInputChange('NGAYNHAP_XUAT', e.target.value)}
                            disabled={isSubmitting}
                            className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            {currentPhieu['NGHIEP_VU'] === 'NHAP' ? 'Nhà cung cấp' : 'Khách hàng'} <span className="text-red-500">*</span>
                          </label>
                          <div className="relative" ref={customerDropdownRef}>
                            <input
                              type="text"
                              value={customerSearchTerm}
                              onChange={(e) => handleCustomerInputChange(e.target.value)}
                              onFocus={() => setShowCustomerDropdown(true)}
                              disabled={isSubmitting}
                              className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                              placeholder="Nhập để tìm kiếm..."
                              required
                            />
                            {showCustomerDropdown && filteredCustomers.length > 0 && (
                              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                {filteredCustomers.map((customer, index) => (
                                  <div
                                    key={index}
                                    onClick={() => handleSelectCustomer(customer)}
                                    className="px-3 py-2 hover:bg-purple-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
                                  >
                                    <div className="font-medium text-gray-900">{customer['TEN_KHACHHANG']}</div>
                                    <div className="text-xs text-gray-500">{customer['MA_KH']}</div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>



                        {currentPhieu['NGHIEP_VU'] === 'NHAP' && (
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Kho nhập <span className="text-red-500">*</span>
                            </label>
                            <select
                              value={currentPhieu['KHONHAP']}
                              onChange={(e) => handleInputChange('KHONHAP', e.target.value)}
                              disabled={isSubmitting}
                              className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                            >
                              <option value="">-- Chọn kho --</option>
                              {khoList.map((kho, index) => (
                                <option key={index} value={kho['KHO']}>
                                  {kho['KHO']}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Kho xuất <span className="text-red-500">*</span>
                            </label>
                            <select
                              value={currentPhieu['KHOXUAT']}
                              onChange={(e) => handleInputChange('KHOXUAT', e.target.value)}
                              disabled={isSubmitting}
                              className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                            >
                              <option value="">-- Chọn kho --</option>
                              {khoList.map((kho, index) => (
                                <option key={index} value={kho['KHO']}>
                                  {kho['KHO']}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Người phụ trách
                          </label>
                          <input
                            type="text"
                            value={currentPhieu['NGUOIPHUTRACH']}
                            onChange={(e) => handleInputChange('NGUOIPHUTRACH', e.target.value)}
                            disabled={isSubmitting}
                            className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100"
                            placeholder="Nhập tên người phụ trách"
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Diễn giải
                          </label>
                          <textarea
                            value={currentPhieu['DIENGIAI']}
                            onChange={(e) => handleInputChange('DIENGIAI', e.target.value)}
                            disabled={isSubmitting}
                            rows={3}
                            className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100 resize-none"
                            placeholder="Ghi chú thêm..."
                          />
                        </div>

                        <div className="bg-white p-2.5 rounded-lg border border-purple-300 mt-3">
                          <div className="flex justify-between items-center text-xs mb-1.5">
                            <span className="text-gray-600">Tổng khối lượng:</span>
                            <span className="font-bold text-purple-900">
                              {formatNumber(currentPhieu['TONGKHOILUONG'], 4)} m³
                            </span>
                          </div>
                          {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                            <>
                              <div className="flex justify-between items-center text-xs pt-1.5 border-t border-purple-200 mt-1.5">
                                <span className="text-gray-600">Thành tiền:</span>
                                <span className="font-bold text-gray-900">
                                  {formatCurrency(currentPhieu['THANHTIEN'])}
                                </span>
                              </div>
                              <div className="flex items-center justify-between text-xs pt-1.5 border-t border-purple-200 mt-1.5">
                                <span className="text-gray-600 flex items-center gap-1">
                                  <span>VAT (%):</span>
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    value={currentPhieu['PT VAT']}
                                    onChange={(e) => handleInputChange('PT VAT', e.target.value)}
                                    disabled={isSubmitting}
                                    className="w-12 px-1 py-0.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-purple-500 font-normal"
                                  />
                                </span>
                                <span className="font-bold text-gray-900">
                                  {formatCurrency(currentPhieu['TIEN VAT'])}
                                </span>
                              </div>
                              <div className="flex justify-between items-center text-xs pt-1.5 border-t border-purple-200 mt-1.5">
                                <span className="text-gray-600 font-bold">Tổng tiền:</span>
                                <span className="font-bold text-purple-900 text-sm">
                                  {formatCurrency(currentPhieu['TONGTIEN'])}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - 70% (7/10) */}
                  <div className="lg:col-span-9 space-y-3">
                    <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                      <h3 className="font-semibold text-blue-900 mb-3 text-sm flex items-center gap-2">
                        <Package className="w-4 h-4" />
                        Chi tiết phiếu ({chiTietList.length} kiện)
                      </h3>

                      {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                        // ✅ NHẬP KHO
                        <div className="bg-white p-3 rounded-lg border border-blue-300 mb-3">
                          <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
                            <div className="relative" ref={nhomHangDropdownRef}>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Nhóm hàng {/* ✅ BỎ DẤU SAO */}
                              </label>
                              <input
                                type="text"
                                value={nhomHangSearchTerm}
                                onChange={(e) => handleNhomHangInputChange(e.target.value)}
                                onFocus={() => setShowNhomHangDropdown(true)}
                                disabled={isSubmitting}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                                placeholder="Chọn hoặc để trống..."
                              />
                              {showNhomHangDropdown && filteredNhomHang.length > 0 && (
                                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                  {filteredNhomHang.map((item, index) => (
                                    <div
                                      key={index}
                                      onClick={() => handleSelectNhomHang(item['NHOM_HANG'])}
                                      className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
                                    >
                                      <div className="font-medium text-gray-900">{item['NHOM_HANG']}</div>
                                      <div className="text-xs text-gray-500">
                                        {item['DAY']}x{item['RONG']}x{item['DAI']}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Tiêu chuẩn {/* ✅ BỎ DẤU SAO */}
                              </label>
                              <select
                                value={currentChiTiet['TIEU_CHUAN']}
                                onChange={(e) => setCurrentChiTiet(prev => ({ ...prev, 'TIEU_CHUAN': e.target.value }))}
                                disabled={isSubmitting}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                              >
                                <option value="">-- Chọn hoặc để trống --</option>
                                {tieuChuanList.map((tc, index) => (
                                  <option key={index} value={tc['TIEU_CHUAN']}>
                                    {tc['TIEU_CHUAN']}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Đội hàng khô {/* ✅ BỎ DẤU SAO */}
                              </label>
                              <select
                                value={currentChiTiet['DOI_HANG_KHO']}
                                onChange={(e) => setCurrentChiTiet(prev => ({ ...prev, 'DOI_HANG_KHO': e.target.value }))}
                                disabled={isSubmitting}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                              >
                                <option value="">-- Chọn hoặc để trống --</option>
                                {doiHangKhoList.map((dhk, index) => (
                                  <option key={index} value={dhk['DOI_HANG_KHO']}>
                                    {dhk['DOI_HANG_KHO']}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Số lượng kiện <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="number"
                                value={currentChiTiet['SO_KIEN']}
                                onChange={(e) => setCurrentChiTiet(prev => ({ ...prev, 'SO_KIEN': e.target.value }))}
                                disabled={isSubmitting}
                                min="1"
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                                placeholder="Nhập số lượng kiện"
                              />
                            </div>

                            <div className="flex items-end">
                              <button
                                onClick={handleAddChiTietNhap}
                                disabled={isSubmitting}
                                className="w-full px-3 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center justify-center gap-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
                              >
                                <Plus className="w-4 h-4" />
                                Thêm
                              </button>
                            </div>
                          </div>

                          {selectedNhomHangInfo && (
                            <div className="mt-2 p-2 bg-blue-50 rounded border border-blue-200 text-xs text-blue-800">
                              <strong>Thông tin:</strong> {selectedNhomHangInfo['NHOM_HANG']} -
                              Kích thước: {selectedNhomHangInfo['DAY']}x{selectedNhomHangInfo['RONG']}x{selectedNhomHangInfo['DAI']}
                            </div>
                          )}
                        </div>
                      ) : (

                        // ✅ XUẤT KHO - ĐÃ THAY ĐỔI: CHỌN ĐỘ DÀY VÀ TIÊU CHUẨN
                        <div className="bg-white p-3 rounded-lg border border-blue-300 mb-3">
                          <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-2">
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Độ dày (mm) <span className="text-red-500">*</span>
                              </label>
                              <select
                                value={selectedDay}
                                onChange={(e) => handleSelectDay(e.target.value)}
                                disabled={isSubmitting || !currentPhieu['KHOXUAT']}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                              >
                                <option value="">-- Chọn độ dày --</option>
                                {availableDay.map((day, index) => (
                                  <option key={index} value={day}>
                                    {day} mm
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Tiêu chuẩn <span className="text-red-500">*</span>
                              </label>
                              <select
                                value={selectedTieuChuanXuat}
                                onChange={(e) => handleSelectTieuChuanXuat(e.target.value)}
                                disabled={isSubmitting || !selectedDay}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                              >
                                <option value="">-- Chọn tiêu chuẩn --</option>
                                {tieuChuanList.map((tc, index) => (
                                  <option key={index} value={tc['TIEU_CHUAN']}>
                                    {tc['TIEU_CHUAN']}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Đơn giá
                              </label>
                              <input
                                type="number"
                                value={currentChiTiet['DONGIA']}
                                onChange={(e) => setCurrentChiTiet(prev => ({ ...prev, 'DONGIA': e.target.value }))}
                                disabled={isSubmitting}
                                className="w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                                placeholder="Đơn giá"
                              />
                            </div>

                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Tìm kiếm kiện
                              </label>
                              <div className="relative">
                                <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
                                <input
                                  type="text"
                                  value={kienSearchTerm}
                                  onChange={(e) => setKienSearchTerm(e.target.value)}
                                  disabled={isSubmitting || availableKien.length === 0}
                                  className="w-full pl-8 pr-2.5 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                                  placeholder="Tìm mã kiện..."
                                />
                              </div>
                            </div>
                          </div>

                          {filteredAvailableKien.length > 0 && (
                            <div className="mt-2">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-xs font-medium text-gray-700">
                                  Chọn kiện để xuất ({filteredAvailableKien.length} kiện):
                                </span>
                                <div className="flex items-center gap-2">
                                  {selectedDay && selectedTieuChuanXuat && (
                                    <button
                                      onClick={() => {
                                        setSelectedDay('');
                                        setSelectedTieuChuanXuat('');
                                        setAvailableKien([]);
                                      }}
                                      className="text-xs text-blue-600 hover:text-blue-800 underline"
                                    >
                                      Xóa bộ lọc
                                    </button>
                                  )}
                                  {kienSearchTerm && (
                                    <button
                                      onClick={() => setKienSearchTerm('')}
                                      className="text-xs text-blue-600 hover:text-blue-800 underline"
                                    >
                                      Xóa tìm kiếm
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="max-h-32 overflow-y-auto border border-blue-200 rounded-lg">
                                <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 gap-1 p-2">
                                  {filteredAvailableKien.map((kien, index) => {
                                    const isSelected = isKienSelected(kien['MA_KIEN']);
                                    return (
                                      <button
                                        key={index}
                                        onClick={() => handleSelectKien(kien)}
                                        disabled={isSubmitting || isSelected}
                                        className={`px-2 py-1.5 text-xs rounded transition-colors text-left ${isSelected
                                          ? 'bg-green-100 border-2 border-green-500 text-green-800 cursor-not-allowed opacity-75'
                                          : 'bg-white border border-blue-300 hover:bg-blue-50 hover:border-blue-500'
                                          }`}
                                        title={isSelected ? 'Kiện đã được chọn' : 'Click để chọn kiện'}
                                      >
                                        <div className="font-medium">{kien['MA_KIEN']}</div>
                                        <div className="text-gray-600">{kien['DAY']}x{kien['RONG']}x{kien['DAI']} || {parseFloat(kien['SO_KHOI'] || 0).toFixed(4)} m³
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}

                          {availableKien.length === 0 && currentPhieu['KHOXUAT'] && (
                            <div className="mt-2 p-2 bg-orange-50 rounded border border-orange-200 text-xs text-orange-800 text-center">
                              {selectedDay && selectedTieuChuanXuat
                                ? 'Không có kiện nào phù hợp với độ dày và tiêu chuẩn đã chọn'
                                : 'Chọn độ dày và tiêu chuẩn để hiển thị kiện'}
                            </div>
                          )}
                        </div>
                      )}

                      {/* ✅ Danh sách chi tiết */}
                      <div className="overflow-x-auto rounded-lg border border-blue-300">
                        {chiTietList.length === 0 ? (
                          <div className="text-center py-8 bg-white">
                            <AlertCircle className="w-12 h-12 text-gray-300 mx-auto mb-2" />
                            <p className="text-gray-500 text-sm">Chưa có chi tiết nào</p>
                          </div>
                        ) : (
                          <table className="w-full text-xs bg-white">
                            <thead className="bg-blue-100 border-b border-blue-300">
                              <tr>
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">STT</th>
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">Mã kiện</th>
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">Nhóm hàng</th>
                                <th className="px-2 py-1.5 text-center font-semibold text-blue-900">Dày</th>
                                <th className="px-2 py-1.5 text-center font-semibold text-blue-900">Rộng</th>
                                <th className="px-2 py-1.5 text-center font-semibold text-blue-900">Dài</th>
                                {currentPhieu['NGHIEP_VU'] === 'NHAP' && (
                                  <th className="px-2 py-1.5 text-center font-semibold text-blue-900">Thanh</th>
                                )}
                                <th className="px-2 py-1.5 text-right font-semibold text-blue-900">Số khối</th>
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">Tiêu chuẩn</th>
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">Đội hàng khô</th>
                                {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                                  <>
                                    <th className="px-2 py-1.5 font-semibold text-blue-900">Đơn giá</th>
                                    <th className="px-2 py-1.5 font-semibold text-blue-900">Thành tiền</th>
                                  </>
                                )}
                                <th className="px-2 py-1.5 text-left font-semibold text-blue-900">Ghi chú</th>
                                <th className="px-2 py-1.5 text-center font-semibold text-blue-900">Thao tác</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                              {chiTietList.map((item, index) => (
                                <tr key={index} className="hover:bg-blue-50 transition-colors">
                                  <td className="px-2 py-1.5">{index + 1}</td>

                                  {/* Mã kiện */}
                                  <td className="px-2 py-1.5">
                                    <div>
                                      <input
                                        type="text"
                                        value={item['MA_KIEN']}
                                        onChange={(e) => handleUpdateMaKien(index, e.target.value)}
                                        disabled={isSubmitting}
                                        className={`w-32 px-2 py-1 text-xs border rounded focus:ring-1 focus:border-transparent ${maKienErrors[index]
                                          ? 'border-red-500 focus:ring-red-500 bg-red-50'
                                          : 'border-gray-300 focus:ring-blue-500'
                                          }`}
                                        placeholder="Nhập mã kiện..."
                                      />
                                      {maKienErrors[index] && (
                                        <p className="text-xs text-red-600 mt-0.5 flex items-center gap-1">
                                          <AlertCircle className="w-3 h-3" />
                                          {maKienErrors[index]}
                                        </p>
                                      )}
                                    </div>
                                  </td>

                                  {/* ✅ Nhóm hàng - CÓ THỂ CHỌN HOẶC NHẬP - TỰ ĐỘNG ĐIỀN KÍCH THƯỚC */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <div className="relative">
                                        <input
                                          type="text"
                                          value={item['NHOM_HANG']}
                                          onChange={(e) => handleUpdateChiTietField(index, 'NHOM_HANG', e.target.value)}
                                          disabled={isSubmitting}
                                          className="w-28 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                          placeholder="Chọn hoặc nhập"
                                          list={`nhomhang-list-${index}`}
                                        />
                                        <datalist id={`nhomhang-list-${index}`}>
                                          {dmhh.map((nh, idx) => (
                                            <option key={idx} value={nh['NHOM_HANG']}>
                                              {nh['DAY']}x{nh['RONG']}x{nh['DAI']}
                                            </option>
                                          ))}
                                        </datalist>
                                      </div>
                                    ) : (
                                      <span className="text-gray-700">{item['NHOM_HANG']}</span>
                                    )}
                                  </td>

                                  {/* ✅ Dày - CÓ THỂ NHẬP */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <input
                                        type="number"
                                        value={item['DAY']}
                                        onChange={(e) => handleUpdateChiTietField(index, 'DAY', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-16 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent text-center"
                                        placeholder="Dày"
                                      />
                                    ) : (
                                      <span className="text-gray-700">{item['DAY']}</span>
                                    )}
                                  </td>

                                  {/* ✅ Rộng - CÓ THỂ NHẬP */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <input
                                        type="number"
                                        value={item['RONG']}
                                        onChange={(e) => handleUpdateChiTietField(index, 'RONG', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-16 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent text-center"
                                        placeholder="Rộng"
                                      />
                                    ) : (
                                      <span className="text-gray-700">{item['RONG']}</span>
                                    )}
                                  </td>

                                  {/* ✅ Dài - CÓ THỂ NHẬP */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <input
                                        type="number"
                                        value={item['DAI']}
                                        onChange={(e) => handleUpdateChiTietField(index, 'DAI', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-16 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent text-center"
                                        placeholder="Dài"
                                      />
                                    ) : (
                                      <span className="text-gray-700">{item['DAI']}</span>
                                    )}
                                  </td>

                                  {/* Số thanh */}
                                  {currentPhieu['NGHIEP_VU'] === 'NHAP' && (
                                    <td className="px-2 py-1.5">
                                      <input
                                        type="number"
                                        value={item['THANH']}
                                        onChange={(e) => handleUpdateChiTietField(index, 'THANH', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-16 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent text-center"
                                        min="0"
                                        step="1"
                                      />
                                    </td>
                                  )}

                                  {/* Số khối */}
                                  <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                                    {formatNumber(item['SO_KHOI'], 4)}
                                  </td>

                                  {/* ✅ Tiêu chuẩn - CÓ THỂ CHỌN */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <select
                                        value={item['TIEU_CHUAN'] || ''}
                                        onChange={(e) => handleUpdateChiTietField(index, 'TIEU_CHUAN', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      >
                                        <option value="">-- Chọn --</option>
                                        {tieuChuanList.map((tc, idx) => (
                                          <option key={idx} value={tc['TIEU_CHUAN']}>
                                            {tc['TIEU_CHUAN']}
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <span className="text-gray-700">{item['TIEU_CHUAN'] || '-'}</span>
                                    )}
                                  </td>

                                  {/* Đội hàng khô */}
                                  <td className="px-2 py-1.5">
                                    {currentPhieu['NGHIEP_VU'] === 'NHAP' ? (
                                      <select
                                        value={item['DOI_HANG_KHO'] || ''}
                                        onChange={(e) => handleUpdateChiTietField(index, 'DOI_HANG_KHO', e.target.value)}
                                        disabled={isSubmitting}
                                        className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      >
                                        <option value="">-- Chọn --</option>
                                        {doiHangKhoList.map((dhk, idx) => (
                                          <option key={idx} value={dhk['DOI_HANG_KHO']}>
                                            {dhk['DOI_HANG_KHO']}
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <span className="text-gray-700">{item['DOI_HANG_KHO'] || '-'}</span>
                                    )}
                                  </td>

                                  {/* Đơn giá và thành tiền (chỉ xuất kho) */}
                                  {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                                    <>
                                      <td className="px-2 py-1.5">
                                        <input
                                          type="number"
                                          value={item['DONGIA']}
                                          onChange={(e) => handleUpdateDonGia(index, e.target.value)}
                                          disabled={isSubmitting}
                                          className="w-24 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent text-right"
                                          min="0"
                                        />
                                      </td>
                                      <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                                        {formatCurrency(item['THANHTIEN'])}
                                      </td>
                                    </>
                                  )}

                                  {/* Ghi chú */}
                                  <td className="px-2 py-1.5">
                                    <input
                                      type="text"
                                      value={item['GHICHU'] || ''}
                                      onChange={(e) => handleUpdateChiTietField(index, 'GHICHU', e.target.value)}
                                      disabled={isSubmitting}
                                      className="w-44 px-2 py-1 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      placeholder="Ghi chú"
                                    />
                                  </td>

                                  {/* ✅ Thao tác - THÊM NÚT COPY */}
                                  <td className="px-2 py-1.5 text-center">
                                    <div className="flex items-center justify-center gap-1">
                                      <button
                                        onClick={() => handleCopyChiTiet(index)}
                                        disabled={isSubmitting}
                                        className="p-1 text-green-600 hover:bg-green-50 rounded transition-colors disabled:opacity-50"
                                        title="Copy dòng"
                                      >
                                        <Copy className="w-3.5 h-3.5" />
                                      </button>
                                      <button
                                        onClick={() => handleRemoveChiTiet(index)}
                                        disabled={isSubmitting}
                                        className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors disabled:opacity-50"
                                        title="Xóa"
                                      >
                                        <Minus className="w-3.5 h-3.5" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Hủy
                </button>
                <button
                  onClick={handleSavePhieu}
                  disabled={isSubmitting || chiTietList.length === 0}
                  className="px-4 py-2 text-sm bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Đang lưu...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      {isEditMode ? 'Cập nhật' : 'Lưu phiếu'}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Xem Chi Tiết */}
      {
        showDetailModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4 overflow-y-auto">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-blue-100">
                <h2 className="text-lg md:text-xl font-bold text-blue-900 flex items-center gap-2">
                  <Eye className="w-5 h-5" />
                  Chi Tiết Phiếu - {currentPhieu['SOPHIEU']}
                </h2>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="p-1.5 hover:bg-blue-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                    <h3 className="font-semibold text-blue-900 mb-2 text-sm">Thông tin chung</h3>
                    <div className="space-y-1.5 text-xs">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Số phiếu:</span>
                        <span className="font-medium text-gray-900">{currentPhieu['SOPHIEU']}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Nghiệp vụ:</span>
                        <span className={`font-medium ${currentPhieu['NGHIEP_VU'] === 'NHAP' ? 'text-green-700' : 'text-red-700'}`}>
                          {currentPhieu['NGHIEP_VU'] === 'NHAP' ? 'Nhập kho' : 'Xuất kho'}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Ngày:</span>
                        <span className="font-medium text-gray-900">{formatDate(currentPhieu['NGAYNHAP_XUAT'])}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">{currentPhieu['NGHIEP_VU'] === 'NHAP' ? 'NCC' : 'Khách hàng'}:</span>
                        <span className="font-medium text-gray-900">{currentPhieu['NCC_KHACHHANG'] || '-'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-purple-50 p-3 rounded-lg border border-purple-200">
                    <h3 className="font-semibold text-purple-900 mb-2 text-sm">Thông tin kho</h3>
                    <div className="space-y-1.5 text-xs">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Kho:</span>
                        <span className="font-medium text-gray-900">
                          {currentPhieu['NGHIEP_VU'] === 'NHAP' ? currentPhieu['KHONHAP'] : currentPhieu['KHOXUAT']}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Người phụ trách:</span>
                        <span className="font-medium text-gray-900">{currentPhieu['NGUOIPHUTRACH'] || '-'}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Tổng KL:</span>
                        <span className="font-medium text-gray-900">{formatNumber(currentPhieu['TONGKHOILUONG'], 4)} m³</span>
                      </div>
                      {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Tổng tiền:</span>
                          <span className="font-medium text-gray-900">{formatCurrency(currentPhieu['TONGTIEN'])}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {currentPhieu['DIENGIAI'] && (
                  <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200 mb-4">
                    <h3 className="font-semibold text-yellow-900 mb-1 text-sm">Diễn giải</h3>
                    <p className="text-xs text-gray-700">{currentPhieu['DIENGIAI']}</p>
                  </div>
                )}

                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">Danh sách chi tiết ({chiTietList.length} kiện)</h3>
                  <div className="overflow-x-auto rounded-lg border border-gray-300">
                    <table className="w-full text-xs bg-white">
                      <thead className="bg-gray-100 border-b border-gray-300">
                        <tr>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">STT</th>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Mã kiện</th>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Nhóm hàng</th>
                          <th className="px-2 py-1.5 text-center font-semibold text-gray-900">Kích thước</th>
                          <th className="px-2 py-1.5 text-center font-semibold text-gray-900">Thanh</th>
                          <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Số khối</th>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Tiêu chuẩn</th>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Đội hàng khô</th>
                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Ghi chú</th>
                          {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                            <>
                              <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Đơn giá</th>
                              <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Thành tiền</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {chiTietList.map((item, index) => (
                          <tr key={index} className="hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-1.5">{index + 1}</td>
                            <td className="px-2 py-1.5 font-medium text-gray-900">{item['MA_KIEN']}</td>
                            <td className="px-2 py-1.5 text-gray-700">{item['NHOM_HANG']}</td>
                            <td className="px-2 py-1.5 text-center text-gray-700">
                              {item['DAY']}x{item['RONG']}x{item['DAI']}
                            </td>
                            <td className="px-2 py-1.5 text-center text-gray-700">{item['THANH'] || '-'}</td>
                            <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                              {formatNumber(item['SO_KHOI'], 4)}
                            </td>

                            <td className="px-2 py-1.5 text-gray-700">{item['TIEU_CHUAN']}</td>
                            <td className="px-2 py-1.5 text-gray-700">{item['DOI_HANG_KHO'] || '-'}</td>
                            <td className="px-2 py-1.5 text-gray-700">{item['GHICHU'] || '-'}</td>
                            {currentPhieu['NGHIEP_VU'] === 'XUAT' && (
                              <>
                                <td className="px-2 py-1.5 text-right text-gray-700">
                                  {formatCurrency(item['DONGIA'])}
                                </td>
                                <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                                  {formatCurrency(item['THANHTIEN'])}
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => handleOpenPrintOptions(currentPhieu)}
                  className="px-4 py-2 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600 flex items-center gap-2 transition-colors"
                >
                  <Printer className="w-4 h-4" />
                  In phiếu
                </button>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Quản Lý Tiêu Chuẩn */}
      {
        showTieuChuanModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-blue-100">
                <h2 className="text-lg md:text-xl font-bold text-blue-900 flex items-center gap-2">
                  <Info className="w-5 h-5" />
                  Quản Lý Tiêu Chuẩn
                </h2>
                <button
                  onClick={() => setShowTieuChuanModal(false)}
                  className="p-1.5 hover:bg-blue-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 mb-4">
                  <h3 className="font-semibold text-blue-900 mb-2 text-sm">Thêm tiêu chuẩn mới</h3>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={newTieuChuan}
                      onChange={(e) => setNewTieuChuan(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleAddTieuChuan()}
                      className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Nhập tên tiêu chuẩn..."
                    />
                    <button
                      onClick={handleAddTieuChuan}
                      className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center gap-2 transition-colors font-medium"
                    >
                      <Plus className="w-4 h-4" />
                      Thêm
                    </button>
                  </div>
                </div>

                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">
                    Danh sách tiêu chuẩn ({tieuChuanList.length})
                  </h3>
                  {tieuChuanList.length === 0 ? (
                    <div className="text-center py-8">
                      <Info className="w-12 h-12 text-gray-300 mx-auto mb-2" />
                      <p className="text-gray-500 text-sm">Chưa có tiêu chuẩn nào</p>
                    </div>
                  ) : (
                    <div className="space-y-2 max-h-96 overflow-y-auto">
                      {tieuChuanList.map((tc, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200 hover:border-blue-300 transition-colors"
                        >
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                              <span className="text-xs font-bold text-blue-700">{index + 1}</span>
                            </div>
                            <span className="text-sm font-medium text-gray-900">{tc['TIEU_CHUAN']}</span>
                          </div>
                          <button
                            onClick={() => handleDeleteTieuChuan(tc['ID_TC'])}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            title="Xóa tiêu chuẩn"
                          >
                            <Trash className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => setShowTieuChuanModal(false)}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Xác Nhận Xóa */}
      {
        showDeleteConfirmation && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
              <div className="p-6">
                <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
                  <AlertCircle className="w-6 h-6 text-red-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 text-center mb-2">
                  Xác nhận xóa phiếu
                </h3>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Bạn có chắc chắn muốn xóa phiếu <strong>{phieuToDelete?.['SOPHIEU']}</strong>?
                  <br />
                  Hành động này không thể hoàn tác.
                </p>

                {/* ✅ THÊM LOADING STATE */}
                {isSubmitting && (
                  <div className="mb-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
                    <div className="flex items-center gap-3">
                      <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <div className="text-sm text-blue-700">
                        Đang xóa phiếu và chi tiết...
                      </div>
                    </div>
                  </div>
                )}

                <div className="flex gap-3">
                  <button
                    onClick={handleCloseDeleteConfirmation}
                    disabled={isSubmitting}
                    className="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Hủy
                  </button>
                  <button
                    onClick={handleDeletePhieu}
                    disabled={isSubmitting}
                    className="flex-1 px-4 py-2 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Đang xóa...
                      </>
                    ) : (
                      <>
                        <Trash className="w-4 h-4" />
                        Xóa
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Import Excel */}
      {
        showImportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4 overflow-y-auto">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-orange-50 to-orange-100">
                <h2 className="text-lg md:text-xl font-bold text-orange-900 flex items-center gap-2">
                  <Upload className="w-5 h-5" />
                  Import Dữ Liệu Từ Excel
                </h2>
                <button
                  onClick={handleCloseImportModal}
                  className="p-1.5 hover:bg-orange-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">

                {/* ✅ THÊM NÚT TẢI MẪU EXCEL VÀO ĐÂY */}
                <div className="bg-green-50 p-4 rounded-lg border border-green-200 mb-4">
                  <div className="flex items-start gap-3">
                    <FileSpreadsheet className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                      <h3 className="font-semibold text-green-900 text-sm mb-1">
                        Tải file mẫu Excel
                      </h3>
                      <p className="text-xs text-green-700 mb-3">
                        Tải file mẫu để biết định dạng dữ liệu cần import. File mẫu có 2 sheet:<br />
                        • <strong>Mẫu Nhập Kho</strong>: Số phiếu tự động tạo<br />
                        • <strong>Mẫu Xuất Kho</strong>: Cột "Số phiếu" có thể tự nhập hoặc để trống (tự động)
                      </p>
                      <button
                        onClick={handleExportTemplate}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 flex items-center gap-2 transition-colors text-sm font-medium shadow-sm hover:shadow"
                      >
                        <Download className="w-4 h-4" />
                        Tải file mẫu Excel
                      </button>
                    </div>
                  </div>
                </div>

                {/* Chọn nghiệp vụ */}
                <div className="bg-orange-50 p-3 rounded-lg border border-orange-200 mb-4">
                  <label className="block text-sm font-medium text-orange-900 mb-2">
                    Chọn loại phiếu <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="NHAP"
                        checked={importNghiepVu === 'NHAP'}
                        onChange={(e) => {
                          setImportNghiepVu(e.target.value);
                          setImportPreview([]);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                          }
                        }}
                        className="w-4 h-4 text-orange-600 border-gray-300 focus:ring-2 focus:ring-orange-500"
                      />
                      <span className="ml-2 text-sm font-medium text-gray-900">Nhập kho</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="XUAT"
                        checked={importNghiepVu === 'XUAT'}
                        onChange={(e) => {
                          setImportNghiepVu(e.target.value);
                          setImportPreview([]);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                          }
                        }}
                        className="w-4 h-4 text-orange-600 border-gray-300 focus:ring-2 focus:ring-orange-500"
                      />
                      <span className="ml-2 text-sm font-medium text-gray-900">Xuất kho</span>
                    </label>
                  </div>
                </div>

                {/* Chọn file */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
                  <label className="block text-sm font-medium text-blue-900 mb-2">
                    Chọn file Excel <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center gap-3">
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".xlsx,.xls"
                      onChange={handleFileSelect}
                      className="flex-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-500 file:text-white hover:file:bg-blue-600"
                    />
                    {importFile && (
                      <button
                        onClick={() => {
                          setImportFile(null);
                          setImportPreview([]);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                          }
                        }}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        title="Xóa file"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                  {importFile && (
                    <div className="mt-2 flex items-center gap-2 text-sm text-green-700">
                      <CheckCircle className="w-4 h-4" />
                      <span>Đã chọn: {importFile.name}</span>
                    </div>
                  )}
                </div>

                {/* Preview data - NHÓM THEO PHIẾU */}
                {importPreview.length > 0 && (() => {
                  const validRows = importPreview.filter(r => r.errors.length === 0);

                  // ✅ NHÓM DỮ LIỆU THEO PHIẾU
                  const groupedPreview = {};
                  validRows.forEach(row => {
                    const ngayYYYYMMDD = convertDateDDMMYYYYtoYYYYMMDD(row.ngay);

                    // ✅ LOGIC GROUPING:
                    // - NHẬP KHO: Luôn group theo (ngày + NCC + kho + người phụ trách)
                    // - XUẤT KHO: Nếu có số phiếu thì group theo số phiếu, nếu không thì group theo (ngày + NCC + kho + người phụ trách)
                    let key;
                    if (importNghiepVu === 'XUAT' && row.soPhieu && row.soPhieu !== '') {
                      // XUẤT KHO với số phiếu custom
                      key = `PHIEU_${row.soPhieu}`;
                    } else {
                      // NHẬP KHO hoặc XUẤT KHO không có số phiếu → tự động group
                      key = `AUTO_${ngayYYYYMMDD}_${row.nccKhachHang}_${row.kho}_${row.nguoiPhuTrach}`;
                    }

                    if (!groupedPreview[key]) {
                      groupedPreview[key] = {
                        soPhieuFromExcel: (importNghiepVu === 'XUAT' && row.soPhieu && row.soPhieu !== '') ? row.soPhieu : null, // ✅ Lưu số phiếu từ Excel (chỉ cho xuất kho)
                        ngay: row.ngay,
                        ngayYYYYMMDD: ngayYYYYMMDD,
                        nccKhachHang: row.nccKhachHang,
                        kho: row.kho,
                        nguoiPhuTrach: row.nguoiPhuTrach,
                        chiTiet: []
                      };
                    }

                    groupedPreview[key].chiTiet.push(row);
                  });

                  const phieuCount = Object.keys(groupedPreview).length;
                  const errorRows = importPreview.filter(r => r.errors.length > 0);

                  return (
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="font-semibold text-gray-900 text-sm">
                          Xem trước: {phieuCount} phiếu - {validRows.length} kiện
                        </h3>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-green-600 flex items-center gap-1">
                            <CheckCircle className="w-4 h-4" />
                            {validRows.length} hợp lệ
                          </span>
                          <span className="text-xs text-red-600 flex items-center gap-1">
                            <XCircle className="w-4 h-4" />
                            {errorRows.length} lỗi
                          </span>
                        </div>
                      </div>

                      {/* HIỂN THỊ LỖI NẾU CÓ */}
                      {errorRows.length > 0 && (
                        <div className="mb-4 bg-red-50 p-3 rounded-lg border border-red-200">
                          <h4 className="font-semibold text-red-900 text-xs mb-2">
                            ⚠️ {errorRows.length} dòng có lỗi:
                          </h4>
                          <div className="max-h-32 overflow-y-auto space-y-1">
                            {errorRows.map((row, idx) => (
                              <div key={idx} className="text-xs text-red-700">
                                <strong>Dòng {row.rowIndex}:</strong> {row.errors.join(', ')}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* HIỂN THỊ TỪNG PHIẾU */}
                      <div className="space-y-4 max-h-96 overflow-y-auto">
                        {Object.keys(groupedPreview).map((key, phieuIndex) => {
                          const phieu = groupedPreview[key];
                          // ✅ SỬ DỤNG SỐ PHIẾU TỪ EXCEL HOẶC TỰ ĐỘNG TẠO
                          const soPhieu = phieu.soPhieuFromExcel || generateSoPhieu(importNghiepVu, phieu.ngayYYYYMMDD);
                          const isAutoGenerated = !phieu.soPhieuFromExcel; // ✅ Kiểm tra xem số phiếu có tự động tạo không
                          const tongKhoiLuong = phieu.chiTiet.reduce((sum, item) => sum + (item.soKhoi || 0), 0);
                          const tongTien = phieu.chiTiet.reduce((sum, item) => sum + (item.thanhTien || 0), 0);

                          return (
                            <div key={phieuIndex} className="bg-white rounded-lg border border-blue-300 overflow-hidden">
                              {/* Header phiếu */}
                              <div className="bg-blue-100 px-3 py-2 border-b border-blue-300">
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-bold">
                                      {phieuIndex + 1}
                                    </span>
                                    <div>
                                      <div className="flex items-center gap-2">
                                        <span className="font-semibold text-blue-900 text-sm">
                                          {soPhieu}
                                        </span>
                                        {isAutoGenerated ? (
                                          <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full border border-green-300">
                                            Tự động
                                          </span>
                                        ) : (
                                          <span className="px-2 py-0.5 bg-purple-100 text-purple-700 text-xs rounded-full border border-purple-300">
                                            Từ Excel
                                          </span>
                                        )}
                                      </div>
                                      <div className="text-xs text-blue-700">
                                        {phieu.ngay} - {phieu.nccKhachHang}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-right">
                                    <div className="text-xs text-blue-700">
                                      {phieu.chiTiet.length} kiện
                                    </div>
                                    <div className="text-xs font-semibold text-blue-900">
                                      {tongKhoiLuong.toFixed(4)} m³
                                    </div>
                                    {importNghiepVu === 'XUAT' && (
                                      <div className="text-xs font-semibold text-blue-900">
                                        {formatCurrency(tongTien)}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Chi tiết phiếu */}
                              <div className="overflow-x-auto">
                                <table className="w-full text-xs">
                                  <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                      <th className="px-2 py-1.5 text-left font-semibold text-gray-900">STT</th>
                                      <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Mã kiện</th>
                                      {importNghiepVu === 'NHAP' && (
                                        <>
                                          <th className="px-2 py-1.5 text-left font-semibold text-gray-900">Nhóm hàng</th>
                                          <th className="px-2 py-1.5 text-center font-semibold text-gray-900">Số thanh</th>
                                        </>
                                      )}
                                      <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Số khối</th>
                                      {importNghiepVu === 'XUAT' && (
                                        <>
                                          <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Đơn giá</th>
                                          <th className="px-2 py-1.5 text-right font-semibold text-gray-900">Thành tiền</th>
                                        </>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody className="divide-y divide-gray-100">
                                    {phieu.chiTiet.map((item, idx) => (
                                      <tr key={idx} className="hover:bg-gray-50">
                                        <td className="px-2 py-1.5">{idx + 1}</td>
                                        <td className="px-2 py-1.5 font-medium text-gray-900">{item.maKien}</td>
                                        {importNghiepVu === 'NHAP' && (
                                          <>
                                            <td className="px-2 py-1.5 text-gray-700">{item.nhomHang}</td>
                                            <td className="px-2 py-1.5 text-center text-gray-700">{item.soThanh}</td>
                                          </>
                                        )}
                                        <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                                          {item.soKhoi ? item.soKhoi.toFixed(4) : '0.0000'}
                                        </td>
                                        {importNghiepVu === 'XUAT' && (
                                          <>
                                            <td className="px-2 py-1.5 text-right text-gray-700">
                                              {formatCurrency(item.donGia)}
                                            </td>
                                            <td className="px-2 py-1.5 text-right font-medium text-gray-900">
                                              {formatCurrency(item.thanhTien)}
                                            </td>
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                {/* Hướng dẫn */}
                {importPreview.length === 0 && (
                  <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                    <div className="flex items-start gap-3">
                      <Info className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                      <div className="text-sm text-yellow-800">
                        <p className="font-semibold mb-2">Hướng dẫn import:</p>
                        <ol className="list-decimal list-inside space-y-1">
                          <li>Tải file mẫu Excel bằng nút "Tải file mẫu Excel" ở trên</li>
                          <li>Điền dữ liệu vào file mẫu theo đúng định dạng</li>
                          <li>Chọn loại phiếu (Nhập kho hoặc Xuất kho)</li>
                          <li>Chọn file Excel đã điền dữ liệu</li>
                          <li>Kiểm tra xem trước và nhấn "Import"</li>
                        </ol>
                        <p className="mt-2 text-xs">
                          <strong>Lưu ý:</strong>
                        </p>
                        <ul className="mt-1 text-xs list-disc list-inside space-y-0.5">
                          <li>Nhóm hàng sẽ tự động được tạo từ kích thước (Dày*Rộng*Dài)</li>
                          <li><strong>Nhập Kho</strong>: Số phiếu tự động tạo (không cần nhập)</li>
                          <li><strong>Xuất Kho</strong>: Cột "Số phiếu" có thể tự nhập hoặc để trống (tự động)</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={handleCloseImportModal}
                  disabled={isImporting}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Hủy
                </button>
                <button
                  onClick={handleImportData}
                  disabled={isImporting || importPreview.length === 0 || importPreview.some(r => r.errors.length > 0)}
                  className="px-4 py-2 text-sm bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg hover:from-orange-600 hover:to-orange-700 flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                >
                  {isImporting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Đang import...
                    </>
                  ) : (
                    <>
                      <Upload className="w-4 h-4" />
                      Import dữ liệu
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Quản Lý Đội Hàng Khô */}
      {
        showDoiHangKhoModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-indigo-100">
                <h2 className="text-lg md:text-xl font-bold text-indigo-900 flex items-center gap-2">
                  <Users className="w-5 h-5" />
                  Quản Lý Đội Hàng Khô
                </h2>
                <button
                  onClick={() => setShowDoiHangKhoModal(false)}
                  className="p-1.5 hover:bg-indigo-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                <div className="bg-indigo-50 p-3 rounded-lg border border-indigo-200 mb-4">
                  <h3 className="font-semibold text-indigo-900 mb-2 text-sm">Thêm đội hàng khô mới</h3>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={newDoiHangKho}
                      onChange={(e) => setNewDoiHangKho(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleAddDoiHangKho()}
                      className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      placeholder="Nhập tên đội hàng khô..."
                    />
                    <button
                      onClick={handleAddDoiHangKho}
                      className="px-4 py-2 text-sm bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 flex items-center gap-2 transition-colors font-medium"
                    >
                      <Plus className="w-4 h-4" />
                      Thêm
                    </button>
                  </div>
                </div>

                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">
                    Danh sách đội hàng khô ({doiHangKhoList.length})
                  </h3>
                  {doiHangKhoList.length === 0 ? (
                    <div className="text-center py-8">
                      <Users className="w-12 h-12 text-gray-300 mx-auto mb-2" />
                      <p className="text-gray-500 text-sm">Chưa có đội hàng khô nào</p>
                    </div>
                  ) : (
                    <div className="space-y-2 max-h-96 overflow-y-auto">
                      {doiHangKhoList.map((dhk, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200 hover:border-indigo-300 transition-colors"
                        >
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center">
                              <span className="text-xs font-bold text-indigo-700">{index + 1}</span>
                            </div>
                            <span className="text-sm font-medium text-gray-900">{dhk['DOI_HANG_KHO']}</span>
                          </div>
                          <button
                            onClick={() => handleDeleteDoiHangKho(dhk['ID_DHK'])}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            title="Xóa đội hàng khô"
                          >
                            <Trash className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => setShowDoiHangKhoModal(false)}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }


      {/* Modal Tùy Chọn In Phiếu Xuất */}
      {
        showPrintOptions && phieuToPrint && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
              <div className="p-6">
                <div className="flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mx-auto mb-4">
                  <Printer className="w-6 h-6 text-green-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 text-center mb-2">
                  Tùy chọn in phiếu
                </h3>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Phiếu: <strong>{phieuToPrint['SOPHIEU']}</strong>
                </p>

                {/* Tùy chọn chọn công ty */}
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-4">
                  <label className="block text-sm font-medium text-gray-900 mb-3">
                    Chọn công ty:
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-start cursor-pointer">
                      <input
                        type="radio"
                        name="company"
                        value="HOANG_NGUYEN_LONG"
                        checked={selectedCompany === 'HOANG_NGUYEN_LONG'}
                        onChange={(e) => {
                          setSelectedCompany(e.target.value);
                          setHeaderInfo('Điện thoại: 0919.509.009 - 0985.96.97.98 ( A. Lưỡng )');
                        }}
                        className="w-4 h-4 text-green-600 border-gray-300 focus:ring-2 focus:ring-green-500 mt-0.5"
                      />
                      <span className="ml-3 text-sm text-gray-900">
                        CÔNG TY CP TM SX XD HOÀNG NGUYÊN LONG
                      </span>
                    </label>
                    <label className="flex items-start cursor-pointer">
                      <input
                        type="radio"
                        name="company"
                        value="HOANG_KHOI"
                        checked={selectedCompany === 'HOANG_KHOI'}
                        onChange={(e) => {
                          setSelectedCompany(e.target.value);
                          setHeaderInfo('MST: 3702896657');
                        }}
                        className="w-4 h-4 text-green-600 border-gray-300 focus:ring-2 focus:ring-green-500 mt-0.5"
                      />
                      <div className="ml-3 text-sm text-gray-900">
                        <div>CÔNG TY TNHH GỖ HOÀNG KHÔI</div>
                        <div className="text-xs text-gray-600">MST: 3702896657</div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Input chỉnh sửa thông tin header */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
                  <label className="block text-sm font-medium text-gray-900 mb-2">
                    {selectedCompany === 'HOANG_NGUYEN_LONG' ? 'Điện thoại:' : 'MST:'} (có thể chỉnh sửa)
                  </label>
                  <input
                    type="text"
                    value={headerInfo}
                    onChange={(e) => setHeaderInfo(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder={selectedCompany === 'HOANG_NGUYEN_LONG' ? 'Nhập số điện thoại...' : 'Nhập mã số thuế...'}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Thông tin này sẽ hiển thị trên header của phiếu in
                  </p>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={printWithPrice}
                      onChange={(e) => setPrintWithPrice(e.target.checked)}
                      className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-2 focus:ring-green-500"
                    />
                    <span className="ml-3 text-sm font-medium text-gray-900">
                      Hiển thị đơn giá và thành tiền
                    </span>
                  </label>
                  <p className="ml-8 mt-1 text-xs text-gray-500">
                    {printWithPrice
                      ? '✓ Phiếu sẽ hiển thị cột đơn giá và thành tiền'
                      : '○ Phiếu chỉ hiển thị thông tin hàng hóa'}
                  </p>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setShowPrintOptions(false);
                      setPrintWithPrice(false);
                      setSelectedCompany('HOANG_NGUYEN_LONG'); // Reset về công ty mặc định
                      setHeaderInfo('Điện thoại: 0919.509.009 - 0985.96.97.98 ( A. Lưỡng )'); // Reset về giá trị mặc định
                    }}
                    className="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    Hủy
                  </button>
                  <button
                    onClick={() => handlePrintPhieu(phieuToPrint, printWithPrice, selectedCompany, headerInfo)}
                    className="flex-1 px-4 py-2 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium flex items-center justify-center gap-2"
                  >
                    <Printer className="w-4 h-4" />
                    In phiếu
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Xác Nhận Gửi Yêu Cầu Duyệt */}
      {
        showApprovalConfirm && pendingChanges && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-center w-12 h-12 bg-yellow-100 rounded-full mx-auto mb-4">
                  <AlertCircle className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 text-center mb-2">
                  Xác nhận gửi yêu cầu duyệt
                </h3>
                <p className="text-sm text-gray-600 text-center">
                  Phiếu <strong>{pendingChanges.phieu['SOPHIEU']}</strong> có <strong>{pendingChanges.changes.length}</strong> thay đổi cần được duyệt
                </p>
              </div>

              <div className="flex-1 overflow-y-auto p-6">
                {/* Lý do yêu cầu */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Lý do yêu cầu thay đổi <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={lyDoYeuCau}
                    onChange={(e) => setLyDoYeuCau(e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent resize-none"
                    placeholder="Nhập lý do cần thay đổi phiếu này..."
                  />
                </div>

                <div className="space-y-3">
                  {pendingChanges.changes.map((change, index) => (
                    <div key={index} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        {change.type === 'edit' && (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            <Edit className="w-3 h-3 mr-1" />
                            Sửa
                          </span>
                        )}
                        {change.type === 'add' && (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            <Plus className="w-3 h-3 mr-1" />
                            Thêm mới
                          </span>
                        )}
                        {change.type === 'delete' && (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                            <Trash className="w-3 h-3 mr-1" />
                            Xóa
                          </span>
                        )}
                        <span className="text-sm font-medium text-gray-900">
                          {change.type === 'delete' ? change.oldData['MA_KIEN'] : change.newData['MA_KIEN']}
                        </span>
                      </div>

                      {change.type === 'edit' && (
                        <div className="space-y-1 text-xs">
                          {JSON.parse(createChangeHistory(change.oldData, change.newData)).map((item, idx) => (
                            <div key={idx} className="flex items-start gap-2 text-gray-700">
                              <span className="font-medium min-w-[100px]">{item.field}:</span>
                              <div className="flex-1">
                                <span className="line-through text-red-600">{item.oldValue || '(trống)'}</span>
                                <span className="mx-2">→</span>
                                <span className="text-green-600 font-medium">{item.newValue || '(trống)'}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {change.type === 'add' && (
                        <div className="text-xs text-gray-700">
                          <div><strong>Nhóm hàng:</strong> {change.newData['NHOM_HANG']}</div>
                          <div><strong>Kích thước:</strong> {change.newData['DAY']}x{change.newData['RONG']}x{change.newData['DAI']}</div>
                          <div><strong>Số khối:</strong> {formatNumber(change.newData['SO_KHOI'], 4)} m³</div>
                        </div>
                      )}

                      {change.type === 'delete' && (
                        <div className="text-xs text-red-600">
                          Yêu cầu xóa chi tiết này khỏi phiếu
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mt-4 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                  <div className="flex items-start gap-3">
                    <Info className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                    <div className="text-sm text-yellow-800">
                      <p className="font-semibold mb-1">Lưu ý:</p>
                      <ul className="list-disc list-inside space-y-1">
                        <li>Các thay đổi sẽ được gửi đến admin để phê duyệt</li>
                        <li>Phiếu sẽ không được cập nhật cho đến khi admin duyệt</li>
                        <li>Bạn có thể theo dõi trạng thái yêu cầu trong phần "Yêu cầu duyệt"</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-3 p-6 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => {
                    setShowApprovalConfirm(false);
                    setPendingChanges(null);
                    setLyDoYeuCau('');
                    setIsSubmitting(false);
                  }}
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Hủy
                </button>
                <button
                  onClick={handleConfirmApprovalRequest}
                  disabled={isSubmitting || !lyDoYeuCau.trim()}
                  className="flex-1 px-4 py-2 text-sm bg-gradient-to-r from-yellow-500 to-yellow-600 text-white rounded-lg hover:from-yellow-600 hover:to-yellow-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Đang gửi...
                    </>
                  ) : (
                    <>
                      <CheckCircle className="w-4 h-4" />
                      Gửi yêu cầu duyệt
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Lịch Sử Yêu Cầu Duyệt */}
      {
        showRequestHistoryModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4 overflow-y-auto">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[95vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-yellow-50 to-yellow-100">
                <h2 className="text-lg md:text-xl font-bold text-yellow-900 flex items-center gap-2">
                  <FileText className="w-5 h-5" />
                  Lịch Sử Yêu Cầu Duyệt ({requestHistory.length})
                </h2>
                <button
                  onClick={() => {
                    setShowRequestHistoryModal(false);
                    setFilterRequestStatus('ALL');
                    setFilterRequestType('ALL');
                    setSearchRequest('');
                  }}
                  className="p-1.5 hover:bg-yellow-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                {/* Filters */}
                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 mb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Tìm kiếm</label>
                      <div className="relative">
                        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                        <input
                          type="text"
                          value={searchRequest}
                          onChange={(e) => setSearchRequest(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                          placeholder="Tìm theo số phiếu, mã kiện..."
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Trạng thái</label>
                      <select
                        value={filterRequestStatus}
                        onChange={(e) => setFilterRequestStatus(e.target.value)}
                        className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                      >
                        <option value="ALL">Tất cả</option>
                        <option value="PENDING">Chờ duyệt</option>
                        <option value="APPROVED">Đã duyệt</option>
                        <option value="REJECTED">Từ chối</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Loại yêu cầu</label>
                      <select
                        value={filterRequestType}
                        onChange={(e) => setFilterRequestType(e.target.value)}
                        className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                      >
                        <option value="ALL">Tất cả</option>
                        <option value="ADD">Thêm mới</option>
                        <option value="EDIT">Sửa đổi</option>
                        <option value="DELETE">Xóa</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Statistics */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                  <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
                    <div className="text-xs text-yellow-700 mb-1">Chờ duyệt</div>
                    <div className="text-2xl font-bold text-yellow-900">
                      {requestHistory.filter(r => r['TRANG_THAI_DUYET'] === 'PENDING').length}
                    </div>
                  </div>
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                    <div className="text-xs text-green-700 mb-1">Đã duyệt</div>
                    <div className="text-2xl font-bold text-green-900">
                      {requestHistory.filter(r => r['TRANG_THAI_DUYET'] === 'APPROVED').length}
                    </div>
                  </div>
                  <div className="bg-red-50 p-3 rounded-lg border border-red-200">
                    <div className="text-xs text-red-700 mb-1">Từ chối</div>
                    <div className="text-2xl font-bold text-red-900">
                      {requestHistory.filter(r => r['TRANG_THAI_DUYET'] === 'REJECTED').length}
                    </div>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                    <div className="text-xs text-blue-700 mb-1">Tổng yêu cầu</div>
                    <div className="text-2xl font-bold text-blue-900">
                      {requestHistory.length}
                    </div>
                  </div>
                </div>

                {/* Request List */}
                <div className="overflow-x-auto rounded-lg border border-gray-200">
                  {requestHistory.length === 0 ? (
                    <div className="text-center py-12 bg-white">
                      <FileText className="w-16 h-16 text-gray-300 mx-auto mb-3" />
                      <p className="text-gray-500 text-sm">Chưa có yêu cầu nào</p>
                    </div>
                  ) : (
                    <table className="w-full text-sm bg-white">
                      <thead className="bg-gray-100 border-b border-gray-300">
                        <tr>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Thời gian</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Số phiếu</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Mã kiện</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Loại</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Trạng thái</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900">Lý do</th>
                          <th className="px-3 py-2 text-center text-xs font-semibold text-gray-900">Thao tác</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {requestHistory
                          .filter(req => {
                            const matchStatus = filterRequestStatus === 'ALL' || req['TRANG_THAI_DUYET'] === filterRequestStatus;
                            const matchType = filterRequestType === 'ALL' || req['LOAI_YEU_CAU'] === filterRequestType;
                            const matchSearch = searchRequest === '' ||
                              req['SOPHIEU']?.toLowerCase().includes(searchRequest.toLowerCase()) ||
                              req['MA_KIEN_NEW']?.toLowerCase().includes(searchRequest.toLowerCase()) ||
                              req['MA_KIEN_OLD']?.toLowerCase().includes(searchRequest.toLowerCase());
                            return matchStatus && matchType && matchSearch;
                          })
                          .map((request, index) => (
                            <tr key={index} className="hover:bg-gray-50 transition-colors">
                              <td className="px-3 py-2 text-xs text-gray-700">
                                {new Date(request['THOI_GIAN_YEU_CAU']).toLocaleString('vi-VN')}
                              </td>
                              <td className="px-3 py-2 text-xs font-medium text-gray-900">
                                {request['SOPHIEU']}
                              </td>
                              <td className="px-3 py-2 text-xs text-gray-700">
                                {request['MA_KIEN_NEW'] || request['MA_KIEN_OLD'] || '-'}
                              </td>
                              <td className="px-3 py-2">
                                {getTypeBadge(request['LOAI_YEU_CAU'])}
                              </td>
                              <td className="px-3 py-2">
                                {getStatusBadge(request['TRANG_THAI_DUYET'])}
                              </td>
                              <td className="px-3 py-2 text-xs text-gray-700 max-w-xs truncate" title={request['LY_DO_YEU_CAU']}>
                                {request['LY_DO_YEU_CAU'] || '-'}
                              </td>
                              <td className="px-3 py-2 text-center">
                                <button
                                  onClick={() => handleViewRequestDetail(request)}
                                  className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                  title="Xem chi tiết"
                                >
                                  <Eye className="w-4 h-4" />
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={fetchRequestHistory}
                  className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center gap-2 transition-colors"
                >
                  <RefreshCw className="w-4 h-4" />
                  Làm mới
                </button>
                <button
                  onClick={() => {
                    setShowRequestHistoryModal(false);
                    setFilterRequestStatus('ALL');
                    setFilterRequestType('ALL');
                    setSearchRequest('');
                  }}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Chi Tiết Yêu Cầu */}
      {
        showRequestDetailModal && selectedRequest && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-2 md:p-4 overflow-y-auto">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[95vh] overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-blue-100">
                <h2 className="text-lg md:text-xl font-bold text-blue-900 flex items-center gap-2">
                  <Info className="w-5 h-5" />
                  Chi Tiết Yêu Cầu - {selectedRequest['REQUEST_ID']}
                </h2>
                <button
                  onClick={() => {
                    setShowRequestDetailModal(false);
                    setSelectedRequest(null);
                  }}
                  className="p-1.5 hover:bg-blue-200 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                {/* Thông tin chung */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                    <h3 className="font-semibold text-blue-900 mb-3 text-sm">Thông tin yêu cầu</h3>
                    <div className="space-y-2 text-xs">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Mã yêu cầu:</span>
                        <span className="font-medium text-gray-900">{selectedRequest['REQUEST_ID']}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Số phiếu:</span>
                        <span className="font-medium text-gray-900">{selectedRequest['SOPHIEU']}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Loại yêu cầu:</span>
                        {getTypeBadge(selectedRequest['LOAI_YEU_CAU'])}
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Trạng thái:</span>
                        {getStatusBadge(selectedRequest['TRANG_THAI_DUYET'])}
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Thời gian yêu cầu:</span>
                        <span className="font-medium text-gray-900">
                          {new Date(selectedRequest['THOI_GIAN_YEU_CAU']).toLocaleString('vi-VN')}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                    <h3 className="font-semibold text-purple-900 mb-3 text-sm">Thông tin duyệt</h3>
                    <div className="space-y-2 text-xs">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Người yêu cầu:</span>
                        <span className="font-medium text-gray-900">{selectedRequest['NGUOI_YEU_CAU']}</span>
                      </div>
                      {selectedRequest['NGUOI_DUYET'] && (
                        <>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Người duyệt:</span>
                            <span className="font-medium text-gray-900">{selectedRequest['NGUOI_DUYET']}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thời gian duyệt:</span>
                            <span className="font-medium text-gray-900">
                              {new Date(selectedRequest['THOI_GIAN_DUYET']).toLocaleString('vi-VN')}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Lý do yêu cầu */}
                {selectedRequest['LY_DO_YEU_CAU'] && (
                  <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200 mb-4">
                    <h3 className="font-semibold text-yellow-900 mb-2 text-sm">Lý do yêu cầu</h3>
                    <p className="text-xs text-gray-700">{selectedRequest['LY_DO_YEU_CAU']}</p>
                  </div>
                )}

                {/* Lý do từ chối */}
                {selectedRequest['TRANG_THAI_DUYET'] === 'REJECTED' && selectedRequest['LY_DO_TU_CHOI'] && (
                  <div className="bg-red-50 p-4 rounded-lg border border-red-200 mb-4">
                    <h3 className="font-semibold text-red-900 mb-2 text-sm">Lý do từ chối</h3>
                    <p className="text-xs text-gray-700">{selectedRequest['LY_DO_TU_CHOI']}</p>
                  </div>
                )}

                {/* Ghi chú duyệt */}
                {selectedRequest['GHI_CHU_DUYET'] && (
                  <div className="bg-green-50 p-4 rounded-lg border border-green-200 mb-4">
                    <h3 className="font-semibold text-green-900 mb-2 text-sm">Ghi chú duyệt</h3>
                    <p className="text-xs text-gray-700">{selectedRequest['GHI_CHU_DUYET']}</p>
                  </div>
                )}

                {/* Chi tiết thay đổi */}
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-3 text-sm">Chi tiết thay đổi</h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Dữ liệu cũ */}
                    {selectedRequest['LOAI_YEU_CAU'] !== 'ADD' && (
                      <div className="bg-red-50 p-3 rounded-lg border border-red-200">
                        <h4 className="font-medium text-red-900 mb-2 text-xs flex items-center gap-1">
                          <Minus className="w-3 h-3" />
                          Dữ liệu cũ
                        </h4>
                        <div className="space-y-1 text-xs">
                          <div><strong>Mã kiện:</strong> {selectedRequest['MA_KIEN_OLD']}</div>
                          <div><strong>Nhóm hàng:</strong> {selectedRequest['NHOM_HANG_OLD']}</div>
                          <div><strong>Kích thước:</strong> {selectedRequest['DAY_OLD']}x{selectedRequest['RONG_OLD']}x{selectedRequest['DAI_OLD']}</div>
                          <div><strong>Số thanh:</strong> {selectedRequest['THANH_OLD']}</div>
                          <div><strong>Số khối:</strong> {formatNumber(selectedRequest['SO_KHOI_OLD'], 4)} m³</div>
                          <div><strong>Tiêu chuẩn:</strong> {selectedRequest['TIEU_CHUAN_OLD']}</div>
                          <div><strong>Đội hàng khô:</strong> {selectedRequest['DOI_HANG_KHO_OLD']}</div>
                          <div><strong>Ghi chú:</strong> {selectedRequest['GHICHU_OLD'] || '-'}</div>
                          {selectedRequest['DONGIA_OLD'] > 0 && (
                            <>
                              <div><strong>Đơn giá:</strong> {formatCurrency(selectedRequest['DONGIA_OLD'])}</div>
                              <div><strong>Thành tiền:</strong> {formatCurrency(selectedRequest['THANHTIEN_OLD'])}</div>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Dữ liệu mới */}
                    {selectedRequest['LOAI_YEU_CAU'] !== 'DELETE' && (
                      <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                        <h4 className="font-medium text-green-900 mb-2 text-xs flex items-center gap-1">
                          <Plus className="w-3 h-3" />
                          Dữ liệu mới
                        </h4>
                        <div className="space-y-1 text-xs">
                          <div><strong>Mã kiện:</strong> {selectedRequest['MA_KIEN_NEW']}</div>
                          <div><strong>Nhóm hàng:</strong> {selectedRequest['NHOM_HANG_NEW']}</div>
                          <div><strong>Kích thước:</strong> {selectedRequest['DAY_NEW']}x{selectedRequest['RONG_NEW']}x{selectedRequest['DAI_NEW']}</div>
                          <div><strong>Số thanh:</strong> {selectedRequest['THANH_NEW']}</div>
                          <div><strong>Số khối:</strong> {formatNumber(selectedRequest['SO_KHOI_NEW'], 4)} m³</div>
                          <div><strong>Tiêu chuẩn:</strong> {selectedRequest['TIEU_CHUAN_NEW']}</div>
                          <div><strong>Đội hàng khô:</strong> {selectedRequest['DOI_HANG_KHO_NEW']}</div>
                          <div><strong>Ghi chú:</strong> {selectedRequest['GHICHU_NEW'] || '-'}</div>
                          {selectedRequest['DONGIA_NEW'] > 0 && (
                            <>
                              <div><strong>Đơn giá:</strong> {formatCurrency(selectedRequest['DONGIA_NEW'])}</div>
                              <div><strong>Thành tiền:</strong> {formatCurrency(selectedRequest['THANHTIEN_NEW'])}</div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Lịch sử thay đổi */}
                  {selectedRequest['LICH_SU'] && selectedRequest['LOAI_YEU_CAU'] === 'EDIT' && (
                    <div className="mt-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
                      <h4 className="font-medium text-blue-900 mb-2 text-xs">Các trường đã thay đổi</h4>
                      <div className="space-y-1">
                        {JSON.parse(selectedRequest['LICH_SU']).map((change, idx) => (
                          <div key={idx} className="text-xs text-gray-700 flex items-start gap-2">
                            <span className="font-medium min-w-[100px]">{change.field}:</span>
                            <div className="flex-1">
                              <span className="line-through text-red-600">{change.oldValue || '(trống)'}</span>
                              <span className="mx-2">→</span>
                              <span className="text-green-600 font-medium">{change.newValue || '(trống)'}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-2 p-4 border-t border-gray-200 bg-gray-50">
                <button
                  onClick={() => {
                    setShowRequestDetailModal(false);
                    setSelectedRequest(null);
                  }}
                  className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }


      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div >
  );
};

export default XuatNhapKhoManagement;
